export const battery0 = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs17">
   </defs>
   
<style
   type="text/css"
   id="style2">
	.tem-battery0-styling{fill:inherit;}
</style>
<path
   class="tem-battery0-styling"
   d="M 36.969573,39.5 V 3.7245616 H 36.440745 35.894719 30.486054 V 0.49999984 H 19.518245 V 3.7245616 H 14.10528 13.567853 13.030426 V 39.5 h 0.537427 0.537427 21.789439 0.546026 z M 35.894719,38.425146 H 14.10528 V 4.7994155 h 21.789439 z"
   id="bat-border"
   style="stroke-width:0.429942" />
  `
]
export const battery100 = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs17">
   </defs>
   
<style
   type="text/css"
   id="style2">
	.tem-battery100-styling{fill:inherit;}
</style>
<polygon
   class="e-board-svg-bat-level-100"
   points="163.68,182.17 163.68,145.57 118,145.57 118,182.17 "
   id="bat-level-100"
   transform="matrix(0.42994157,0,0,0.85989071,-35.552971,-119.26029)" />
   <path
   class="tem-battery100-styling"
   d="M 36.969573,39.5 V 3.7245616 H 36.440745 35.894719 30.486054 V 0.49999984 H 19.518245 V 3.7245616 H 14.10528 13.567853 13.030426 V 39.5 h 0.537427 0.537427 21.789439 0.546026 z M 35.894719,38.425146 H 14.10528 V 4.7994155 h 21.789439 z"
   id="bat-border"
   style="stroke-width:0.429942" />
  `
]
export const battery20 = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs17">
	</defs>
   
<style
   type="text/css"
   id="style2">
	.tem-battery20-styling{fill:inherit;}
</style>
<polygon
   class="e-board-svg-bat-level-20"
   points="118,145.57 118,182.17 163.68,182.17 163.68,145.57 "
   id="bat-level-20"
   transform="matrix(0.42994157,0,0,0.17197814,-35.552971,5.9791422)" />
   <path
   class="tem-battery20-styling"
   d="M 36.969573,39.5 V 3.7245616 H 36.440745 35.894719 30.486054 V 0.49999984 H 19.518245 V 3.7245616 H 14.10528 13.567853 13.030426 V 39.5 h 0.537427 0.537427 21.789439 0.546026 z M 35.894719,38.425146 H 14.10528 V 4.7994155 h 21.789439 z"
   id="bat-border"
   style="stroke-width:0.429942" />
  `
]
export const battery40 = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs17">
	</defs>
   
<style
   type="text/css"
   id="style2">
	.tem-battery40-styling{fill:inherit;}
</style>
<polygon
   class="e-board-svg-bat-level-40"
   points="118,145.57 118,182.17 163.68,182.17 163.68,145.57 "
   id="bat-level-40"
   transform="matrix(0.42994157,0,0,0.34395628,-35.552971,-25.355716)" />
   <path
   class="tem-battery40-styling"
   d="M 36.969573,39.5 V 3.7245616 H 36.440745 35.894719 30.486054 V 0.49999984 H 19.518245 V 3.7245616 H 14.10528 13.567853 13.030426 V 39.5 h 0.537427 0.537427 21.789439 0.546026 z M 35.894719,38.425146 H 14.10528 V 4.7994155 h 21.789439 z"
   id="bat-border"
   style="stroke-width:0.429942" />
  `
]
export const battery60 = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs17">
	</defs>
   
<style
   type="text/css"
   id="style2">
	.tem-battery60-styling{fill:inherit;}
</style>
<polygon
   class="e-board-svg-bat-level-60"
   points="163.68,182.17 163.68,145.57 118,145.57 118,182.17 "
   id="bat-level-60"
   transform="matrix(0.42994157,0,0,0.51593443,-35.552971,-56.590575)" />
   <path
   class="tem-battery60-styling"
   d="M 36.969573,39.5 V 3.7245616 H 36.440745 35.894719 30.486054 V 0.49999984 H 19.518245 V 3.7245616 H 14.10528 13.567853 13.030426 V 39.5 h 0.537427 0.537427 21.789439 0.546026 z M 35.894719,38.425146 H 14.10528 V 4.7994155 h 21.789439 z"
   id="bat-border"
   style="stroke-width:0.429942" />
  `
]
export const battery80 = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs17">
   </defs>
   
<style
   type="text/css"
   id="style2">
	.tem-battery80-styling{fill:inherit;}
</style>
<polygon
   class="e-board-svg-bat-level-80"
   points="118,182.17 163.68,182.17 163.68,145.57 118,145.57 "
   id="bat-level-80"
   transform="matrix(0.42994157,0,0,0.68791257,-35.552971,-87.825433)" />
   <path
   class="tem-battery80-styling"
   d="M 36.969573,39.5 V 3.7245616 H 36.440745 35.894719 30.486054 V 0.49999984 H 19.518245 V 3.7245616 H 14.10528 13.567853 13.030426 V 39.5 h 0.537427 0.537427 21.789439 0.546026 z M 35.894719,38.425146 H 14.10528 V 4.7994155 h 21.789439 z"
   id="bat-border"
   style="stroke-width:0.429942" />
  `
]
export const chp = [
  '50 40',
  `
  <defs
     id="defs5" />
  
    
  </sodipodi:namedview>
  <g
     id="g2"
     transform="matrix(0.10938525,0,0,0.10938525,-49.857799,-346.9137)">
    <g
       transform="matrix(5,0,0,5,330,3000)"
       id="g1">
      <path
         style="fill:inherit;fill-opacity:1"
         d="m 25.16,35.71 v 4.03 c 0,0 0,0.01 0,0.01 v 62.23 c 0,0 0,0.01 0,0.01 v 4.03 h 4.03 c 0,0 0,0 0.01,0 h 83.33 c 0,0 0,0 0.01,0 h 4.04 V 35.71 Z M 46.17,91.57 H 30.01 v -4.23 h 16.16 z m 0,-12.39 H 30.01 v -4.23 h 16.16 z m 0,-12.39 H 30.01 v -4.23 h 16.16 z m 0,-12.4 H 30.01 v -4.23 h 16.16 z"
         id="path1" />
    </g>
  </g>
  `
]
export const container = [
  '50 40',
  `
  <defs
     id="defs2" />
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21161124,0,0,0.2456282,51.72743,126.23038)">
      <path
         style="fill:none;stroke: inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
  </g>
  `
]
export const containerAlarm = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21193464,0,0,0.24600356,51.938646,126.37029)"
       style="fill:none;fill-opacity:1;stroke:inherit;stroke-opacity:1">
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
    <circle
       style="fill:#f92224;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="15.267975"
       cy="137.63654"
       r="4.4884591" />
  </g>
  `
]
export const containerOk = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21193464,0,0,0.24600356,51.938646,126.37029)"
       style="fill:none;fill-opacity:1;stroke:inherit;stroke-opacity:1">
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
    <circle
       style="fill:#5ec44e;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="15.267975"
       cy="137.63654"
       r="4.4884591" />
  </g>
  `
]
export const containerWarning = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21193464,0,0,0.24600356,51.938646,126.37029)"
       style="fill:none;fill-opacity:1;stroke:inherit;stroke-opacity:1">
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
    <circle
       style="fill:#fafb5c;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="15.267975"
       cy="137.63654"
       r="4.4884591" />
  </g>
  `
]
export const dashboardCenterIcon = [
  '320 320',
  `
  <defs
     id="defs150">
    <style
       id="style148">
      .mpg-dashboard-center-icon-styling-1, .mpg-dashboard-center-icon-styling-2 {
        fill: #ebf1f3;
      }
      .mpg-dashboard-center-icon-styling-3 {
        fill: #c4794f;
      }
      .mpg-dashboard-center-icon-styling-3, .mpg-dashboard-center-icon-styling-2, .mpg-dashboard-center-icon-styling-4, .mpg-dashboard-center-icon-styling-5, .mpg-dashboard-center-icon-styling-6, .mpg-dashboard-center-icon-styling-7, .mpg-dashboard-center-icon-styling-8, .mpg-dashboard-center-icon-styling-9, .mpg-dashboard-center-icon-styling-10, .mpg-dashboard-center-icon-styling-11, .mpg-dashboard-center-icon-styling-12, .mpg-dashboard-center-icon-styling-13, .mpg-dashboard-center-icon-styling-14, .mpg-dashboard-center-icon-styling-15, .mpg-dashboard-center-icon-styling-16, .mpg-dashboard-center-icon-styling-17, .mpg-dashboard-center-icon-styling-18 {
        fill-rule: evenodd;
      }
      .mpg-dashboard-center-icon-styling-4 {
        fill: #c9e8d9;
      }
      .mpg-dashboard-center-icon-styling-5 {
        fill: #759ac9;
      }
      .mpg-dashboard-center-icon-styling-19 {
        fill: #b2c8de;
      }
      .mpg-dashboard-center-icon-styling-6 {
        fill: #90b0d0;
      }
      .mpg-dashboard-center-icon-styling-7 {
        fill: #406a97;
      }
      .mpg-dashboard-center-icon-styling-8 {
        fill: #33425d;
      }
      .mpg-dashboard-center-icon-styling-9 {
        fill: #495977;
      }
      .mpg-dashboard-center-icon-styling-10 {
        fill: #b3c8dd;
      }
      .mpg-dashboard-center-icon-styling-11 {
        fill: #b5683f;
      }
      .mpg-dashboard-center-icon-styling-12 {
        fill: #59b847;
      }
      .mpg-dashboard-center-icon-styling-13 {
        fill: #5984c0;
      }
      .mpg-dashboard-center-icon-styling-14 {
        fill: #4977b7;
      }
      .mpg-dashboard-center-icon-styling-15 {
        fill: #479b3e;
      }
      .mpg-dashboard-center-icon-styling-16 {
        fill: #9ebbd7;
      }
      .mpg-dashboard-center-icon-styling-17 {
        fill: #dee9f4;
      }
      .mpg-dashboard-center-icon-styling-18 {
        fill: #c6d7e6;
      }
      .mpg-dashboard-center-icon-styling-20 {
        fill: #d4e0ec;
      }
    </style>
  </defs>
  <path
     class="mpg-dashboard-center-icon-styling-10"
     d="m 298.07891,241.95784 c 0,0.98073 -14.58502,1.92071 -40.54755,2.61508 -25.96175,0.69316 -61.17425,1.08292 -97.89009,1.08292 -36.71583,0 -71.927717,-0.38976 -97.890299,-1.08292 -25.961699,-0.69437 -40.547712,-1.63435 -40.547712,-2.61508 0,-0.98049 14.586004,-1.9207 40.547712,-2.61412 25.962582,-0.69312 61.174199,-1.08266 97.890299,-1.08266 36.71611,0 71.92834,0.38954 97.89009,1.08266 25.96253,0.69342 40.54755,1.63363 40.54755,2.61412 z m 0,0"
     id="path152"
     style="stroke-width:0.929932" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 24.505723,238.43187 c 0,0 -9.566315,-4.70703 -7.268973,-8.67276 2.296268,-3.96577 10.84972,-0.0534 10.84972,-0.0534 0,0 -0.368748,-3.99892 1.602604,-4.89072 1.971407,-0.89202 7.20359,3.08323 7.20359,3.08323 0,0 -2.724148,-3.86183 -1.516904,-5.00997 1.207179,-1.14915 4.483963,1.60453 4.483963,1.60453 0,0 -1.817946,-9.41965 1.300616,-11.12712 3.119628,-1.7075 9.108954,4.42967 9.108954,4.42967 0,0 1.93431,-4.41163 4.868912,-2.73635 2.935016,1.67505 0.839681,5.15001 0.839681,5.15001 0,0 4.443053,-3.31591 5.957109,-2.06386 1.515057,1.25107 -0.786145,5.42831 -0.786145,5.42831 0,0 8.19632,-9.02525 12.179154,-5.35025 3.982834,3.67523 -3.342533,9.64651 -3.342533,9.64651 0,0 5.737898,-1.69211 6.645938,-0.0334 0.906974,1.65992 -2.557464,3.94672 -2.557464,3.94672 0,0 13.281704,-2.79661 13.707618,1.96576 0.42586,4.76217 -14.082082,4.68118 -14.082082,4.68118 l -49.193749,0.002 z m 0,0"
     id="path154"
     style="stroke-width:0.91893" />
  <path
     class="mpg-dashboard-center-icon-styling-15"
     d="m 37.950297,238.47477 c 0,0 -5.260706,-2.58902 -3.998198,-4.76994 1.263574,-2.18094 5.967648,-0.0295 5.967648,-0.0295 0,0 -0.202955,-2.19927 0.881309,-2.68903 1.084319,-0.49056 3.960862,1.69526 3.960862,1.69526 0,0 -1.497736,-2.12383 -0.833671,-2.75563 0.664184,-0.63175 2.465984,0.88328 2.465984,0.88328 0,0 -0.999584,-5.18048 0.715516,-6.1201 1.715219,-0.93861 5.008975,2.43632 5.008975,2.43632 0,0 1.063542,-2.42581 2.677513,-1.50452 1.614035,0.92056 0.46224,2.83198 0.46224,2.83198 0,0 2.442937,-1.82383 3.275653,-1.135 0.832835,0.6881 -0.432411,2.98538 -0.432411,2.98538 0,0 4.507726,-4.96335 6.698344,-2.94245 2.189488,2.02093 -1.837951,5.30537 -1.837951,5.30537 0,0 3.154704,-0.93081 3.653995,-0.0171 0.499282,0.91178 -1.40644,2.16943 -1.40644,2.16943 0,0 7.30459,-1.53768 7.538981,1.0816 0.234456,2.61829 -7.744619,2.57462 -7.744619,2.57462 H 37.95027 Z m 0,0"
     id="path156"
     style="stroke-width:0.91893" />
  <path
     class="mpg-dashboard-center-icon-styling-4"
     d="m 42.447539,213.06562 c -0.461946,-0.005 -0.896618,0.0866 -1.287218,0.30003 -3.118563,1.70746 -1.300617,11.12711 -1.300617,11.12711 0,0 -3.275892,-2.75367 -4.483016,-1.60453 -1.207235,1.14815 1.515958,5.00998 1.515958,5.00998 0,0 -5.232174,-3.97526 -7.20359,-3.08323 -1.971353,0.89179 -1.602605,4.89071 -1.602605,4.89071 0,0 -8.553452,-3.91234 -10.849719,0.0534 -1.168235,2.01724 0.732433,4.22306 2.88214,5.90565 -1.904766,-1.61503 -3.402447,-3.61228 -2.335331,-5.45389 2.296387,-3.96576 10.848883,-0.0544 10.848883,-0.0544 0,0 -0.367618,-3.99892 1.603735,-4.89094 1.971407,-0.8918 7.203406,3.08442 7.203406,3.08442 0,0 -2.724148,-3.86282 -1.516969,-5.01094 1.207115,-1.14816 4.484083,1.60548 4.484083,1.60548 0,0 -1.818001,-9.4206 1.300616,-11.1281 1.898931,-1.03957 4.849853,0.82694 6.877417,2.44782 -1.629401,-1.376 -4.126711,-3.17959 -6.137191,-3.1986 v 0 z m 11.152066,1.62356 c -2.010471,0.18952 -3.254996,2.94711 -3.307403,3.06248 0.191524,0.18366 0.524176,0.4954 0.524176,0.4954 0,0 1.934126,-4.41162 4.868967,-2.73754 0.08754,0.0504 0.15609,0.10682 0.235173,0.16001 -0.209562,-0.22005 -0.460991,-0.42689 -0.782331,-0.61058 -0.549722,-0.31369 -1.06515,-0.41371 -1.538582,-0.36978 v 0 z m 17.60059,2.65925 c -2.965092,-0.14097 -6.728899,2.99393 -8.703164,4.86705 -0.367618,1.00059 -0.802281,1.80943 -0.802281,1.80943 0,0 7.628494,-8.39713 11.742763,-5.68832 -0.03805,-0.037 -0.0695,-0.0764 -0.109518,-0.11343 -0.622263,-0.5735 -1.347482,-0.83836 -2.127791,-0.87473 v 0 z m -10.377234,0.52225 c -1.199672,0.0934 -2.775654,0.97935 -3.80186,1.63403 -0.212484,0.67935 -0.496424,1.15475 -0.496424,1.15475 0,0 3.92847,-2.93073 5.655948,-2.238 -0.06664,-0.10294 -0.147626,-0.19635 -0.245649,-0.27732 -0.28394,-0.23443 -0.670855,-0.30884 -1.112015,-0.27345 v 0 z m 13.864599,9.23866 c -1.069073,-0.022 -2.31913,0.19807 -3.272979,0.40783 -0.50214,0.48105 -0.8822,0.80327 -0.8822,0.80327 0,0 4.346703,-1.28061 6.070256,-0.51739 -0.29901,-0.48977 -1.032693,-0.6766 -1.915077,-0.6937 v 0 z m 7.341687,3.86183 c -2.420194,-0.0476 -4.933825,0.29443 -6.480328,0.54981 -0.505898,0.42686 -0.928891,0.71273 -0.928891,0.71273 0,0 9.249909,-1.94481 12.556236,0.181 -0.971768,-1.03472 -2.981467,-1.40061 -5.147017,-1.44354 z m 0,0"
     id="path158"
     style="stroke-width:0.91893" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 261.91538,76.874283 c -19.5816,-0.640927 -20.63786,12.322714 -20.63786,12.322714 0,0 -5.77234,-3.939503 -16.03506,2.524423 -10.26195,6.464185 -7.57192,15.73787 -7.57192,15.73787 0,0 -6.51093,-2.44411 -10.69041,6.23641 -4.17875,8.68054 1.03982,12.47186 1.03982,12.47186 0,0 -4.45989,3.72887 -1.17578,11.8165 3.28309,8.08837 11.0235,6.40466 11.0235,6.40466 0,0 -0.045,6.55773 6.40935,9.24603 6.45563,2.689 10.7032,-0.95194 10.7032,-0.95194 0,0 -0.0824,4.73738 7.79667,5.52571 7.87865,0.78907 10.78619,-5.73608 10.78619,-5.73608 0,0 9.04199,6.29469 17.13528,5.23942 8.09418,-1.05406 9.79995,-5.59158 9.79995,-5.59158 0,0 6.31081,4.70382 12.87251,1.44833 6.56068,-3.25547 3.86671,-9.39025 3.86671,-9.39025 0,0 8.85693,-0.17315 12.17823,-7.13863 3.32142,-6.96525 -2.51981,-12.07389 -2.51981,-12.07389 0,0 4.95537,-5.30164 3.50241,-12.00876 -1.45428,-6.70711 -6.54646,-6.36351 -6.54646,-6.36351 0,0 3.57499,-8.17556 -2.72554,-14.278008 -6.30132,-6.103454 -17.8518,0.629394 -17.8518,0.629394 0,0 -1.77758,-15.430511 -21.35917,-16.070673 v 0 z m 0,0"
     id="path160"
     style="stroke-width:0.922609" />
  <path
     class="mpg-dashboard-center-icon-styling-15"
     d="m 310.65844,115.54595 c -0.0432,5.43165 -3.76249,9.41989 -3.76249,9.41989 0,0 5.84122,5.10864 2.51981,12.07389 -3.3213,6.96548 -12.17823,7.13863 -12.17823,7.13863 0,0 2.69493,6.13478 -3.86671,9.39025 -6.56062,3.25548 -12.87251,-1.44833 -12.87251,-1.44833 0,0 -1.70577,4.53753 -9.79995,5.59256 -8.09329,1.0543 -17.13528,-5.24039 -17.13528,-5.24039 0,0 -2.90754,6.52515 -10.78619,5.73608 -7.87906,-0.78833 -7.79667,-5.52571 -7.79667,-5.52571 0,0 -4.24757,3.64094 -10.7032,0.95194 -6.45438,-2.6883 -6.40935,-9.24603 -6.40935,-9.24603 0,0 -7.74042,1.68371 -11.0235,-6.40393 -1.3594,-3.34902 -1.38414,-5.93885 -0.95563,-7.83757 1.09518,1.77724 2.83652,3.5557 5.61929,4.71433 7.51828,3.13207 12.46594,-1.10892 12.46594,-1.10892 0,0 -0.0954,5.51715 9.07953,6.43553 9.17615,0.91911 12.56172,-6.68042 12.56172,-6.68042 0,0 10.53178,7.33089 19.95775,6.10246 9.42673,-1.22818 11.41267,-6.51292 11.41267,-6.51292 0,0 7.34997,5.47895 14.9916,1.68761 7.64176,-3.79204 4.50401,-10.93631 4.50401,-10.93631 0,0 10.30405,-0.20278 14.17739,-8.30264 z m 0,0"
     id="path162"
     style="stroke-width:0.922609" />
  <path
     class="mpg-dashboard-center-icon-styling-4"
     d="m 260.13327,76.853202 c 0.57572,-0.0076 1.16986,0 1.78211,0.02205 9.77794,0.319592 15.11609,4.326925 18.01079,8.260781 -3.12148,-3.308143 -8.2167,-6.271941 -16.56631,-6.545494 -19.5987,-0.639922 -20.6558,12.333987 -20.6558,12.333987 0,0 -5.77814,-3.943165 -16.04984,2.526657 -10.27134,6.468816 -7.57849,15.752047 -7.57849,15.752047 0,0 -6.5165,-2.44605 -10.69902,6.24107 -2.51017,5.21567 -1.63096,8.65483 -0.52716,10.58146 -0.79964,-0.68304 -4.63586,-4.50471 -0.86876,-12.32905 4.17881,-8.68081 10.68975,-6.23642 10.68975,-6.23642 0,0 -2.69003,-9.274676 7.57192,-15.73886 10.26272,-6.463927 16.03506,-2.523474 16.03506,-2.523474 0,0 0.99121,-12.165722 18.85575,-12.344745 v 0 z m 34.06039,12.903366 c 2.48231,-9.22e-4 4.96296,0.651445 6.93174,2.558016 0.57405,0.555927 1.04011,1.132659 1.45978,1.714308 -6.3098,-6.07846 -17.84815,0.646768 -17.84815,0.646768 0,0 -0.12413,-0.900254 -0.52897,-2.214621 1.74229,-0.879219 5.82131,-2.699821 9.9856,-2.704471 z m -86.23393,36.466342 c 0.70481,1.15373 1.45691,1.70377 1.45691,1.70377 0,0 -4.46389,3.73183 -1.17673,11.82802 0.31193,0.77022 0.6754,1.42533 1.05895,2.029 -0.93261,-0.93259 -1.78779,-2.15612 -2.45469,-3.79891 -3.15304,-7.76509 0.79199,-11.47486 1.11557,-11.76188 v 0 z m 0,0"
     id="path164"
     style="stroke-width:0.922609" />
  <path
     class="mpg-dashboard-center-icon-styling-3"
     d="m 279.93641,141.2907 -16.28337,30.26177 -21.06753,-27.89771 -4.49908,1.03498 18.69421,35.24811 -3.18637,60.74116 h 22.49643 l -5.03625,-67.80041 13.32103,-33.06137 -4.43907,1.47346 z m 0,0"
     id="path166" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 273.09304,200.32217 2.99766,40.35686 h -22.49643 l 1.30947,-24.95713 c 10.34081,-3.70665 15.86233,-8.45782 18.18931,-15.39973 v 0 z m 0,0"
     id="path168" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 284.37444,139.81725 -13.31999,33.06137 c 2.03328,-6.51478 2.19919,-12.94971 0.76309,-16.49895 l 8.11784,-15.08897 4.43907,-1.47346 z m 0,0"
     id="path170" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 242.58648,143.65477 21.06539,27.89771 -3.40295,3.37514 c 0.33077,-0.0985 -8.85701,-16.01084 -19.34635,-30.88504 0.3889,-0.0902 0.96645,-0.22295 1.68391,-0.3878 v 0 z m 0,0"
     id="path172" />
  <rect
     class="mpg-dashboard-center-icon-styling-1"
     x="45.325871"
     y="166.00519"
     width="158.12296"
     height="74.71019"
     id="rect174" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 233.89783,240.67144 c 0,0 -9.87466,-4.85785 -7.50444,-8.95206 2.37054,-4.09293 11.19934,-0.0552 11.19934,-0.0552 0,0 -0.37974,-4.12778 1.65565,-5.04776 2.03459,-0.92032 7.43506,3.18279 7.43506,3.18279 0,0 -2.81173,-3.98778 -1.5655,-5.17227 1.24616,-1.1861 4.62951,1.65696 4.62951,1.65696 0,0 -1.87785,-9.72482 1.34249,-11.48695 3.21859,-1.76213 9.40251,4.57296 9.40251,4.57296 0,0 1.99697,-4.5539 5.02609,-2.82502 3.02871,1.72893 0.866,5.31621 0.866,5.31621 0,0 4.58579,-3.42297 6.1504,-2.13076 1.56333,1.29258 -0.81258,5.60367 -0.81258,5.60367 0,0 8.46061,-9.31645 12.57297,-5.52254 4.1109,3.79361 -3.45129,9.95816 -3.45129,9.95816 0,0 5.92306,-1.74796 6.86006,-0.0345 0.93708,1.71214 -2.63998,4.07223 -2.63998,4.07223 0,0 13.71106,-2.88511 14.15129,2.03057 0.43895,4.91561 -14.53641,4.83217 -14.53641,4.83217 l -50.78117,0.001 z m 0,0"
     id="path176"
     style="stroke-width:1.23779" />
  <path
     class="mpg-dashboard-center-icon-styling-15"
     d="m 247.77607,240.71645 c 0,0 -5.43054,-2.67219 -4.12776,-4.92354 1.30408,-2.25099 6.15923,-0.0296 6.15923,-0.0296 0,0 -0.208,-2.27037 0.91141,-2.77603 1.11917,-0.50697 4.08892,1.7506 4.08892,1.7506 0,0 -1.54648,-2.19351 -0.86104,-2.84538 0.68536,-0.65187 2.54501,0.91146 2.54501,0.91146 0,0 -1.03199,-5.34709 0.7379,-6.31734 1.77126,-0.96894 5.17233,2.51549 5.17233,2.51549 0,0 1.09744,-2.50398 2.76312,-1.55409 1.66625,0.95085 0.47656,2.92354 0.47656,2.92354 0,0 2.52158,-1.88137 3.38182,-1.17163 0.85992,0.71097 -0.4468,3.08287 -0.4468,3.08287 0,0 4.65373,-5.1236 6.91525,-3.03789 2.26017,2.0867 -1.89815,5.47654 -1.89815,5.47654 0,0 3.25741,-0.96141 3.77192,-0.0207 0.51627,0.94198 -1.45159,2.24079 -1.45159,2.24079 0,0 7.54021,-1.58759 7.78183,1.11549 0.24241,2.70408 -7.99336,2.6581 -7.99336,2.6581 l -27.92661,0.001 z m 0,0"
     id="path178"
     style="stroke-width:1.23779" />
  <path
     class="mpg-dashboard-center-icon-styling-4"
     d="m 252.41832,214.48746 c -0.47776,-0.007 -0.92698,0.0888 -1.32837,0.30954 -3.22034,1.76213 -1.34249,11.48695 -1.34249,11.48695 0,0 -3.38335,-2.84307 -4.62951,-1.65696 -1.24503,1.18449 1.5655,5.17096 1.5655,5.17096 0,0 -5.40046,-4.10313 -7.43505,-3.18148 -2.0354,0.91996 -1.65566,5.04776 -1.65566,5.04776 0,0 -8.8288,-4.03776 -11.19934,0.0552 -1.20621,2.08178 0.75595,4.35843 2.97505,6.09617 -1.96602,-1.66714 -3.51257,-3.7295 -2.41033,-5.63028 2.3707,-4.09421 11.19942,-0.0552 11.19942,-0.0552 0,0 -0.37982,-4.12909 1.65446,-5.0491 2.03572,-0.92028 7.43625,3.18282 7.43625,3.18282 0,0 -2.81172,-3.98643 -1.56558,-5.17224 1.24591,-1.18482 4.62782,1.65693 4.62782,1.65693 0,0 -1.87641,-9.72486 1.3425,-11.48691 1.95991,-1.07313 5.00699,0.85454 7.10039,2.52695 -1.68262,-1.42071 -4.25987,-3.2817 -6.33506,-3.30112 v 0 z m 11.51116,1.67637 c -2.07552,0.19517 -3.36009,3.04055 -3.41279,3.1598 0.19661,0.1899 0.54017,0.51225 0.54017,0.51225 0,0 1.9961,-4.55491 5.02617,-2.82502 0.09,0.0512 0.16188,0.10905 0.24273,0.1643 -0.21586,-0.22706 -0.47649,-0.44159 -0.80721,-0.63023 -0.56745,-0.32459 -1.10016,-0.42742 -1.58907,-0.3811 z m 18.16873,2.74416 c -3.06,-0.14524 -6.94629,3.09047 -8.98427,5.02477 -0.37982,1.03297 -0.82799,1.86724 -0.82799,1.86724 0,0 7.87529,-8.66721 12.12239,-5.87181 -0.0397,-0.0384 -0.0734,-0.0782 -0.11301,-0.11672 -0.64301,-0.59303 -1.39127,-0.86506 -2.19712,-0.90353 v 0 z m -10.71195,0.53886 c -1.23869,0.0975 -2.86475,1.0113 -3.92464,1.68785 -0.21947,0.70081 -0.51219,1.19104 -0.51219,1.19104 0,0 4.05444,-3.02508 5.83861,-2.31015 -0.0694,-0.10546 -0.1529,-0.20307 -0.25308,-0.2852 -0.29367,-0.24249 -0.69299,-0.31937 -1.1487,-0.28353 v 0 z m 14.31205,9.53759 c -1.10401,-0.0233 -2.39404,0.20402 -3.3783,0.42088 -0.51859,0.49678 -0.91108,0.82895 -0.91108,0.82895 0,0 4.4868,-1.32178 6.26702,-0.53388 -0.30931,-0.50571 -1.06655,-0.69823 -1.97764,-0.71594 v 0 z m 7.57856,3.98612 c -2.49872,-0.0486 -5.09267,0.30425 -6.68912,0.56743 -0.52253,0.4416 -0.95874,0.7353 -0.95874,0.7353 0,0 9.54859,-2.0072 12.96144,0.18763 -1.00374,-1.06782 -3.07764,-1.4467 -5.31358,-1.49036 z m 0,0"
     id="path180"
     style="stroke-width:1.23779" />
  <rect
     class="mpg-dashboard-center-icon-styling-19"
     x="203.44908"
     y="166.00519"
     width="53.659088"
     height="74.71019"
     id="rect182" />
  <path
     class="mpg-dashboard-center-icon-styling-5"
     d="M 77.914452,116.21868 H 230.31894 L 203.44909,166.0052 H 45.325872 Z m 0,0"
     id="path184" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 230.31999,116.26461 26.79028,49.74801 h -53.66119 l 26.8709,-49.74801 z m 0,0"
     id="path186"
     style="stroke-width:0.999633" />
  <path
     class="mpg-dashboard-center-icon-styling-7"
     d="m 132.63745,143.3904 -0.5701,0.14518 0.17413,0.1752 H 69.513472 c -0.69362,0 -1.2142,0.21473 -1.47861,0.60971 l -7.47088,11.18612 -0.53484,-0.27687 0.57651,0.8067 c 0.13065,0.18447 0.34723,0.37746 0.70288,0.37746 l 0.28327,-0.006 h 63.564328 c 0.69187,0 1.20312,-0.22376 1.44355,-0.63229 l 6.63501,-11.26918 c 0.0528,-0.09 0.0457,-0.19908 -0.0363,-0.31931 l -0.56096,-0.79633 z m 0,0"
     id="path188" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="M 68.970082,142.91655 H 131.8152 c 0.45416,0 1.03599,0.52773 0.87728,0.79633 l -6.63404,11.26894 c -0.24153,0.40957 -0.75168,0.63361 -1.44348,0.63361 H 60.764192 c -0.44074,0 -1.00054,-0.51629 -0.8325,-0.76845 l 7.55992,-11.31855 c 0.26434,-0.39606 0.78486,-0.61188 1.47848,-0.61188 v 0 z m 0,0"
     id="path190" />
  <path
     class="mpg-dashboard-center-icon-styling-13"
     d="m 68.261102,144.04364 -6.97939,10.44871 c -0.10797,0.16192 0.2519,0.49374 0.53601,0.49374 h 62.306968 c 0.55986,0 0.97254,-0.18053 1.16748,-0.51234 l 6.13121,-10.41151 c 0.10239,-0.17308 -0.2718,-0.51205 -0.56303,-0.51205 H 69.456322 c -0.56083,0 -0.98181,0.17413 -1.19521,0.49345 v 0 z m 0,0"
     id="path192" />
  <path
     class="mpg-dashboard-center-icon-styling-14"
     d="m 131.15359,143.64337 -66.690758,11.34272 h 59.661858 c 0.55986,0 0.97254,-0.18053 1.16748,-0.51125 l 6.13219,-10.41259 c 0.0622,-0.10567 -0.0612,-0.29757 -0.27076,-0.41887 v 0 z m 0,0"
     id="path194" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 79.156512,142.91762 -8.48392,12.69674 h 1.35541 l 8.486,-12.69674 z m 13.21119,0 -8.48392,12.69674 h 1.35515 l 8.48496,-12.69674 z m 14.134928,0 -8.483918,12.69674 h 1.36151 l 8.484958,-12.69674 h -1.36254 z m 13.54376,0 -8.48392,12.69674 h 1.36047 l 8.486,-12.69674 h -1.36254 z m 0,0"
     id="path196" />
  <path
     class="mpg-dashboard-center-icon-styling-7"
     d="m 142.80535,125.97058 -0.56938,0.1452 0.17407,0.17413 H 79.682412 c -0.69368,0 -1.21427,0.21477 -1.47861,0.61078 l -7.47205,11.18612 -0.534,-0.27687 0.57548,0.8067 c 0.13084,0.18447 0.34742,0.37641 0.70424,0.37641 l 0.28191,-0.005 H 135.3241 c 0.69251,0 1.20273,-0.22376 1.44348,-0.63255 l 6.63501,-11.26892 c 0.0529,-0.09 0.0457,-0.19908 -0.0364,-0.31933 l -0.56083,-0.79633 z m 0,0"
     id="path198" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 79.137982,125.49675 h 62.846088 c 0.45422,0 1.03475,0.52773 0.87624,0.79633 l -6.6343,11.26894 c -0.24043,0.40957 -0.75175,0.63361 -1.44316,0.63361 H 70.932012 c -0.44061,0 -1.00073,-0.51629 -0.83269,-0.76845 l 7.56005,-11.31963 c 0.26441,-0.39603 0.78499,-0.61079 1.47861,-0.61079 v 0 z m 0,0"
     id="path200" />
  <path
     class="mpg-dashboard-center-icon-styling-13"
     d="m 78.428682,126.62383 -6.97933,10.44871 c -0.10784,0.16192 0.25287,0.49374 0.53614,0.49374 h 62.306778 c 0.56005,0 0.97254,-0.18157 1.16774,-0.51234 l 6.13206,-10.41125 c 0.10162,-0.17334 -0.2716,-0.51231 -0.56407,-0.51231 H 79.624232 c -0.56083,0 -0.98194,0.17413 -1.19554,0.49345 v 0 z m 0,0"
     id="path202" />
  <path
     class="mpg-dashboard-center-icon-styling-14"
     d="m 141.32156,126.22356 -66.689788,11.34272 h 59.660498 c 0.56005,0 0.97254,-0.18053 1.16774,-0.51125 l 6.13206,-10.41233 c 0.0623,-0.10593 -0.0611,-0.29783 -0.2705,-0.41913 v 0 z m 0,0"
     id="path204" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 89.324352,125.49675 -8.48282,12.69781 h 1.35431 l 8.48574,-12.69781 z m 13.211188,0 -8.483858,12.69781 h 1.35509 l 8.484898,-12.69781 z m 14.13492,0 -8.48386,12.69781 h 1.36151 l 8.48457,-12.69781 z m 13.54377,0 -8.48386,12.69781 h 1.36034 l 8.48606,-12.69781 z m 0,0"
     id="path206" />
  <path
     class="mpg-dashboard-center-icon-styling-7"
     d="m 207.78939,143.3904 -0.57023,0.14518 0.17413,0.1752 h -62.72801 c -0.69355,0 -1.21407,0.21473 -1.47848,0.60971 l -7.47172,11.18612 -0.53406,-0.27687 0.57548,0.8067 c 0.13058,0.18447 0.34749,0.37746 0.70392,0.37746 l 0.28223,-0.006 h 63.56459 c 0.69154,0 1.2028,-0.22376 1.44323,-0.63229 l 6.63508,-11.26918 c 0.0528,-0.09 0.0456,-0.19908 -0.036,-0.31931 l -0.56012,-0.79633 z m 0,0"
     id="path208" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="M 144.12221,142.91655 H 206.967 c 0.45416,0 1.03501,0.52773 0.87728,0.79633 l -6.63501,11.26894 c -0.24043,0.40957 -0.75168,0.63361 -1.44323,0.63361 h -63.85077 c -0.4399,0 -1.0008,-0.51629 -0.83282,-0.76845 l 7.56102,-11.31855 c 0.26428,-0.39606 0.78486,-0.61188 1.47874,-0.61188 z m 0,0"
     id="path210" />
  <path
     class="mpg-dashboard-center-icon-styling-13"
     d="m 143.41194,144.04364 -6.97829,10.44871 c -0.10777,0.16192 0.2519,0.49374 0.53484,0.49374 h 62.30814 c 0.55876,0 0.97144,-0.18053 1.16625,-0.51234 l 6.13232,-10.41151 c 0.10175,-0.17308 -0.2718,-0.51205 -0.56401,-0.51205 h -61.40377 c -0.56115,0 -0.98181,0.17413 -1.19547,0.49345 v 0 z m 0,0"
     id="path212" />
  <path
     class="mpg-dashboard-center-icon-styling-14"
     d="m 206.30559,143.64337 -66.69095,11.34272 h 59.66199 c 0.55876,0 0.97144,-0.18053 1.16625,-0.51125 l 6.13232,-10.41259 c 0.0622,-0.10567 -0.0612,-0.29757 -0.26959,-0.41887 v 0 z m 0,0"
     id="path214" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 154.30871,142.91762 -8.48392,12.69674 h 1.35502 l 8.48503,-12.69674 z m 13.20982,0 -8.48392,12.69674 h 1.35541 l 8.48567,-12.69674 z m 14.1359,0 -8.48379,12.69674 h 1.36034 l 8.48606,-12.69674 z m 13.54306,0 -8.48392,12.69674 h 1.36047 l 8.48574,-12.69674 h -1.36228 z m 0,0"
     id="path216" />
  <path
     class="mpg-dashboard-center-icon-styling-7"
     d="m 216.73888,125.97058 -0.57023,0.1452 0.1731,0.17413 h -62.72691 c -0.69362,0 -1.21414,0.21477 -1.47854,0.61078 l -7.47172,11.18612 -0.53406,-0.27687 0.57548,0.8067 c 0.13156,0.18447 0.34716,0.37641 0.70386,0.37641 l 0.28223,-0.005 h 63.56466 c 0.69264,0 1.2028,-0.22376 1.44323,-0.63255 l 6.63508,-11.26892 c 0.0528,-0.09 0.0457,-0.19908 -0.0364,-0.31933 l -0.55979,-0.79633 z m 0,0"
     id="path218" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 153.07137,125.49675 h 62.84512 c 0.45416,0 1.03501,0.52773 0.87728,0.79633 l -6.63508,11.26894 c -0.24043,0.40957 -0.75168,0.63361 -1.44348,0.63361 h -63.85084 c -0.43951,0 -1.00047,-0.51629 -0.83243,-0.76845 l 7.56096,-11.31963 c 0.26441,-0.39603 0.78486,-0.61079 1.47848,-0.61079 v 0 z m 0,0"
     id="path220" />
  <path
     class="mpg-dashboard-center-icon-styling-13"
     d="m 152.36136,126.62383 -6.97823,10.44871 c -0.10803,0.16192 0.2519,0.49374 0.53484,0.49374 h 62.30807 c 0.55876,0 0.9715,-0.18157 1.16631,-0.51234 l 6.13232,-10.41125 c 0.10175,-0.17334 -0.2718,-0.51231 -0.56401,-0.51231 h -61.40377 c -0.56109,0 -0.98207,0.17413 -1.19554,0.49345 v 0 z m 0,0"
     id="path222" />
  <path
     class="mpg-dashboard-center-icon-styling-14"
     d="m 215.25502,126.22356 -66.69089,11.34272 h 59.66192 c 0.55876,0 0.9715,-0.18053 1.16631,-0.51125 l 6.13232,-10.41233 c 0.0621,-0.10593 -0.0612,-0.29783 -0.26966,-0.41913 v 0 z m 0,0"
     id="path224" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 163.25781,125.49675 -8.48354,12.69781 h 1.35502 l 8.48503,-12.69781 h -1.35652 z m 13.21021,0 -8.48399,12.69781 h 1.35548 l 8.48567,-12.69781 z m 14.13597,0 -8.48386,12.69781 h 1.3604 l 8.486,-12.69781 z m 13.54299,0 -8.48392,12.69781 h 1.36047 l 8.48574,-12.69781 h -1.36228 z m 0,0"
     id="path226" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 57.534182,193.06278 h 72.026738 c 0.47172,0 0.92407,0.18661 1.25775,0.52054 0.33291,0.33288 0.52059,0.78598 0.52059,1.25769 V 240.7154 H 55.755982 v -45.87439 c 0,-0.47171 0.18761,-0.92481 0.52162,-1.25769 0.33284,-0.33393 0.78493,-0.52054 1.25658,-0.52054 z m 0,0"
     id="path228" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 70.189532,193.06278 -14.43355,13.62686 v 29.96421 l 43.59001,-43.59107 z m 46.212308,0 -47.652628,47.65262 h 13.1594 l 47.652298,-47.65262 h -13.15908 z m 14.93742,32.58651 -14.13894,14.1381 c -0.15054,0.15133 -0.23013,0.31616 -0.17731,0.36899 l 0.55869,0.55901 h 12.49378 l 1.26268,-1.26299 z m 0,0"
     id="path230" />
  <rect
     class="mpg-dashboard-center-icon-styling-1"
     x="79.820137"
     y="193.06171"
     width="2.00438"
     height="47.653412"
     id="rect232" />
  <rect
     class="mpg-dashboard-center-icon-styling-1"
     x="107.53433"
     y="193.06171"
     width="2.00334"
     height="47.653412"
     id="rect234" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 169.76555,200.9815 h 19.58892 c 0.80567,0 1.46001,0.65434 1.46001,1.45994 v 38.27395 H 168.3056 v -38.27395 c 0,-0.38672 0.1534,-0.75782 0.42701,-1.03178 0.27504,-0.27364 0.64618,-0.42816 1.03294,-0.42816 z m 0,0"
     id="path236" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 222.68643,193.06278 h 20.78135 c 0.49479,0 0.89588,0.40031 0.89588,0.89588 v 46.75674 h -23.30527 v -46.0257 c 0,-0.43136 0.17238,-0.84517 0.4771,-1.15098 0.30601,-0.30473 0.71954,-0.47593 1.15095,-0.47593 v 0 z m 0,0"
     id="path238" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 235.50236,193.06278 -14.44399,14.44497 v 9.84001 l 23.30527,-23.30309 v -0.0871 c -0.001,-0.49451 -0.40212,-0.89482 -0.89698,-0.89482 h -7.96431 z m 8.86129,12.224 -23.30527,23.30524 v 12.12337 h 5.79837 l 17.5069,-17.50609 z m 0,0"
     id="path240" />
  <rect
     class="mpg-dashboard-center-icon-styling-19"
     x="232.71118"
     y="193.06171"
     width="1.40292"
     height="47.653412"
     id="rect242" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 233.57197,149.05901 c 0,4.80912 -2.14576,8.70747 -4.79197,8.70747 -1.2703,0 -2.48925,-0.9174 -3.3885,-2.55041 -0.89829,-1.63299 -1.40322,-3.84766 -1.40322,-6.15706 0,-2.30918 0.50493,-4.52481 1.40322,-6.15781 0.89925,-1.633 2.1182,-2.55042 3.3885,-2.55042 2.64621,0 4.79197,3.89933 4.79197,8.70822 v 0 z m 0,0"
     id="path244"
     style="stroke-width:0.922609" />
  <rect
     class="mpg-dashboard-center-icon-styling-20"
     x="45.325871"
     y="166.00519"
     width="158.12296"
     height="8.8424902"
     id="rect246" />
  <path
     class="mpg-dashboard-center-icon-styling-16"
     d="m 203.44805,166.00599 v 8.8417 h 37.9604 c 7.45455,0 11.70989,0.10991 11.70989,5.29243 v 60.57527 h 3.99094 v -74.7094 z m 0,0"
     id="path248" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 228.78001,140.35079 c -0.17776,0.003 -0.35485,0.0238 -0.53094,0.0629 2.31897,0.0404 4.18922,3.89836 4.18922,8.64429 -9e-4,4.7528 -1.87521,8.6127 -4.19681,8.64331 0.17871,0.0401 0.3588,0.0622 0.53853,0.0651 1.27049,0 2.48914,-0.91643 3.38839,-2.5504 0.89835,-1.633 1.40358,-3.84767 1.40358,-6.15806 0,-2.30917 -0.50523,-4.52478 -1.40358,-6.1578 -0.89925,-1.633 -2.1179,-2.5504 -3.38839,-2.54944 v 0 z m 0,0"
     id="path250"
     style="stroke-width:0.922609" />
  <path
     class="mpg-dashboard-center-icon-styling-2"
     d="m 170.61787,218.96537 h 1.62151 c 0.17122,0 0.30906,0.13805 0.30906,0.30902 v 4.67339 c 0,0.17096 -0.13784,0.30899 -0.30906,0.30899 h -1.62151 c -0.17128,0 -0.30899,-0.13803 -0.30899,-0.30899 v -4.67339 c 0,-0.17097 0.13771,-0.30902 0.30899,-0.30902 z m 0,0"
     id="path252" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 175.65309,200.9815 -7.34866,7.34857 v 20.90694 l 22.51004,-22.50891 v -4.28558 c 0,-0.80669 -0.65434,-1.46102 -1.46098,-1.46102 z m 15.16139,19.62858 -20.10633,20.10532 h 12.65003 l 7.4563,-7.45635 v -12.64896 z m 0,0"
     id="path254" />
  <path
     class="mpg-dashboard-center-icon-styling-18"
     d="m 55.502877,70.264968 c -4.33525,0.0064 -8.16981,2.81319 -9.48666,6.94402 -0.23226,-0.02176 -0.46563,-0.03423 -0.69867,-0.03423 -2.78218,0.0053 -5.32464,1.57089 -6.58544,4.05015 -0.75888,-0.18236 -1.53778,-0.27476 -2.31843,-0.27581 -5.5072,10e-4 -9.97193,4.46506 -9.97193,9.97196 0.01348,0.85419 0.12955,1.70044 0.35248,2.51643 0.46161,1.68715 2.73435,2.88352 4.49085,2.88352 h 49.30952 c 1.75637,0 3.9225,-1.26483 4.23467,-2.98625 0.10162,-0.55984 0.15651,-1.12816 0.16078,-1.70149 0,-5.50694 -4.46506,-9.97169 -9.97193,-9.97169 -0.99328,0.0021 -1.97943,0.15448 -2.92812,0.44885 -1.1074,-2.84608 -3.84681,-4.72093 -6.90156,-4.72199 -0.04348,0.0011 -0.08606,0.0053 -0.12851,0.0082 -1.25684,-4.23038 -5.14396,-7.13169 -9.55704,-7.13276 v 0.0011 z m 0,0"
     id="path256" />
  <path
     class="mpg-dashboard-center-icon-styling-18"
     d="m 213.49539,30.173101 c -4.33525,0.0064 -8.16981,2.81319 -9.48666,6.94402 -0.23226,-0.02176 -0.46563,-0.03423 -0.69867,-0.03423 -2.78218,0.0053 -5.32464,1.57089 -6.58544,4.05015 -0.75888,-0.18236 -1.53777,-0.27476 -2.31842,-0.27581 -5.5072,0.001 -9.97193,4.46506 -9.97193,9.97196 0.0135,0.85419 0.12955,1.70044 0.35248,2.51643 0.46161,1.68715 2.73435,2.88352 4.49085,2.88352 h 49.30951 c 1.75637,0 3.9225,-1.26483 4.23467,-2.98625 0.10162,-0.55984 0.15651,-1.12816 0.16078,-1.70149 0,-5.50694 -4.46506,-9.97169 -9.97193,-9.97169 -0.99328,0.0021 -1.97943,0.15448 -2.92812,0.44885 -1.1074,-2.84608 -3.84681,-4.72093 -6.90156,-4.72199 -0.0435,0.0011 -0.0861,0.0053 -0.12851,0.0082 -1.25684,-4.23038 -5.14396,-7.13169 -9.55704,-7.13276 v 0.0011 z m 0,0"
     id="path256-3"
     style="fill:#c6d7e6;fill-rule:evenodd" />
  <path
     class="mpg-dashboard-center-icon-styling-18"
     d="m 144.71527,65.52324 c -3.73683,0.0064 -7.04141,2.42539 -8.17674,5.98501 -0.20006,-0.0186 -0.40134,-0.02897 -0.6025,-0.02897 -2.3973,0.0051 -4.58929,1.35405 -5.67602,3.49115 -0.65428,-0.15767 -1.32515,-0.23758 -1.99796,-0.23758 -4.74696,0 -8.59481,3.84814 -8.59481,8.59484 0.0124,0.73739 0.11088,1.46523 0.30387,2.16921 0.39713,1.45489 2.35589,2.48561 3.86962,2.48561 h 42.50335 c 1.5138,0 3.38014,-1.09099 3.6498,-2.57375 0.0882,-0.48313 0.13486,-0.97364 0.13881,-1.46711 0,-4.74696 -3.84888,-8.59484 -8.59584,-8.59484 -0.85524,0.0011 -1.70556,0.13272 -2.52367,0.38676 -0.95394,-2.45326 -3.31618,-4.06981 -5.94853,-4.07087 -0.0374,0.0021 -0.0749,0.0064 -0.11101,0.0082 -1.08349,-3.64562 -4.43401,-6.14664 -8.23837,-6.14771 v 0 z m 0,0"
     id="path258" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 192.51394,233.67248 c -0.11419,0.53514 0.2678,0.39363 0.59622,0.49277 8.08442,2.44036 12.26939,7.25824 18.81075,11.97416 4.39775,3.1705 9.00278,5.54769 13.96771,7.71713 0.19587,0.83256 -1.45234,-0.0126 -1.37097,0.86006 1.21446,2.72128 3.71309,2.97599 6.3673,3.13373 -0.0698,0.4158 0.0848,0.36676 0.3997,0.39963 l 0.71481,2.80886 29.06266,-0.0114 c 0.60783,3.57217 -0.1092,6.29703 -1.39894,9.59122 l -4.86906,-0.0272 c -0.61498,-0.20751 -0.50489,-2.43155 -1.42592,-2.57063 l -12.68969,0.10113 c -0.43483,0.59874 -1.77135,2.49674 -2.49909,2.49674 h -16.2877 c 0.57471,-3.77143 -1.1268,-7.99161 -4.10125,-10.38613 -2.01067,-1.61867 -4.31555,-2.22372 -6.89043,-2.00252 0.20039,-3.56072 -0.31757,-7.05668 -0.60055,-10.58954 -0.46828,-0.0309 -0.35256,-0.0648 -0.40069,0.29688 -0.0906,0.68068 0.14374,1.40837 0.20185,2.10017 l -26.57991,-0.59946 c 0.0838,-0.59294 0.19799,-1.19542 0.19876,-1.79736 -0.60423,-0.0988 -0.31878,0.15273 -0.40361,0.48786 -0.0912,0.3604 -0.127,0.74548 -0.19484,1.10968 l -11.49956,-0.19157 -10.68367,-0.8075 c 0.0736,-0.61441 0.16359,-1.49004 0.20142,-2.10032 0.0247,-0.3976 -0.0435,-0.31233 -0.39918,-0.2977 -0.67724,4.09153 -1.13536,8.22902 -1.20119,12.38886 -4.47027,0.31163 -9.19304,4.7024 -9.19304,9.29148 v 3.09717 h -2.19834 c -3.12848,-6.50808 -4.08868,-11.9305 -4.09421,-11.95068 -0.24739,-1.52649 -1.11028,-6.80876 2.10392,-13.71758 0.42307,-0.39683 2.25815,-1.1653 2.97262,-1.62364 7.84141,-5.03036 13.19195,-9.33081 23.10147,-9.87203 6.70355,-0.36612 13.66377,0.14253 20.28265,0.19781 z m -20.58443,1.79835 c -2.79377,0.0664 -5.55264,0.56832 -8.19376,1.49867 l -1.58903,7.62182 0.17958,0.58164 20.6718,0.90029 c 0.36842,-0.099 0.26259,-1.68397 0.3228,-2.01029 0.10594,-0.57415 0.28333,-1.15758 0.39969,-1.79835 0.37729,-2.07759 0.98867,-4.54531 1.1991,-6.59397 0.0138,-0.13453 0.075,-0.42404 -0.11681,-0.40275 z m 13.78958,6.59396 c -0.11133,0.72803 -1.07545,3.90324 -0.27189,4.16821 3.8933,-0.056 7.77839,0.38797 11.66327,0.42758 0.57983,0.40691 1.56251,0.14525 2.30548,0.19257 0.25929,0.0165 0.52259,0.20706 0.59233,0.20706 h 4.39667 c 0.19337,0 0.9206,2.10987 1.89732,1.59962 l 0.2011,-1.19998 c 0.0456,-0.004 0.21991,-0.20311 0.48315,-0.20799 0.70479,-0.013 1.41211,0.0237 2.11488,0.008 0.56522,0.0343 1.25394,0.0602 1.79765,-0.0989 -0.5389,-0.74294 -1.34337,-1.15233 -1.99749,-1.69942 -1.39397,-1.16588 -2.57088,-1.95483 -3.99699,-2.99726 -2.60393,-1.90337 -5.18921,-4.04444 -8.1938,-5.39506 -3.15999,-1.42045 -6.51884,-2.05891 -9.99052,-1.79649 -0.30814,2.26517 -0.65563,4.53228 -1.00116,6.79192 z m -24.58143,0.59945 c 0.30016,-1.42728 0.74407,-2.89869 0.99925,-4.39597 0.0313,-0.18347 0.51625,-0.6779 -0.0942,-0.59702 -0.64391,0.0853 -1.50851,0.59391 -2.10818,0.89269 -1.10581,0.55096 -5.89584,2.91012 -6.00178,4.01055 0.1846,1.27343 2.05985,1.61498 3.13344,1.86269 1.17976,0.27222 2.39519,0.35863 3.58451,0.56742 0.61192,-0.10989 0.40426,-1.947 0.48698,-2.34036 z m 76.74192,24.17985 c -1.50647,0.18468 -3.00756,-0.32645 -4.50094,-0.20115 -0.3022,0.0253 -0.57131,-0.1597 -0.49822,0.30106 0.15569,0.98173 3.06428,0.82105 3.91054,0.70782 0.5356,-0.0717 0.84479,-0.31889 1.08862,-0.80773 z m 21.98256,-0.20078 -4.99436,0.29771 c 1.00554,1.32681 3.17573,0.45495 4.66116,0.70813 z"
     id="path4607"
     style="fill:#e1e7f0;stroke-width:0.358479"
     sodipodi:nodetypes="ccsccccccccccscsccscccscccsccsccccsscccccccsssccsccssscccccssscsssssscscsscsssccccc" />
  <path
     class="mpg-dashboard-center-icon-styling-22"
     d="m 192.51394,233.67248 c 8.6454,0.0722 18.41112,-0.61632 26.88736,-0.008 5.25552,0.37736 9.9632,3.50863 14.06097,6.52244 0.95183,0.70007 3.70273,3.27318 4.42309,3.58386 0.2913,0.12565 1.25105,-0.32766 1.88251,-0.31245 0.9357,0.0225 3.48363,0.59693 3.81949,1.59014 0.39325,1.16295 -0.15899,1.66256 -1.31006,1.61285 -0.075,0.33084 0.10632,0.40539 0.3018,0.59546 4.10515,3.99192 13.82355,5.74643 17.08408,10.39342 -0.36245,-0.12446 -0.75398,0.17391 -0.99925,0.19982 -0.0279,-0.3006 -0.57156,-0.3006 -0.59956,0 -0.79446,0.0373 -1.60329,-0.0335 -2.39819,0 -0.46638,-0.27843 -0.94351,-0.49417 -1.39892,-0.79928 -0.21484,-0.14392 -0.30102,-0.60282 -0.68025,-0.59052 -5.29308,0.42124 -10.69496,0.173 -16.01367,-0.0246 -0.40304,0.0373 -0.42158,0.51587 -0.78801,0.819 -1.05948,0.8764 -3.23104,0.62551 -4.60806,0.60518 -0.3849,-0.006 -1.05433,0.004 -1.29236,-0.01 -2.65417,-0.15774 -5.1528,-0.41245 -6.36726,-3.13373 -0.0814,-0.87269 1.5668,-0.0275 1.37097,-0.86006 -4.96493,-2.16944 -9.56996,-4.54663 -13.96771,-7.71713 -6.54136,-4.71592 -10.72633,-9.5338 -18.81076,-11.97416 -0.32842,-0.0991 -0.71041,0.0423 -0.59621,-0.49278 z m 25.58067,0.79926 c -7.05553,-0.10043 -14.12763,0.0733 -21.18393,0.002 0.97544,0.7546 2.25307,1.15383 3.33167,1.76214 5.43502,3.06524 9.65388,7.76992 14.95444,11.02414 h 25.68061 l -12.00785,-9.07476 c -2.51165,-1.54702 -5.20716,-2.9204 -8.1769,-3.31389 -0.053,-0.19279 -0.23068,-0.18927 -0.39971,-0.19981 -0.33012,-0.0206 -0.66763,0.008 -0.99926,0 -0.21741,-0.33575 -0.82177,-0.19445 -1.19907,-0.19982 z"
     id="path4609"
     style="fill:#f3f6fa;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 159.53887,258.24996 c 0.19701,-0.0137 0.40133,2.3e-4 0.59956,0 6.74583,-0.008 10.5093,6.12845 10.19229,12.38866 h 31.77597 v -3.89643 c 0,-3.80546 4.64184,-7.71639 8.19381,-8.29241 0.16072,-0.026 0.36023,-0.17926 0.59954,-0.19982 2.57488,-0.2212 4.87976,0.38386 6.89043,2.00253 2.97445,2.39451 4.67596,6.6147 4.10125,10.38613 h 16.2877 c 0.72774,0 2.06429,-1.898 2.49909,-2.49674 l 12.68969,-0.10114 c 0.92103,0.13909 0.81094,2.36313 1.42592,2.57064 l 4.86906,0.0273 c -0.0998,0.2548 -0.11818,0.95466 -0.32273,1.01143 -1.95647,-0.0158 -3.91774,-0.0206 -5.8726,-0.0124 -5.79212,0.0244 -11.5946,0.006 -17.38682,0 -3.92707,-0.004 -7.86431,0.0279 -11.79112,0 -1.13014,-0.008 -2.26799,0.007 -3.39816,-2.6e-4 0.82607,-4.9219 -1.33724,-10.22028 -6.19457,-11.98876 -0.72527,-0.26405 -0.72745,-0.32803 -1.59879,-0.39964 -0.066,-0.005 -0.13346,0.003 -0.19985,0 -0.30683,-0.33313 -1.28385,-0.33598 -1.5988,0 -0.0661,0.006 -0.13398,-0.007 -0.19985,0 -0.54556,-0.0157 -1.18664,-0.009 -1.59878,0.39964 -0.0647,0.0112 -0.13517,-0.0112 -0.19985,0 -0.15585,0.027 -0.29139,0.081 -0.39969,0.19982 -4.09847,1.25182 -6.7147,7.64731 -5.59578,11.58938 v 0.19982 h -5.59577 c -5.7793,0 -11.67675,0.20872 -17.38684,0.19981 -2.46423,-0.004 -5.0776,-0.18422 -7.59426,-0.19981 -1.19679,-0.007 -2.40078,0.007 -3.59758,-7.3e-4 0.87247,-4.96826 -1.29985,-10.20838 -6.19503,-11.98809 -0.22955,-0.0835 -0.32148,-0.1325 -0.59954,-0.19982 -0.40972,-0.0992 -0.49425,-0.15613 -0.99925,-0.19981 -0.0659,-0.006 -0.13347,0.003 -0.19985,0 -0.30681,-0.33313 -1.28384,-0.33598 -1.59879,0 -0.0659,0.007 -0.13441,-0.008 -0.19984,0 -0.54557,-0.0157 -1.18665,-0.009 -1.59879,0.39963 -4.81095,1.49377 -7.16498,7.29184 -6.19532,11.98902 -0.88216,-3.5e-4 -1.7742,0.0445 -2.6555,-0.0416 -0.58073,-0.1684 -0.55011,-0.69439 -0.74194,-0.95746 h 2.19835 v -3.09716 c 0,-4.58909 4.72277,-8.97987 9.19304,-9.29149 z"
     id="path4613"
     style="fill:#92a9c6;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-22"
     d="m 254.06741,257.25087 c 0.16285,0.0435 0.68086,0.66652 0.99926,0.79927 1.10547,0.46096 3.7765,0.22365 4.99622,0 0.54546,0.97104 0.81547,1.91725 0.99923,2.99725 l -29.06263,0.0114 -0.71484,-2.80885 c 1.29117,0.13475 3.96238,0.30099 5.07413,-0.22175 1.53357,-0.72109 0.36486,-0.79341 2.41231,-0.76752 1.53429,0.0194 4.26127,-0.26256 5.59958,-0.006 0.63479,0.12181 0.94584,1.088 1.79608,1.00132 l 1.20424,-1.00688 c 0.55145,-0.10364 6.27087,-0.11216 6.69642,0.001 z"
     id="path4617"
     style="fill:#f3f6fa;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-19"
     d="m 253.46785,271.6377 c -0.43598,3.51278 -3.35088,5.71346 -6.39515,6.99359 h -4.19682 c -0.87501,-0.5833 -1.85322,-0.73834 -2.78136,-1.31534 -1.93034,-1.20003 -3.53661,-3.46272 -4.01349,-5.67825 5.79222,0.006 11.5947,0.0244 17.38682,0 z"
     id="path4619"
     style="fill:#1a2331;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 259.66318,257.65051 c 0.0659,0.094 0.26657,0.16262 0.39971,0.39963 -1.21972,0.22365 -3.89075,0.46096 -4.99622,0 0.0966,-0.26113 0.38045,-0.19056 0.59951,-0.19981 0.79493,-0.0335 1.60373,0.0373 2.39823,0 0.19767,-0.009 0.40411,0.0207 0.59952,0 0.24527,-0.0259 0.6368,-0.32428 0.99925,-0.19982 z"
     id="path4629"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-20"
     d="m 165.33449,228.27742 0.79941,-0.59945 c -0.34362,0.58475 -0.47628,0.38486 -0.79941,0.59945 z"
     id="path4631"
     style="fill:#b2ddae;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-19"
     d="m 197.71002,271.6377 c -0.97307,3.40927 -3.41714,6.14388 -6.99471,6.79378 -1.44188,0.26192 -2.14901,0.26308 -3.59728,0 -3.303,-0.60001 -6.17347,-3.26205 -6.79486,-6.59397 5.7101,0.009 11.60755,-0.19981 17.38685,-0.19981 z"
     id="path4667"
     style="fill:#1a2331;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 152.54417,271.6377 c -1.17418,-6.1507 3.79829,-13.45724 10.59044,-10.68866 6.1104,2.49068 6.82168,12.32631 1.60269,16.18602 l -1.80099,1.29642 c -1.5725,0.0202 -2.43937,0.34234 -4.19682,0 -0.4358,-0.0849 -0.79571,-0.23227 -1.1991,-0.39964 -2.55006,-1.05802 -4.47586,-3.6683 -4.99622,-6.39414 z m 12.99017,1.99817 c 1.01618,-1.65697 1.07333,-2.35823 0.99925,-4.19616 -0.0711,-1.76533 0.0268,-1.98925 -0.7994,-3.59671 -0.83428,-1.62327 -1.64377,-2.57568 -3.39743,-3.19707 -5.54905,-1.96623 -9.39364,4.00463 -8.10316,9.00106 1.44699,5.60239 8.10613,7.19797 11.30074,1.98888 z"
     id="path4671"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 204.10519,271.6377 c -0.0279,-0.13345 -0.0152,-2.3517 0.004,-2.69523 0.20503,-3.61837 2.86206,-7.9676 6.70772,-8.47764 9.35134,-1.24023 12.69631,12.69163 4.40844,17.40605 -0.26937,0.15322 -0.63803,0.0645 -0.52842,0.5606 -1.27377,1.2e-4 -2.79601,0.19849 -4.19682,0.19981 -3.25839,-1.17916 -5.14883,-3.32507 -6.04873,-6.6493 -0.0673,-0.24853 -0.34143,-0.32039 -0.34643,-0.34429 z m 13.19001,1.79835 c 0.95349,-1.68055 1.06343,-2.11752 0.99926,-3.99634 -0.0596,-1.74441 -0.0661,-1.84597 -0.79941,-3.39689 -0.79155,-1.67409 -1.57953,-2.72549 -3.39742,-3.39689 -3.85174,-1.42254 -7.266,1.18685 -8.13424,4.95505 -1.76959,7.68006 7.22138,13.07994 11.33181,5.83507 z"
     id="path4673"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-19"
     d="m 212.89854,259.24904 c 0.0664,0.003 0.13382,-0.005 0.19984,0 l 1.59879,0.39964 c 4.85734,1.76848 7.02065,7.06686 6.19458,11.98876 1.13017,0.007 2.26802,-0.008 3.39816,2.6e-4 -0.36224,3.13164 -2.91766,6.05313 -5.99545,6.79378 h -3.59728 c -0.10962,-0.49608 0.25904,-0.40738 0.5284,-0.5606 8.28787,-4.71442 4.9429,-18.64628 -4.40843,-17.40606 -3.84566,0.51004 -6.50269,4.85928 -6.70772,8.47765 -0.0195,0.34352 -0.0322,2.56178 -0.004,2.69523 h -0.59956 l -0.19985,-0.19983 c -1.11892,-3.94207 1.4973,-10.33754 5.59577,-11.58938 0.14648,-0.0447 0.32213,0.006 0.39969,-0.19981 0.0647,-0.0112 0.13518,0.0112 0.19986,0 0.4961,-0.0859 1.27744,-0.36643 1.59879,-0.39964 0.0659,-0.007 0.13375,0.006 0.19985,0 0.47983,-0.0431 1.10847,-0.0246 1.59879,0 z"
     id="path4679"
     style="fill:#1a2331;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-19"
     d="m 161.13766,259.24904 c 0.0663,0.003 0.13395,-0.006 0.19986,0 0.17186,0.35207 0.70068,0.14945 0.99924,0.19982 0.0957,0.0162 0.35495,0.29832 0.59955,0.19982 4.89518,1.77971 7.06749,7.01982 6.19502,11.98809 1.1968,0.007 2.4008,-0.007 3.59758,7.2e-4 -0.79971,3.09205 -2.92384,6.1067 -6.19532,6.79378 -1.19503,-0.0121 -2.40235,-0.0154 -3.59728,0 l 1.80099,-1.29642 c 5.21898,-3.8597 4.50771,-13.69533 -1.60269,-16.18602 -6.79215,-2.76858 -11.76463,4.53795 -10.59044,10.68866 -0.33306,-9e-5 -0.66619,1.4e-4 -0.99925,0 -0.96966,-4.69718 1.38436,-10.49525 6.19531,-11.98901 0.29084,-0.0903 1.35883,-0.36911 1.59879,-0.39964 0.0655,-0.008 0.13393,0.007 0.19985,0 0.46961,-0.0485 1.11353,-0.023 1.59879,0 z"
     id="path4681"
     style="fill:#1a2331;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 196.71077,237.06936 c 3.00459,1.35061 5.58987,3.49169 8.1938,5.39506 -0.20737,0.33087 -0.75832,0.19974 -1.0963,0.20329 -5.91907,0.0623 -11.77988,0.24495 -17.68949,-0.20329 l 1.22677,-6.76678 c 2.92854,-0.24276 5.75471,0.37519 8.49287,1.34527 0.2556,0.0906 0.67908,0.44898 0.87235,0.0265 z"
     id="path4711"
     style="fill:#92a9c6;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 174.32769,235.67064 c 3.51834,-0.12848 7.07109,0.0954 10.59199,0 -0.21042,2.04866 -0.8218,4.51638 -1.19909,6.59396 -6.23717,-0.87288 -12.79894,-1.73304 -18.18625,-5.19524 3.03914,-0.97304 5.5746,-1.28118 8.79335,-1.39872 z"
     id="path4713"
     style="fill:#92a9c6;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 165.53434,237.06936 c 5.38731,3.4622 11.94908,4.32236 18.18625,5.19524 -0.11636,0.64078 -0.29375,1.22421 -0.39969,1.79835 l -20.18572,-1.19799 c -0.18714,-0.19017 0.66156,-4.90816 0.83934,-5.25711 0.31171,-0.61183 1.10934,-0.39426 1.55982,-0.53849 z"
     id="path4715"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 210.10065,250.05747 c 0.0675,0.80394 0.14721,1.58699 0.19985,2.3978 l -27.17945,-0.59945 c 0.10891,-0.80332 0.28783,-1.60577 0.39969,-2.39781 z"
     id="path4717"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 183.12105,249.2582 c -0.16134,0.86628 -0.27035,1.72734 -0.3997,2.59762 l -13.69789,-0.39139 -8.48534,-0.80752 c 0.0831,-0.83579 0.30503,-1.60746 0.3997,-2.3978 l 10.68367,0.80751 z"
     id="path4721"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 171.92951,235.47083 c 0.74025,-0.0176 1.81442,-0.15312 2.39818,0.19981 -3.21875,0.11754 -5.75421,0.42568 -8.79335,1.39872 -0.45048,0.14423 -1.24811,-0.0733 -1.55982,0.53849 -0.17778,0.34895 -1.02648,5.06694 -0.83934,5.25711 l 20.18572,1.19799 c -0.0602,0.32633 0.0456,1.91126 -0.3228,2.0103 l -20.6718,-0.90029 -0.17958,-0.58165 1.58903,-7.62181 c 2.64112,-0.93035 5.39999,-1.43226 8.19376,-1.49868 z"
     id="path4723"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 204.90457,242.46442 c 1.42611,1.04242 2.60302,1.83139 3.99699,2.99725 h -2.59804 c -0.30317,-1.10839 -0.80448,-2.12263 -2.10144,-2.21084 -1.10951,-0.0755 -3.91659,1.05285 -4.49357,2.01103 l -13.98876,-1.00041 c 0.17303,-0.60976 0.24007,-1.15839 0.19919,-1.79703 h 0.19984 c 5.90961,0.44824 11.77042,0.26556 17.68949,0.2033 0.33798,-0.004 0.88893,0.12757 1.0963,-0.2033 z"
     id="path4725"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 185.91893,242.46442 c 0.0409,0.63864 -0.0262,1.18727 -0.19918,1.79703 l 13.98875,1.00041 c -0.11162,0.18537 -0.32402,0.93447 0,0.99909 -0.0177,0.0116 0.0799,0.34626 -0.13112,0.40271 -0.44885,0.12007 -1.86175,0.003 -2.46692,-0.003 -3.88487,-0.0396 -7.76997,-0.4836 -11.66326,-0.42758 -0.80357,-0.26495 0.16055,-3.44017 0.27188,-4.16821 0.19209,0.054 0.189,0.23031 0.19985,0.39964 z"
     id="path4727"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 161.13766,242.66424 c -0.0827,0.39336 0.12495,2.23047 -0.48698,2.34036 -1.18931,-0.20879 -2.40475,-0.2952 -3.58451,-0.56742 -1.07358,-0.24771 -2.94884,-0.58926 -3.13344,-1.86269 0.10594,-1.10043 4.89598,-3.45959 6.00179,-4.01055 0.59966,-0.29878 1.46427,-0.80737 2.10817,-0.89269 0.61047,-0.0809 0.12548,0.41355 0.0942,0.59702 -0.87979,0.3322 -5.82366,2.59042 -5.97098,3.12631 -0.13855,0.50397 0.12302,0.52549 0.47625,0.66915 1.25182,0.50913 3.14041,0.34408 4.49549,0.6005 z"
     id="path4729"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 206.30352,245.46167 c 0.10671,0.39016 -0.10903,1.12018 0.22825,1.57085 0.68667,0.1099 1.3969,-0.04 2.08583,0.0197 0.25561,0.0222 0.45714,0.20622 0.48381,0.20783 -0.70278,0.0156 -1.41009,-0.0212 -2.11489,-0.008 -0.26324,0.005 -0.43757,0.2033 -0.48315,0.20798 -0.9866,0.10135 -0.97679,-0.83449 -1.40592,-1.092 -0.50482,-0.30291 -5.16207,-0.25535 -5.38894,-0.1069 -0.32402,-0.0646 -0.11162,-0.81372 0,-0.99909 0.57698,-0.95817 3.38407,-2.08649 4.49358,-2.01103 1.29696,0.0882 1.79826,1.10245 2.10143,2.21085 z"
     id="path4733"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 254.26726,257.05106 -0.19985,0.19981 c -0.42555,-0.11365 -6.14497,-0.10514 -6.69642,-0.001 l -1.20424,1.00687 c -0.85024,0.0867 -1.16129,-0.8795 -1.79608,-1.00131 -1.33831,-0.2568 -4.06529,0.0252 -5.59958,0.006 -2.04745,-0.0259 -0.87874,0.0464 -2.41231,0.76752 -1.11175,0.52275 -3.78296,0.3565 -5.07413,0.22174 -0.31492,-0.0329 -0.46949,0.0162 -0.3997,-0.39963 0.23803,0.0142 0.90742,0.004 1.29232,0.01 1.37702,0.0203 3.54858,0.27122 4.60806,-0.60518 0.36643,-0.30313 0.38501,-0.78177 0.78801,-0.81899 5.31875,0.19754 10.72062,0.44579 16.01367,0.0246 0.37923,-0.0123 0.46541,0.44661 0.68025,0.59053 z"
     id="path4735"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 162.13691,238.26827 c -0.25518,1.49728 -0.69909,2.96869 -0.99925,4.39597 -1.35507,-0.25642 -3.24365,-0.0914 -4.49548,-0.60051 -0.35322,-0.14366 -0.61479,-0.16517 -0.47625,-0.66915 0.14732,-0.53589 5.0912,-2.79411 5.97098,-3.12631 z"
     id="path4737"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 183.12105,249.2582 c 0.0678,-0.36421 0.1036,-0.74929 0.19484,-1.10969 0.0848,-0.33512 -0.20062,-0.58661 0.40361,-0.48786 -7.2e-4,0.60195 -0.11501,1.20442 -0.19876,1.79736 -0.11186,0.79204 -0.29078,1.59449 -0.39969,2.39781 -0.4888,3.60528 -0.86712,7.14229 -0.99925,10.79011 -0.0384,1.06002 0.0154,2.13563 0,3.19707 -0.01,0.66188 0.0795,1.47818 3.6e-4,2.10202 -0.0371,0.29244 -0.15329,0.61789 -0.39905,0.29475 -0.009,-0.86304 0.009,-1.73355 -7.3e-4,-2.59658 -0.0117,-0.99355 -0.0247,-2.00431 0,-2.99726 0.0916,-3.67434 0.4604,-7.1646 0.99924,-10.79011 0.12935,-0.87028 0.23836,-1.73134 0.3997,-2.59762 z"
     id="path4739"
     style="fill:#b2c8de;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-1"
     d="m 196.71077,237.06936 c -0.19327,0.42254 -0.61675,0.0641 -0.87235,-0.0265 -2.73816,-0.97008 -5.56433,-1.58802 -8.49287,-1.34526 l -1.22677,6.76677 h -0.19984 c -0.0108,-0.16932 -0.008,-0.34567 -0.19985,-0.39964 0.34553,-2.25964 0.69302,-4.52674 1.00116,-6.79192 3.47169,-0.26242 6.83054,0.37604 9.99053,1.7965 z"
     id="path4741"
     style="fill:#4e709b;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-30"
     d="m 206.50337,247.45985 -0.2011,1.19998 c -0.97672,0.51025 -1.70395,-1.59962 -1.89732,-1.59962 h -4.39667 c -0.0698,0 -0.33304,-0.19054 -0.59233,-0.20706 -0.74297,-0.0473 -1.72565,0.21434 -2.30548,-0.19257 0.60517,0.006 2.01806,0.12315 2.46691,0.003 0.211,-0.0564 0.1134,-0.39111 0.13113,-0.40272 0.22687,-0.14844 4.88412,-0.196 5.38893,0.10692 0.42914,0.2575 0.41933,1.19334 1.40593,1.09199 z"
     id="path4743"
     style="fill:#d4e0ec;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 208.90156,245.46167 c 0.65413,0.5471 1.45859,0.95648 1.99749,1.69943 -0.54371,0.15907 -1.23243,0.13323 -1.79765,0.0989 -0.0267,-0.001 -0.2282,-0.18569 -0.4838,-0.20783 -0.68893,-0.0597 -1.39917,0.0902 -2.08583,-0.0197 -0.33728,-0.45067 -0.12154,-1.18069 -0.22826,-1.57084 h 2.59804 z"
     id="path4745"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 159.53887,258.24996 c 0.0658,-4.15984 0.52396,-8.29732 1.20119,-12.38886 0.35566,-0.0146 0.42382,-0.0999 0.39918,0.29771 -0.0378,0.61028 -0.12783,1.4859 -0.20142,2.10031 -0.0947,0.79034 -0.31656,1.56201 -0.3997,2.3978 -0.11509,1.15702 -0.24862,2.33364 -0.40794,3.48856 l 0.008,4.10448 c -0.19822,2.3e-4 -0.40253,-0.0137 -0.59954,0 z"
     id="path4747"
     style="fill:#b2c8de;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-1"
     d="m 171.92951,235.47083 12.87337,-0.20294 c 0.19181,-0.0213 0.13063,0.26822 0.11681,0.40275 -3.52091,0.0954 -7.07365,-0.12848 -10.59199,0 -0.58377,-0.35293 -1.65794,-0.21741 -2.39819,-0.19981 z"
     id="path4751"
     style="fill:#4e709b;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 210.10065,250.05747 c -0.0581,-0.69179 -0.2924,-1.41948 -0.20185,-2.10017 0.0482,-0.36166 -0.0676,-0.3278 0.40069,-0.29687 0.28298,3.53285 0.80094,7.0288 0.60055,10.58953 -0.2393,0.0205 -0.43882,0.17376 -0.59954,0.19982 0.47922,-1.94791 0.12757,-4.02969 0,-5.99451 -0.0527,-0.81081 -0.13232,-1.59386 -0.19985,-2.3978 z"
     id="path4755"
     style="fill:#b2c8de;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-22"
     d="m 259.86214,266.64331 -0.3332,1.00584 c -1.48539,-0.25318 -3.65562,0.61868 -4.66112,-0.70814 z"
     id="path4757"
     style="fill:#f3f6fa;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-22"
     d="m 237.87958,266.84409 c -0.24383,0.48884 -0.55302,0.73606 -1.08862,0.80773 -0.84623,0.11323 -3.75485,0.27391 -3.91054,-0.70782 -0.0731,-0.46076 0.19602,-0.2757 0.49822,-0.30106 1.49338,-0.1253 2.99447,0.38583 4.50094,0.20115 z"
     id="path4759"
     style="fill:#f3f6fa;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 218.09461,234.47174 c 0.21889,0.3384 0.82117,0.19099 1.19907,0.19982 0.33163,0.008 0.66914,-0.0206 0.99926,0 0.0514,0.20067 0.23334,0.17777 0.39971,0.19981 2.96974,0.39349 5.66525,1.76687 8.1769,3.31389 l 12.00785,9.07477 h -25.68061 c -5.30056,-3.25423 -9.51942,-7.95891 -14.95444,-11.02415 -1.0786,-0.60831 -2.35623,-1.00754 -3.33167,-1.76214 7.0563,0.0713 14.1284,-0.10244 21.18393,-0.002 z m 14.78882,7.59305 0.19885,-0.29846 c -0.0305,-0.12569 -0.1887,-0.0905 -0.19885,-0.10118 -1.06532,-1.11697 -4.54275,-3.31798 -5.99122,-4.10052 -1.57404,-0.85041 -5.39944,-2.49344 -7.09888,-2.49344 h -11.29147 c 4.48597,3.52266 10.52121,5.28582 16.12108,6.1611 2.74247,0.42867 5.5201,0.5462 8.26049,0.83249 z"
     id="path4767"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 255.66618,257.85033 c -0.21906,0.009 -0.50294,-0.0613 -0.59951,0.19981 -0.3184,-0.13275 -0.83641,-0.75577 -0.99926,-0.79927 l 0.19985,-0.19981 c 0.45541,0.3051 0.93254,0.52084 1.39892,0.79927 z"
     id="path4769"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-29"
     d="m 219.29368,234.67156 c -0.3779,-0.009 -0.98018,0.13858 -1.19907,-0.19982 0.3773,0.005 0.98162,-0.13592 1.19907,0.19982 z"
     id="path4771"
     style="fill:#bbcee0;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 258.66393,257.85033 c -0.19541,0.0207 -0.40185,-0.009 -0.59956,0 0.0279,-0.3006 0.57156,-0.3006 0.59956,0 z"
     id="path4773"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-29"
     d="m 220.69265,234.87137 c -0.16637,-0.022 -0.34834,7.2e-4 -0.39971,-0.19981 0.16903,0.0105 0.3468,0.007 0.39971,0.19981 z"
     id="path4775"
     style="fill:#bbcee0;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 182.72135,251.85582 c -0.53885,3.62551 -0.90768,7.11577 -0.99925,10.79011 -1.27891,-0.3059 -7.96558,0.49765 -7.99597,2.09611 2.57403,0.72974 5.3278,0.84739 7.99597,0.90115 0.0101,0.86303 -0.008,1.73354 7.3e-4,2.59658 0.24576,0.32314 0.36198,-0.002 0.39905,-0.29475 0.0791,-0.62384 -0.01,-1.44014 -3.5e-4,-2.10202 5.24706,-0.0837 10.58929,0.66135 15.79003,-0.10189 0.0241,-0.39474 -0.36337,-0.45221 -0.64018,-0.55882 -1.49297,-0.57503 -3.92086,-0.93294 -5.55245,-1.24221 -3.16525,-0.59999 -6.38628,-1.04947 -9.5974,-1.29415 0.13212,-3.64783 0.51044,-7.18483 0.99924,-10.79012 l 27.17945,0.59945 c 0.12757,1.96483 0.47922,4.0466 0,5.99451 -3.55197,0.57602 -8.1938,4.48696 -8.1938,8.29241 v 3.89643 h -31.776 c 0.31702,-6.2602 -3.44645,-12.39639 -10.19229,-12.38865 l -0.008,-4.10449 c 0.15931,-1.15492 0.29284,-2.33153 0.40794,-3.48856 l 8.48533,0.80752 13.6979,0.39138 z"
     id="path4783"
     style="fill:#e1e7f0;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 161.13766,259.24904 c -0.48525,-0.0231 -1.12918,-0.0485 -1.59879,0 0.31495,-0.33598 1.29198,-0.33313 1.59879,0 z"
     id="path4785"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 212.89854,259.24904 c -0.49032,-0.0246 -1.11897,-0.0431 -1.5988,0 0.31495,-0.33598 1.29197,-0.33313 1.5988,0 z"
     id="path4787"
     style="fill:#4b5c79;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 162.33676,259.44886 c -0.29856,-0.0504 -0.82738,0.15224 -0.99924,-0.19982 0.50499,0.0436 0.58952,0.10063 0.99924,0.19982 z"
     id="path4789"
     style="fill:#323a4b;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 211.09989,259.24904 c -0.32134,0.0332 -1.10268,0.31376 -1.59879,0.39964 0.41215,-0.40845 1.05323,-0.41536 1.59879,-0.39964 z"
     id="path4791"
     style="fill:#323a4b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 214.69718,259.64868 -1.59879,-0.39964 c 0.87135,0.0716 0.87352,0.13558 1.59879,0.39964 z"
     id="path4793"
     style="fill:#323a4b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 159.33903,259.24904 c -0.23997,0.0305 -1.30796,0.30933 -1.59879,0.39964 0.41215,-0.40845 1.05323,-0.41536 1.59879,-0.39964 z"
     id="path4795"
     style="fill:#323a4b;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-5"
     d="m 162.93631,259.64868 c -0.2446,0.0985 -0.50382,-0.18367 -0.59955,-0.19982 0.27806,0.0673 0.37,0.11636 0.59955,0.19982 z"
     id="path4797"
     style="fill:#33425d;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 209.30125,259.64868 c -0.0776,0.20597 -0.25322,0.15508 -0.39969,0.19981 0.1083,-0.11885 0.24384,-0.17288 0.39969,-0.19981 z"
     id="path4799"
     style="fill:#323a4b;stroke-width:0.358479;stroke:none" />
  <polygon
     class="mpg-dashboard-center-icon-styling-23"
     points="963.4444,448.709 963.4444,448.15159 964.00189,448.709 "
     id="polygon4801"
     style="fill:#252c3b"
     transform="matrix(0.35847865,0,0,0.35847865,-142.06846,110.7851)" />
  <path
     class="mpg-dashboard-center-icon-styling-24"
     d="m 162.33676,262.64593 c -0.04,0.12821 -0.18548,0.28823 -0.19985,0.39964 -0.0722,0.55971 -0.33386,4.41025 -0.19784,4.59574 l 3.59527,-1.79831 h 0.19985 c 0.82615,1.60746 0.72825,1.83138 0.7994,3.59671 h -0.19985 l -3.59722,0.80129 c 0.72279,1.11469 1.66358,2.06253 2.59797,2.99523 0.0811,0.0809 0.12127,0.28962 0.19985,0.39964 -3.19461,5.2091 -9.85375,3.61352 -11.30074,-1.98887 -1.29048,-4.99643 2.55411,-10.9673 8.10316,-9.00106 z m 0,7.79287 c 0.16621,-0.15697 0.1503,-0.494 0.34294,-0.60052 0.4764,-0.26343 3.23838,-0.53078 3.42813,-0.82367 0.20932,-0.4043 -0.3453,-2.51375 -0.66714,-2.54324 -0.80889,0.0622 -4.12842,2.68373 -4.06209,0.73244 0.022,-0.64635 0.55674,-4.07715 0.33605,-4.33643 -0.88362,-0.28181 -1.66886,-0.28247 -2.55243,8e-5 l 0.35596,4.95156 c -0.44351,0.70465 -3.30953,-1.12079 -3.96948,-1.29474 -0.23468,-0.0618 -0.34532,-0.15867 -0.50412,0.11869 l -0.48661,2.38274 c 0.12126,0.14121 3.08389,0.52706 3.63341,0.81142 1.22355,0.63317 -2.06127,3.25514 -2.41376,3.8966 l 1.86279,1.89694 c 0.26552,-0.004 1.77297,-3.02373 2.12126,-3.46983 0.33117,-0.42417 0.86292,-0.49886 1.27882,-0.12491 0.42315,0.38047 1.66098,3.22771 1.89973,3.39707 0.598,0.0296 2.05089,-1.43536 1.9745,-1.86921 -0.43245,-0.81204 -2.41446,-2.3778 -2.57796,-3.12499 z m -3.59829,-7.39219 c -1.52789,0.28382 -2.72272,1.63697 -3.39666,2.99288 l 3.59552,1.60182 z m -0.59873,7.19453 -3.59576,-0.8007 c -0.0921,1.32837 0.3438,2.58656 0.80092,3.7952 0.23727,0.17896 0.75061,-0.43626 0.89894,-0.59639 0.20251,-0.21859 2.00368,-2.28973 1.8959,-2.39811 z m 2.29846,1.80014 -2.29365,3.6939 c 1.2916,0.87015 3.32867,0.9566 4.58472,7.2e-4 l -2.29108,-3.69455 z"
     id="path4891"
     style="fill:#769ac9;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 165.73419,265.843 h -0.19985 c -0.8027,-1.17249 -1.89263,-2.60428 -3.39743,-2.79743 0.0144,-0.11141 0.15982,-0.27143 0.19985,-0.39964 1.75366,0.62139 2.56315,1.5738 3.39743,3.19707 z"
     id="path4893"
     style="fill:#6a7e99;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 165.53434,273.63587 c -0.0786,-0.11002 -0.11879,-0.31872 -0.19985,-0.39964 0.82289,-1.01698 1.05614,-2.51345 0.99925,-3.79652 h 0.19985 c 0.0741,1.83793 0.017,2.53919 -0.99925,4.19616 z"
     id="path4895"
     style="fill:#4b5c79;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-24"
     d="m 214.09763,262.64593 c -0.0395,0.12774 -0.18663,0.28962 -0.19986,0.39964 -0.17357,1.44401 -0.0706,2.96619 -0.39903,4.39456 1.29595,-0.0156 2.34569,-1.0768 3.59661,-1.39731 0.11077,-0.0284 0.2728,0.0191 0.3997,0 0.7333,1.55092 0.73983,1.65248 0.79941,3.39689 h -0.19985 l -3.59709,0.80143 c -0.16661,0.1677 2.25939,2.73444 2.59783,2.99509 0.0726,0.0559 0.12615,0.14311 0.19985,0.19982 -4.11044,7.24487 -13.1014,1.84499 -11.33182,-5.83507 0.86825,-3.7682 4.2825,-6.37759 8.13425,-4.95505 z m -0.99924,5.19524 0.41145,-4.88082 c -0.0721,-0.23737 -2.48452,-0.5433 -2.61719,0.018 l 0.402,4.85252 c -0.57268,0.78975 -3.39603,-1.2931 -4.12769,-1.364 -0.66683,-0.0646 -0.96054,2.04043 -0.84436,2.55557 l 3.76108,0.83249 c 0.69262,0.81481 -2.11888,3.20058 -2.53289,3.87797 l 1.85085,1.89746 c 0.23553,-0.004 1.96405,-3.57972 2.43152,-3.76063 0.19979,-0.0773 0.64072,-0.0975 0.82678,0.01 l 2.14959,3.5526 c 0.83754,-0.30974 1.42588,-0.98406 1.85966,-1.73389 0.089,-0.57953 -3.52448,-3.18811 -2.23257,-3.86646 l 3.43591,-0.81435 c 0.006,-0.56906 -0.12869,-2.64626 -0.92587,-2.43877 -0.98351,0.25602 -2.12195,1.23244 -3.04248,1.3752 -0.37055,0.0575 -0.60875,-0.12151 -0.8058,-0.11288 z m -2.59904,-4.79487 c -1.51981,0.19806 -2.72491,1.68913 -3.39667,2.99319 l 3.59551,1.60182 z m -0.59876,7.19484 -3.59575,-0.80068 c -0.15497,1.34322 0.35482,2.5699 0.80093,3.79518 0.35013,0.0703 0.49187,-0.1815 0.69974,-0.39598 0.19874,-0.20505 2.21386,-2.48127 2.09508,-2.59852 z m 2.29843,1.8001 -2.27348,3.69664 c 0.0562,0.74271 4.04113,0.95414 4.5646,-0.002 z"
     id="path4897"
     style="fill:#769ac9;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 217.49505,266.04282 c -0.1269,0.0191 -0.28893,-0.0284 -0.3997,0 -0.24825,-1.36639 -1.83841,-2.79962 -3.19758,-2.99725 0.0132,-0.11001 0.16035,-0.2719 0.19986,-0.39964 1.81789,0.6714 2.60587,1.72279 3.39742,3.39689 z"
     id="path4899"
     style="fill:#6a7e99;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 217.2952,273.43605 c -0.0737,-0.0567 -0.12729,-0.14395 -0.19985,-0.19982 0.82289,-1.01698 1.05615,-2.51345 0.99926,-3.79652 h 0.19985 c 0.0642,1.87883 -0.0457,2.31579 -0.99926,3.99634 z"
     id="path4901"
     style="fill:#4b5c79;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 141.27584,212.85833 c 0.21719,0.33519 0.82198,0.19518 1.19909,0.19981 2.51015,0.0308 5.06332,0.30327 5.74539,3.14738 0.50575,2.10893 0.51624,6.98118 -0.005,9.08643 -0.34959,1.41274 -1.09856,2.40021 -2.5431,2.75246 -0.67604,0.16485 -1.68835,0.14127 -2.39819,0.19981 -0.43193,0.0356 -0.87682,-0.0411 -1.31194,-0.008 l -0.48669,0.2078 c -0.3392,0.0427 -0.69933,-0.19169 -0.99925,-0.19982 h -0.59955 c -3.04585,-0.0174 -4.70528,-0.47553 -5.19522,-3.69746 -0.33549,-2.20624 -0.38405,-6.80888 0.29595,-8.89398 0.79018,-2.42295 4.06889,-2.66965 6.29822,-2.79446 z m 4.59652,1.79835 c -1.67709,-1.09367 -7.53537,-1.22153 -9.06245,-0.0119 -0.20845,0.16512 -0.10788,0.38774 -0.1306,0.41148 -0.0773,0.0432 -0.13014,0.15177 -0.19985,0.19982 -0.0487,0.0725 -0.16818,0.13198 -0.19985,0.19981 -0.0658,0.0607 -0.14829,0.12945 -0.19985,0.19982 -0.6695,0.91375 -0.73488,1.93992 -0.80775,3.08881 -0.12251,1.93142 -0.17766,4.97355 0.60791,6.70222 0.0704,0.15484 0.0828,0.23442 0.19984,0.39963 0.0518,0.0732 0.13494,0.1356 0.19985,0.19982 0.0382,0.0687 0.14305,0.12881 0.19985,0.19982 0.0694,0.0491 0.12351,0.1603 0.19985,0.19982 0.0241,0.0239 -0.0845,0.26011 0.12667,0.41361 1.14527,0.83241 8.40296,0.87372 9.41828,-0.0672 0.0972,-0.09 0.0198,-0.31161 0.0478,-0.34639 0.079,-0.0376 0.13386,-0.15727 0.19985,-0.19981 0.0383,-0.064 0.16068,-0.11922 0.19984,-0.19982 0.0326,-0.028 0.26134,0.0852 0.41387,-0.12643 0.97142,-1.34783 0.77373,-6.61009 0.56008,-8.34029 -0.10351,-0.83826 -0.21639,-0.92399 -0.57425,-1.52412 -0.0494,-0.20132 -0.13493,-0.2664 -0.19984,-0.39964 -0.0284,-0.0582 0.0591,-0.23533 -0.0553,-0.34559 -0.0974,-0.0939 -0.29651,-0.0231 -0.34444,-0.0541 -0.0421,-0.0479 -0.009,-0.30864 -0.19994,-0.49253 -0.11926,-0.11511 -0.33394,-0.0641 -0.3996,-0.10692 z"
     id="path4907"
     style="fill:#ffffff;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 145.87236,214.65668 c 0.0411,0.0223 0.0687,0.25672 0.59955,0.59945 0.11533,0.13121 0.37217,0.35889 0.3997,0.39963 0.0498,0.0738 0.11487,0.25713 0.19984,0.39964 0.12381,0.50505 0.3997,2.06537 0.3997,2.49771 v 4.59579 c 0,0.57917 -0.51813,2.31849 -0.7994,2.89734 -0.0721,0.062 -0.13941,0.16085 -0.19984,0.19982 -0.0362,0.0605 -0.14006,0.1256 -0.19985,0.19982 -1.09294,0.52064 -2.86374,0.76818 -4.08688,0.8085 -1.45314,0.0479 -4.24232,-0.15449 -5.50587,-0.8085 -0.0644,-0.064 -0.14538,-0.13172 -0.19985,-0.19982 -0.0666,-0.0471 -0.13545,-0.1361 -0.19985,-0.19982 -0.0431,-0.0774 -0.16967,-0.13659 -0.19985,-0.19981 -0.0484,-0.10144 -0.19487,-0.37786 -0.19984,-0.39964 -0.0256,-0.11222 -0.19985,-1.42303 -0.19985,-1.49863 v -6.59395 c 0,-0.0872 0.34452,-1.54833 0.39969,-1.69845 0.0192,-0.0523 0.16127,-0.11718 0.19985,-0.19981 0.0684,-0.0631 0.13352,-0.1541 0.19985,-0.19982 0.0409,-0.0609 0.13655,-0.13368 0.19985,-0.19982 1.49138,-0.83332 4.19834,-1.12025 5.89231,-0.99605 0.37145,0.0273 3.1428,0.51077 3.30074,0.59642 z m -4.19612,5.39369 0.70074,-3.59132 c -0.54275,0.99708 -2.72953,3.56657 -2.90361,4.48946 -0.11458,0.60739 1.42468,0.17944 1.80319,0.30231 l -0.59825,3.59649 2.99292,-4.49967 c 0.19469,-0.63093 -1.79195,-0.12165 -1.99499,-0.29727 z"
     id="path4909"
     style="fill:#ffffff;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 142.47493,212.85833 c -0.39757,0.0152 -0.80195,-0.0223 -1.19909,0 -2.22934,0.1248 -5.50805,0.3715 -6.29822,2.79446 -0.68,2.08509 -0.63144,6.68773 -0.29595,8.89397 0.48994,3.22194 2.14936,3.68011 5.19522,3.69747 l 0.29533,0.18255 c 0.14836,0.007 0.26691,-0.18356 0.30422,-0.18255 0.29991,0.008 0.66005,0.24255 0.99924,0.19981 l 1.19811,0.002 0.001,0.19781 h -5.29609 c -0.094,0 -1.32185,-0.23656 -1.51142,-0.28717 -1.21648,-0.32475 -2.12963,-1.07057 -2.49158,-2.30442 -0.57827,-1.97125 -0.60332,-8.64837 0.003,-10.59946 0.95139,-3.062 5.40763,-2.82486 7.99995,-2.79778 0.33778,0.004 0.88867,-0.12762 1.0963,0.20329 z"
     id="path4911"
     style="fill:#b2c8de;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-3"
     d="m 142.47493,212.85833 v 0.19981 c -0.37711,-0.004 -0.9819,0.13538 -1.19909,-0.19981 0.39714,-0.0223 0.80152,0.0152 1.19909,0 z"
     id="path4915"
     style="fill:#d6e3f1;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 182.1218,262.64593 c 3.21113,0.24469 6.43216,0.69416 9.59741,1.29415 1.63159,0.30927 4.05948,0.66718 5.55245,1.24221 0.2768,0.10661 0.66434,0.16408 0.64018,0.55882 -5.20075,0.76324 -10.54297,0.0182 -15.79004,0.10189 0.0154,-1.06144 -0.0384,-2.13705 0,-3.19706 z"
     id="path4917"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 181.72211,262.64593 c -0.0247,0.99295 -0.0117,2.00371 0,2.99726 -2.66818,-0.0538 -5.42195,-0.17141 -7.99598,-0.90115 0.0304,-1.59846 6.71707,-2.40201 7.99598,-2.09611 z"
     id="path4919"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 232.88343,241.66515 v 0.39964 c -2.74039,-0.2863 -5.51802,-0.40383 -8.26049,-0.83249 -5.59987,-0.87529 -11.63511,-2.63844 -16.12108,-6.16111 h 11.29147 c 1.69944,0 5.52484,1.64304 7.09888,2.49345 1.44847,0.78253 4.9259,2.98355 5.99122,4.10051 z"
     id="path4921"
     style="fill:#92a9c6;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-2"
     d="m 232.88343,242.06479 v -0.39964 c 0.01,0.0106 0.16824,-0.0245 0.19885,0.10118 z"
     id="path4923"
     style="fill:#5f88bd;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 162.33676,270.4388 c 0.1635,0.74719 2.14551,2.31295 2.57796,3.12498 0.0764,0.43385 -1.3765,1.89881 -1.97451,1.86922 -0.23875,-0.16936 -1.47658,-3.0166 -1.89973,-3.39707 -0.41589,-0.37395 -0.94765,-0.29927 -1.27881,0.1249 -0.34829,0.4461 -1.85575,3.46522 -2.12126,3.46983 l -1.86279,-1.89693 c 0.35249,-0.64146 3.63731,-3.26343 2.41375,-3.8966 -0.54951,-0.28437 -3.51214,-0.67021 -3.63341,-0.81143 l 0.48662,-2.38273 c 0.1588,-0.27736 0.26944,-0.18054 0.50412,-0.11869 0.65995,0.17394 3.52597,1.99939 3.96948,1.29474 l -0.35596,-4.95156 c 0.88356,-0.28256 1.66881,-0.2819 2.55243,-9e-5 0.22068,0.25929 -0.31409,3.69008 -0.33606,4.33644 -0.0663,1.95129 3.2532,-0.67024 4.06209,-0.73245 0.32185,0.0295 0.87647,2.13894 0.66714,2.54324 -0.18975,0.2929 -2.95173,0.56024 -3.42813,0.82368 -0.19264,0.10652 -0.17673,0.44355 -0.34294,0.60051 -0.1642,-0.75041 0.10345,-2.18827 -1.13993,-2.55545 -2.70869,-0.79991 -3.58454,2.80646 -1.46925,3.46431 1.2935,0.40227 1.75915,-0.10613 2.60918,-0.90886 z"
     id="path4971"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 160.4382,272.04128 2.29108,3.69455 c -1.25606,0.95595 -3.29313,0.8695 -4.58472,-7.1e-4 l 2.29364,-3.6939 z"
     id="path4973"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 158.73847,263.04661 0.19886,4.5947 -3.59552,-1.60182 c 0.67394,-1.35591 1.86877,-2.70906 3.39666,-2.99288 z"
     id="path4975"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 165.53434,265.843 -3.59527,1.79831 c -0.13602,-0.18549 0.12562,-4.03603 0.19784,-4.59574 1.5048,0.19315 2.59473,1.62494 3.39743,2.79743 z"
     id="path4977"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 158.13974,270.24114 c 0.10778,0.10838 -1.69338,2.17952 -1.8959,2.39811 -0.14833,0.16013 -0.66167,0.77535 -0.89894,0.59639 -0.45712,-1.20864 -0.89301,-2.46683 -0.80092,-3.7952 z"
     id="path4979"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 166.33374,269.43971 c 0.0569,1.28307 -0.17636,2.77954 -0.99925,3.79652 -0.93439,-0.9327 -1.87518,-1.88054 -2.59797,-2.99523 z"
     id="path4981"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 213.09839,267.84117 c 0.19705,-0.009 0.43525,0.17035 0.80579,0.11288 0.92053,-0.14276 2.05898,-1.11918 3.04251,-1.37519 0.79715,-0.2075 0.93208,1.86971 0.92584,2.43877 l -3.4359,0.81435 c -1.29192,0.67834 2.32154,3.28692 2.23256,3.86646 -0.43377,0.74982 -1.02212,1.42415 -1.85966,1.73389 l -2.14959,-3.55261 c -0.18606,-0.10749 -0.62699,-0.0873 -0.82678,-0.01 -0.46746,0.18093 -2.19598,3.75594 -2.43151,3.76064 l -1.85086,-1.89742 c 0.41401,-0.67739 3.22552,-3.06317 2.5329,-3.87797 l -3.76108,-0.83249 c -0.11619,-0.51514 0.17753,-2.6202 0.84435,-2.55558 0.73166,0.0709 3.55501,2.15375 4.1277,1.36401 l -0.402,-4.85252 c 0.13267,-0.56129 2.54511,-0.25536 2.61718,-0.018 l -0.41145,4.88082 c -1.22885,0.0538 -2.73563,-0.0571 -2.81164,1.7026 -0.15,3.4729 6.31519,1.61131 2.81164,-1.7026 z"
     id="path4983"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 212.19902,272.04124 2.29112,3.69459 c -0.52347,0.95619 -4.50847,0.74476 -4.5646,0.002 z"
     id="path4985"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 217.09535,266.04282 c -1.25092,0.32051 -2.30066,1.38175 -3.59661,1.39731 0.32841,-1.42837 0.22546,-2.95055 0.39904,-4.39456 1.35916,0.19763 2.94932,1.63086 3.19757,2.99725 z"
     id="path4987"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 210.49935,263.0463 0.19884,4.59501 -3.59551,-1.60182 c 0.67176,-1.30406 1.87686,-2.79513 3.39666,-2.99319 z"
     id="path4989"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 218.09461,269.43971 c 0.0569,1.28307 -0.17637,2.77954 -0.99926,3.79652 -0.33844,-0.26065 -2.76443,-2.82739 -2.59783,-2.99509 z"
     id="path4991"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 209.90059,270.24114 c 0.11877,0.11726 -1.89634,2.39348 -2.09508,2.59853 -0.20787,0.21447 -0.34961,0.46629 -0.69974,0.39598 -0.44611,-1.22529 -0.95589,-2.45197 -0.80093,-3.79519 z"
     id="path4993"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 146.47191,215.25613 c 0.0479,0.0309 0.24705,-0.0398 0.34443,0.054 0.11441,0.11026 0.0269,0.28741 0.0553,0.34559 -0.0275,-0.0407 -0.28436,-0.26843 -0.39969,-0.39963 z"
     id="path5041"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.27962,226.04624 c -0.0649,-0.0642 -0.14803,-0.12666 -0.19985,-0.19981 0.0302,0.0632 0.15676,0.12238 0.19985,0.19981 z"
     id="path5043"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.47946,226.24606 c -0.0568,-0.071 -0.16163,-0.13114 -0.19984,-0.19982 0.0644,0.0637 0.13326,0.15273 0.19984,0.19982 z"
     id="path5045"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.67931,226.44588 c -0.0763,-0.0395 -0.13045,-0.15074 -0.19985,-0.19982 0.0545,0.0681 0.13546,0.13582 0.19985,0.19982 z"
     id="path5049"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.27962,215.45594 c 0.0317,-0.0679 0.15112,-0.12726 0.19984,-0.19981 -0.0663,0.0458 -0.13141,0.13675 -0.19984,0.19981 z"
     id="path5053"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 145.87236,214.65668 c -0.15794,-0.0856 -2.92929,-0.56919 -3.30073,-0.59642 -1.69397,-0.12421 -4.40093,0.16272 -5.89232,0.99605 0.0227,-0.0237 -0.0778,-0.24635 0.13061,-0.41148 1.52707,-1.20968 7.38535,-1.08182 9.06244,0.0119 z"
     id="path5055"
     style="fill:#e1e7f0" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 146.27206,226.44588 c -0.028,0.0348 0.0494,0.25634 -0.0478,0.34638 -1.01532,0.94095 -8.27301,0.89964 -9.41827,0.0672 -0.21119,-0.1535 -0.10259,-0.38967 -0.12668,-0.41362 1.26355,0.65401 4.05273,0.8564 5.50588,0.8085 1.22313,-0.0403 2.99393,-0.28785 4.08687,-0.8085 z"
     id="path5057"
     style="fill:#e1e7f0" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.07977,215.65576 c 0.0516,-0.0703 0.13405,-0.13917 0.19985,-0.19981 -0.0386,0.0826 -0.18063,0.14751 -0.19985,0.19981 z"
     id="path5059"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 135.87992,225.44679 c -0.78557,-1.72866 -0.73042,-4.7708 -0.60791,-6.70223 0.0729,-1.14888 0.13825,-2.17505 0.80775,-3.0888 -0.0552,0.15012 -0.39969,1.61121 -0.39969,1.69845 v 6.59395 c 0,0.0756 0.17422,1.38641 0.19985,1.49863 z"
     id="path5061"
     style="fill:#e1e7f0" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.47946,215.25613 c 0.0697,-0.0481 0.12258,-0.15664 0.19985,-0.19982 -0.0633,0.0661 -0.15898,0.13897 -0.19985,0.19982 z"
     id="path5063"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 147.07145,216.0554 c -0.085,-0.14251 -0.15,-0.32587 -0.19984,-0.39964 0.0649,0.13324 0.1505,0.19832 0.19984,0.39964 z"
     id="path5065"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 147.07145,216.0554 c 0.35786,0.60013 0.47074,0.68586 0.57425,1.52412 0.21365,1.7302 0.41134,6.99247 -0.56008,8.34029 -0.15253,0.21163 -0.38124,0.0984 -0.41387,0.12643 0.28127,-0.57885 0.7994,-2.31817 0.7994,-2.89735 v -4.59578 c 0,-0.43234 -0.27589,-1.99266 -0.3997,-2.49771 z"
     id="path5067"
     style="fill:#e1e7f0" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.07977,225.84642 c -0.11703,-0.16521 -0.12949,-0.24479 -0.19985,-0.39963 0.005,0.0218 0.15143,0.2982 0.19985,0.39963 z"
     id="path5069"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 146.47191,215.25613 c -0.53082,-0.34273 -0.55842,-0.57715 -0.59955,-0.59945 0.0657,0.0428 0.28035,-0.008 0.3996,0.10691 0.19054,0.1839 0.15781,0.4446 0.19995,0.49254 z"
     id="path5071"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 162.33676,270.4388 c -0.85004,0.80272 -1.31568,1.31113 -2.60919,0.90886 -2.11529,-0.65785 -1.23943,-4.26423 1.46926,-3.46432 1.24337,0.36719 0.97572,1.80504 1.13993,2.55546 z"
     id="path5075"
     style="fill:#92a9c6;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 213.09839,267.84117 c 3.50355,3.31392 -2.96165,5.1755 -2.81164,1.70261 0.076,-1.75968 1.58278,-1.64879 2.81164,-1.70261 z"
     id="path5077"
     style="fill:#92a9c6;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-3"
     d="m 141.67624,220.05037 c 0.20304,0.17562 2.18968,-0.33366 1.99499,0.29727 l -2.99292,4.49967 0.59825,-3.59649 c -0.37851,-0.12287 -1.91777,0.30508 -1.80319,-0.30231 0.17408,-0.92289 2.36087,-3.49239 2.90361,-4.48946 z"
     id="path5079"
     style="fill:#d6e3f1" />
  <path
     class="mpg-dashboard-center-icon-styling-14"
     d="m 145.28863,249.10092 c 8.59543,6.59021 0.53212,5.13735 -1.40283,5.45038 -0.27459,-1.32607 -0.091,-4.68465 1.40283,-5.45038 z"
     id="path4749"
     style="fill:#c47a50;stroke-width:0.358479"
     sodipodi:nodetypes="ccc" />
  <path
     style="fill:none;fill-opacity:0.506283;stroke:#000000;stroke-width:1.88976;stroke-linecap:square;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
     d="m 144.44408,229.43631 v 6.10414 c 0,3.51999 -2.59648,13.88811 -2.68948,27.87117 -2.25067,23.26293 8.42581,8.68072 1.66657,9.26925 -13.5701,0.70353 -12.1799,-3.94591 -8.01069,-9.58533 3.54205,-3.04696 0.048,-0.11563 3.6058,-3.0051 0.4276,-0.34728 2.33396,-2.07316 2.55594,-2.59353 0.18328,-0.42968 0.4975,-0.84886 0.6457,-1.29347 0.0195,-0.0586 -0.0276,-0.13006 0,-0.18531 0.0138,-0.0276 0.0708,0.0218 0.0927,0 0.0218,-0.0217 -0.0125,-0.0642 0,-0.0922 0.12463,-0.279 0.34424,-0.50666 0.5444,-0.73754 0.49291,-0.56858 1.05034,-1.05034 1.57473,-1.57473 0.13984,-0.13984 0.23078,-0.32344 0.37062,-0.46328 0.36968,-0.36967 0.87802,-0.61208 1.29677,-0.92614 0.17891,-0.13419 0.24873,-0.44104 0.43733,-0.44104"
     id="path6044"
     sodipodi:nodetypes="cscccssssscssssc" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 152.61741,250.82317 c 0.35592,1.28093 0.12833,1.95565 -0.99925,2.59761 -0.32477,-0.11766 -0.66076,-0.14752 -0.99925,-0.19981 -2.14005,-0.3306 -1.64289,0.15605 -3.25965,0.84643 -0.27152,0.11595 -0.59084,0.0897 -0.73732,0.15265 -0.19187,-0.50994 -0.52129,-0.93956 -0.7994,-1.39872 -0.21,-0.34672 -0.36828,-0.9554 -0.39969,-0.99908 0.88567,-0.29676 2.29056,-1.64221 3.10813,-1.79085 1.19938,-0.21805 2.86907,0.62813 4.08643,0.79177 z"
     id="path4731"
     style="fill:#ffffff;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-29"
     d="m 151.21847,249.82408 c 0.16579,0.49202 0.79444,0.36976 1.19909,0.59945 0.0875,0.13937 0.15258,0.22951 0.19985,0.39964 -1.21736,-0.16364 -2.88705,-1.00982 -4.08643,-0.79177 -0.81757,0.14864 -2.22246,1.49409 -3.10813,1.79085 -0.0266,-0.037 -0.61708,0.14994 -0.38067,-0.5792 1.00087,-0.1872 2.28336,-1.55611 3.13048,-1.77408 0.63807,-0.16418 2.15244,0.30996 3.0458,0.35511 z"
     id="path4753"
     style="fill:#bbcee0;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 152.41756,250.42353 c -0.40465,-0.22969 -1.0333,-0.10743 -1.19909,-0.59945 0.12303,0.007 0.29732,-0.27652 0.74316,-0.0592 0.48266,0.2353 0.32515,0.45042 0.45593,0.65863 z"
     id="path4763"
     style="fill:#323a4b;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 151.61816,253.42078 c -0.0807,0.046 -0.0703,0.36363 -0.46107,0.36472 -0.35282,-0.10559 -0.6405,-0.14819 -0.53817,-0.56453 0.33848,0.0523 0.67447,0.0822 0.99925,0.19981 z"
     id="path4765"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-27"
     d="m 145.67251,228.04442 c -0.0374,0.41585 0.0754,0.90342 -0.002,1.30208 -0.0804,0.41095 -0.3879,0.46585 -0.3971,0.49627 -0.39125,-0.0295 -0.81417,0.0426 -1.1991,0 -0.23035,-0.0255 -0.55306,0.0554 -0.70974,-0.18646 l -0.0896,-1.41208 c 0.70983,-0.0585 1.72214,-0.0349 2.39819,-0.19981 z"
     id="path4809"
     style="fill:#9ebbd7;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 146.47191,226.24606 c 0.0604,-0.039 0.12779,-0.13787 0.19985,-0.19982 -0.0392,0.0806 -0.16152,0.13584 -0.19985,0.19982 z"
     id="path5047"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 146.27206,226.44588 c 0.0598,-0.0742 0.16359,-0.1393 0.19985,-0.19982 -0.066,0.0426 -0.12089,0.1622 -0.19985,0.19982 z"
     id="path5051"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-30"
     d="m 140.47644,228.24423 c -0.0373,-7.3e-4 -0.15586,0.18944 -0.30422,0.18255 l -0.29532,-0.18255 h 0.59955 z"
     id="path5073"
     style="fill:#d4e0ec;stroke-width:0.358479;stroke:none" />
  `
]
export const factory = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs15" />
<style
   type="text/css"
   id="style2">
	.tem-factory-styling{fill:inherit;}
</style>
<switch
   id="switch10"
   transform="matrix(0.42994157,0,0,0.42994157,-35.658306,-40.972164)">
	<foreignObject
   requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"
   x="0"
   y="0"
   width="1"
   height="1">
		
	</foreignObject>
	<g
   i:extraneous="self"
   id="g8">
		<g
   id="g6">
			<polygon
   class="tem-factory-styling"
   points="140.33,122.49 118.42,138.91 118.42,96.46 98,96.46 98,187.17 184.17,187.17 184.17,122.49 162.25,138.91 162.25,122.49 140.33,138.91 "
   id="polygon4" />
		</g>
	</g>
</switch>
  `
]
export const fuelcell = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs15" /></sodipodi:namedview>
<style
   type="text/css"
   id="style2">
	.tem-fuelcell-styling{fill:inherit;}
</style>
<path
   class="tem-fuelcell-styling"
   d="M 43.433744,39.5 V 0.49999984 H 6.5662549 V 39.5 Z m -2.953698,-4.424099 c 0,0.971668 -0.786793,1.758461 -1.758461,1.758461 -0.726601,0 -1.350017,-0.44284 -1.61658,-1.070555 H 11.282714 v -5.034615 0 -1.074854 0 -0.0258 H 37.65103 V 25.694576 H 11.282714 V 19.563609 H 37.65103 V 15.58235 H 12.168394 v -0.0043 h -0.88568 v -5.030317 0 -1.0748536 0 -0.025796 H 37.65103 V 5.4916215 H 12.942288 c -0.236468,0.6922059 -0.885679,1.1909381 -1.659574,1.1909381 -0.971668,0 -1.7584611,-0.7867931 -1.7584611,-1.758461 0,-0.971668 0.7867931,-1.758461 1.7584611,-1.758461 0.795392,0 1.457502,0.5288281 1.676772,1.2511299 H 38.725884 V 10.547734 H 12.357568 v 3.955463 h 25.482637 v 0.0043 h 0.885679 v 6.130967 H 12.357568 v 3.955462 h 26.368316 v 6.130967 H 12.357568 v 3.959762 h 24.652849 c 0.176276,-0.786793 0.877081,-1.375813 1.715467,-1.375813 0.967369,0.0086 1.754162,0.795392 1.754162,1.767059 z"
   id="path4"
   style="stroke-width:0.429942" />
  `
]
export const generic = [
  '50 40',
  `
  <defs
   id="defs5" />
  </sodipodi:namedview>
   <g
     id="path3756"
     transform="translate(4.49692,0.5)">
    <path
       d="m 22.26434,2.00304 v 15.91139 l 2.61798,-0.85055 12.51492,-4.06594 1.08884,3.35147 -12.51502,4.06646 -2.61848,0.85082 1.6187,2.22714 7.73465,10.64196 -2.85088,2.07077 L 22.1228,25.56342 20.50495,23.33652 18.88682,25.56321 11.152,36.207 8.29859,34.13525 l 7.7341,-10.6449 1.61798,-2.22691 -2.61786,-0.85075 -12.51271,-4.06638 1.08878,-3.35109 12.51171,4.0656 2.61807,0.85073 V 2.00304 h 3.52569 M 16.73865,0 V 15.15871 L 2.32478,10.47502 0,17.63029 14.41466,22.31477 5.5046,34.57821 11.59466,38.99997 20.50472,26.73895 29.41239,39 35.49995,34.57824 26.58911,22.31798 41.00616,17.6335 38.68139,10.47783 24.26434,15.16175 V 0.00304 h -7.52563 z"
       id="path2154" />
  </g>
  `
]
export const grid = [
  '50 40',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs1" /></sodipodi:namedview>
<style
   id="style2"
   type="text/css">
	.tem-grid-styling{fill:inherit;}
</style>
<g
   id="g4"
   transform="matrix(0.10302109,0,0,0.10302109,-43.671283,-328.82993)"><polygon
     style="fill:inherit;fill-opacity:1"
     class="tem-grid-styling"
     points="75.16,162.71 75.16,216 133.18,134.29 100.03,134.29 100.03,81 42,162.71 "
     id="polygon1"
     transform="translate(430,3150)" /><polygon
     style="fill:inherit;fill-opacity:1"
     class="tem-grid-styling"
     points="358.51,306.29 358.51,373 431.15,270.71 389.64,270.71 389.64,204 317,306.29 "
     id="polygon2"
     transform="translate(430,3150)" /><path
     style="fill:inherit;fill-opacity:1"
     class="tem-grid-styling"
     d="M 741,3372.07 V 3390 h 12 v -17.93 h 36.68 l -92.23,-55.29 V 3266 H 741 v 19 h 12 v -19 h 36.68 L 666,3191.87 542.32,3266 H 580 v 19 h 12 v -19 h 42.55 v 50.79 l -92.23,55.28 H 580 V 3390 h 12 v -17.93 h 39.87 L 548.38,3580 666,3467.54 l 117.76,112.6 -84.23,-208.07 z m -75,78.86 -0.07,0.07 h -37.16 l 37.11,-44.72 37.3,44.72 h -37.11 z m -7.93,-54 -45,54.27 29.34,-73.07 z M 653,3372.07 h 25.69 l -12.81,15.44 z m 20.69,24.81 15.43,-18.59 29.18,72.08 z m -27.12,-36.81 v -36.49 l 19.43,-11.65 19.45,11.65 v 36.49 z m 99.77,0 h -48.89 v -29.3 z M 697.45,3254 v -29.29 l 48.87,29.29 z m -12,-36.49 V 3254 h -38.9 v -36.49 L 666,3205.86 Z m -99.77,36.49 48.87,-29.29 V 3254 Z m 60.87,12 h 38.9 v 43.59 l -19.45,-11.65 -19.45,11.65 z m -12,64.78 v 29.29 H 585.68 Z M 608.29,3463 h 45.09 l -73.19,70 z m 70.33,0 h 44.77 l 28.28,69.86 z"
     id="path2" /><polygon
     style="fill:inherit;fill-opacity:1"
     class="tem-grid-styling"
     points="75.16,162.71 75.16,216 133.18,134.29 100.03,134.29 100.03,81 42,162.71 "
     id="polygon3"
     transform="translate(430,3150)" /><polygon
     style="fill:inherit;fill-opacity:1"
     class="tem-grid-styling"
     points="358.51,306.29 358.51,373 431.15,270.71 389.64,270.71 389.64,204 317,306.29 "
     id="polygon4"
     transform="translate(430,3150)" /><path
     style="fill:inherit;fill-opacity:1"
     class="tem-grid-styling"
     d="M 741,3372.07 V 3390 h 12 v -17.93 h 36.68 l -92.23,-55.29 V 3266 H 741 v 19 h 12 v -19 h 36.68 L 666,3191.87 542.32,3266 H 580 v 19 h 12 v -19 h 42.55 v 50.79 l -92.23,55.28 H 580 V 3390 h 12 v -17.93 h 39.87 L 548.38,3580 666,3467.54 l 117.76,112.6 -84.23,-208.07 z m -75,78.86 -0.07,0.07 h -37.16 l 37.11,-44.72 37.3,44.72 h -37.11 z m -7.93,-54 -45,54.27 29.34,-73.07 z M 653,3372.07 h 25.69 l -12.81,15.44 z m 20.69,24.81 15.43,-18.59 29.18,72.08 z m -27.12,-36.81 v -36.49 l 19.43,-11.65 19.45,11.65 v 36.49 z m 99.77,0 h -48.89 v -29.3 z M 697.45,3254 v -29.29 l 48.87,29.29 z m -12,-36.49 V 3254 h -38.9 v -36.49 L 666,3205.86 Z m -99.77,36.49 48.87,-29.29 V 3254 Z m 60.87,12 h 38.9 v 43.59 l -19.45,-11.65 -19.45,11.65 z m -12,64.78 v 29.29 H 585.68 Z M 608.29,3463 h 45.09 l -73.19,70 z m 70.33,0 h 44.77 l 28.28,69.86 z"
     id="path4" /></g>
  `
]
export const heatingelement = [
  '49.999998 40',
  `
  <defs
     id="defs912" />
  
  <g
     id="g1577"
     transform="translate(-0.02268035,-0.54294373)">
    <path
       style="stroke-miterlimit: 10;stroke-width: .5px;"
       d="M 46.88857,30.857764 H 3.1558104 c -0.7793348,0 -1.4132347,-0.614477 -1.4132347,-1.369019 V 4.9626735 c 0,-0.7550755 0.6339098,-1.3690191 1.4132347,-1.3690191 H 46.88857 c 0.779815,0 1.414215,0.6139436 1.414215,1.3690191 V 29.488756 c 0,0.754531 -0.6344,1.36902 -1.414215,1.36902 z M 3.1558104,4.7053676 c -0.2488746,0 -0.4138183,0.154706 -0.4138183,0.2573059 V 29.488756 c 0,0.102059 0.1649437,0.257307 0.4138183,0.257307 H 46.88857 c 0.248874,0 0.414798,-0.155252 0.414798,-0.257307 V 4.9626735 c 0,-0.1026003 -0.165924,-0.2573059 -0.414798,-0.2573059 z"
       id="path1055" />
    <path
       style="stroke-miterlimit: 10;stroke-width: .5px;"
       d="m 26.39451,37.3909 -0.7832,-0.62305 c 0.42676,-0.53516 0.72461,-1.08105 0.91211,-1.66895 0.63379,-1.98633 -0.15332,-4.11133 -0.98633,-6.3623 -1.1958,-3.22949 -2.55078,-6.8916 0.375,-10.67383 l 0.79102,0.6123 c -2.58643,3.34375 -1.3877,6.58203 -0.22852,9.71484 0.85547,2.31055 1.74023,4.69922 1.00195,7.0127 -0.22168,0.69531 -0.58594,1.36426 -1.08203,1.98828 z"
       id="path1057" />
    <path
       id="path5222"
       d="m 24.95698,14.43791 -2.80658,6 h 5.56481 z" />
    <path
       d="m 28.13767,20.70877 h -6.41309 l 3.23438,-6.91504 z m -5.56152,-0.542 h 4.71582 l -2.33691,-5.08496 z"
       id="path1060" />
    <path
       style="stroke-miterlimit: 10;stroke-width: .5px;"
       d="m 36.84666,37.3909 -0.7832,-0.62305 c 0.42676,-0.53516 0.72461,-1.08105 0.91211,-1.66895 0.63379,-1.98633 -0.15332,-4.11133 -0.98633,-6.3623 -1.19531,-3.22949 -2.55078,-6.8916 0.375,-10.67334 l 0.79102,0.61133 c -2.58594,3.34424 -1.3877,6.58252 -0.22754,9.71533 0.85449,2.30957 1.73926,4.69922 1.00098,7.0127 -0.22168,0.69531 -0.58594,1.36426 -1.08203,1.98828 z"
       id="path1064" />
    <path
       id="path5222-2"
       d="m 35.4092,14.43791 -2.80658,6 h 5.56481 z" />
    <path
       d="m 38.58982,20.70877 h -6.41309 l 3.23438,-6.91504 z m -5.56152,-0.542 h 4.71582 l -2.33691,-5.08496 z"
       id="path1067" />
    <path
       style="stroke-miterlimit: 10;stroke-width: .5px;"
       d="m 15.94285,37.38992 -0.7832,-0.62109 c 0.42627,-0.53711 0.72461,-1.08301 0.9126,-1.6709 0.63281,-1.98535 -0.15381,-4.11035 -0.98682,-6.36035 -1.1958,-3.23047 -2.55078,-6.8916 0.375,-10.6748 l 0.79102,0.6123 c -2.58643,3.34375 -1.3877,6.58301 -0.22803,9.71484 0.85498,2.31055 1.73926,4.69922 1.00146,7.0127 -0.22217,0.69434 -0.58594,1.36328 -1.08203,1.9873 z"
       id="path1071" />
    <path
       id="path5222-3"
       d="m 14.50505,14.43791 -2.80658,6 h 5.56481 z" />
    <path
       d="m 17.68601,20.70877 h -6.41309 l 3.23389,-6.91504 z m -5.56152,-0.542 h 4.71582 l -2.3374,-5.08496 z"
       id="path1074" />
  </g>
  `
]
export const heatpump = [
  '50 40',
  `
  <defs
     id="defs5" />
  
    
  </sodipodi:namedview>
  <path
     style="fill:inherit;fill-opacity:1;stroke-width:0.442038"
     d="M 38.846834,40 V 12.434523 H 11.153166 V 40 Z M 34.660736,26.217262 c 0,5.335396 -4.32755,9.662946 -9.662946,9.662946 -5.335396,0 -9.662946,-4.32755 -9.662946,-9.662946 0,-5.335397 4.32755,-9.662947 9.662946,-9.662947 5.335396,0 9.662946,4.32755 9.662946,9.662947 z"
     id="path1" />
  <path
     style="fill:inherit;fill-opacity:1;stroke-width:0.442038"
     d="m 32.437286,29.855233 c 0,0 0,-1.467566 0,-4.968505 0,-2.705271 -4.429219,-2.413527 -6.449332,-2.139463 0.826611,-2.21903 2.647807,-3.9695 2.647807,-3.9695 0,0 -1.467566,0 -4.968505,0 -2.705271,0 -2.413526,4.429219 -2.139463,6.449332 -2.21903,-0.826611 -3.969499,-2.647806 -3.969499,-2.647806 0,0 0,1.467565 0,4.968504 0,2.705272 4.429218,2.413527 6.449331,2.139463 -0.826611,2.21903 -2.647806,3.9695 -2.647806,3.9695 0,0 1.467565,0 4.968505,0 2.705271,0 2.413526,-4.429219 2.139462,-6.449332 2.21903,0.826611 3.9695,2.647807 3.9695,2.647807 z"
     id="path2" />
  <path
     style="fill:inherit;fill-opacity:1;stroke-width:0.442038"
     d="M 28.830257,10.684053 C 27.269864,9.8928058 26.376948,8.619737 26.376948,7.1875345 c 0,-1.4322024 0.892916,-2.7052713 2.453309,-3.4965189 0.720522,-0.3668914 1.136038,-0.8575533 1.136038,-1.3526357 0,-0.4950823 -0.415516,-0.9857442 -1.136038,-1.35263562 L 29.32976,0 c 1.105095,0.561388 1.741629,1.4145209 1.741629,2.3383799 0,0.923859 -0.636534,1.776992 -1.741629,2.33838 -1.17582,0.5923306 -1.847718,1.5073488 -1.847718,2.5107746 0,0.9990054 0.671898,1.9140237 1.847718,2.5107747 z"
     id="path3" />
  <path
     style="fill:inherit;fill-opacity:1;stroke-width:0.442038"
     d="m 25.103879,10.684053 c -1.560394,-0.7912472 -2.45331,-2.064316 -2.45331,-3.4965185 0,-1.4322024 0.892916,-2.7052713 2.45331,-3.4965189 0.720521,-0.3668914 1.136037,-0.8575533 1.136037,-1.3526357 0,-0.4950823 -0.415516,-0.9857442 -1.136037,-1.35263562 L 25.603382,0 c 1.105094,0.561388 1.741628,1.4145209 1.741628,2.3383799 0,0.923859 -0.636534,1.776992 -1.741628,2.33838 -1.175821,0.5923306 -1.847718,1.5073488 -1.847718,2.5107746 0,0.9990054 0.671897,1.9140237 1.847718,2.5107747 z"
     id="path4" />
  <path
     style="fill:inherit;fill-opacity:1;stroke-width:0.442038"
     d="M 21.3775,10.684053 C 19.817107,9.8928058 18.924191,8.619737 18.924191,7.1875345 c 0,-1.4322024 0.892916,-2.7052713 2.453309,-3.4965189 0.720522,-0.3668914 1.136037,-0.8575533 1.136037,-1.3526357 0,-0.4950823 -0.415515,-0.9857442 -1.136037,-1.35263562 L 21.877003,0 c 1.105094,0.561388 1.741629,1.4145209 1.741629,2.3383799 0,0.923859 -0.636535,1.776992 -1.741629,2.33838 -1.1714,0.596751 -1.847718,1.5117692 -1.847718,2.5107746 0,0.9990054 0.671897,1.9140237 1.847718,2.5107747 z"
     id="path5" />
  `
]
export const pv = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs19" /></sodipodi:namedview>
<style
   type="text/css"
   id="style2">
	.tem-pv-styling{fill:inherit;}
</style>
<path
   class="tem-pv-styling"
   d="m 30.183056,12.143038 h -1.231617 l 0.745452,7.314078 h 3.521993 C 31.339047,17.582681 30.183056,15.000607 30.183056,12.143038 Z M 29.232334,28.224286 28.470676,20.748154 H 16.327362 l -0.761658,7.476132 z M 16.457006,19.457116 H 28.33563 L 27.590177,12.143038 H 17.202458 Z m -1.35586,0 0.745453,-7.314078 H 5.9936611 l -1.6259508,7.314078 z m -0.129643,1.291038 H 4.0814133 L 2.4176496,28.224286 H 14.209845 Z m -0.896704,8.772572 H 2.1259508 L 0.5,36.829402 h 12.829346 z m 1.355859,0 -0.745452,7.314077 h 15.416822 l -0.745452,-7.314077 z m 14.395877,-8.772572 0.761658,7.476132 H 42.380388 L 41.094752,22.44973 c -0.194465,0.0108 -0.383529,0.02701 -0.577995,0.02701 -2.117518,0 -4.083784,-0.637416 -5.720538,-1.728585 z m 12.84015,8.772572 H 30.717837 l 0.745453,7.314077 h 12.829346 z"
   id="path4"
   style="stroke-width:0.540183" /><path
   class="tem-pv-styling"
   d="m 49.5,12.143038 c 0,-4.9588795 -4.018962,-8.977841 -8.977842,-8.977841 -4.958879,0 -8.983243,4.0189615 -8.983243,8.977841 0,4.95888 4.018962,8.983244 8.983243,8.983244 4.95888,0 8.977842,-4.024364 8.977842,-8.983244 z m -1.350458,0 c 0,4.213428 -3.413956,7.632786 -7.632785,7.632786 -4.213428,0 -7.632786,-3.419358 -7.632786,-7.632786 0,-4.2134269 3.413956,-7.6327853 7.632786,-7.6327853 4.218829,0 7.632785,3.4193584 7.632785,7.6327853 z"
   id="path6"
   style="stroke-width:0.540183" /><polyline
   class="tem-pv-styling"
   points="175.32,126.16 167.42,139.94 169.44,130.39 164.85,130.39 168.52,116.24 173.48,116.24      170.91,126.16 175.32,126.16    "
   id="polyline8"
   transform="matrix(0.540183,0,0,0.540183,-51.357568,-57.049002)" />
  `
]
export const rest = [
  '49.999998 39.999999',
  `
  <!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs49" />
   <g
     id="g318"
     transform="matrix(0.98893229,0,0,0.98893229,5.3944619,0.3944668)">
    <path
       id="path6"
       d="m 13.60029,13.87419 c 0.32014,-0.82167 0.76638,-1.53168 1.3396,-2.13326 0.57518,-0.60443 1.26879,-1.07296 2.08083,-1.40862 0.81096,-0.33958 1.71806,-0.50741 2.722,-0.50741 1.29501,0 2.37565,0.17746 3.24297,0.53452 0.86625,0.35599 1.56379,0.79937 2.09349,1.32712 0.52864,0.5297 0.90799,1.10007 1.13592,1.70932 0.22704,0.6121 0.34154,1.18354 0.34154,1.71128 0,0.8741 -0.1145,1.59571 -0.34154,2.16126 -0.22793,0.56555 -0.51116,1.04871 -0.84878,1.45018 -0.33851,0.40165 -0.71109,0.74408 -1.12237,1.02641 -0.40932,0.28322 -0.79741,0.56555 -1.16214,0.84878 -0.36473,0.28233 -0.68879,0.60533 -0.97113,0.97005 -0.28322,0.36384 -0.46175,0.8206 -0.53345,1.36689 v 1.03997 h -3.69402 v -1.23205 c 0.0544,-0.78386 0.20564,-1.43966 0.45105,-1.96829 0.24648,-0.52864 0.53345,-0.98075 0.86144,-1.35512 0.32888,-0.37258 0.67524,-0.69753 1.04086,-0.97113 0.36384,-0.27448 0.70039,-0.54807 1.01179,-0.81881 0.30855,-0.27555 0.56074,-0.57519 0.75282,-0.90406 0.19101,-0.32692 0.27752,-0.74016 0.25897,-1.23205 0,-0.83914 -0.20475,-1.45892 -0.61603,-1.85967 -0.40932,-0.40254 -0.97969,-0.60247 -1.71021,-0.60247 -0.49189,0 -0.91566,0.09506 -1.27183,0.28626 -0.35617,0.19119 -0.64706,0.4482 -0.87588,0.76727 -0.22793,0.32014 -0.39683,0.6945 -0.50545,1.12148 -0.10969,0.43072 -0.16391,0.88855 -0.16391,1.38329 H 13.095 c 0.0173,-0.98736 0.18513,-1.88857 0.50527,-2.71112 z m 7.97696,12.04984 v 3.62072 h -3.69339 v -3.62072 z" />
    <path
       style="stroke-miterlimit: 10; stroke-width: .5px;"
       d="M 19.82471,39.3999 C 9.03125,39.3999 0.25,30.61865 0.25,19.82471 0.25,9.03077 9.03125,0.25 19.82471,0.25 c 10.79346,0 19.5752,8.78125 19.5752,19.57471 0,10.79346 -8.78125,19.5752 -19.5752,19.5752 z m 0,-38.00049 c -10.15967,0 -18.4253,8.26563 -18.4253,18.4253 0,10.15967 8.26562,18.4248 18.42529,18.4248 10.15967,0 18.4248,-8.26465 18.4248,-18.4248 0,-10.16015 -8.26464,-18.4253 -18.42479,-18.4253 z"
       id="path153" />
  </g>
  `
]
export const tVIconLadesaeuleRGB = [
  '283.46 283.46',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" [
	<!ENTITY ns_extend "http://ns.adobe.com/Extensibility/1.0/">
	<!ENTITY ns_ai "http://ns.adobe.com/AdobeIllustrator/10.0/">
	<!ENTITY ns_graphs "http://ns.adobe.com/Graphs/1.0/">
	<!ENTITY ns_vars "http://ns.adobe.com/Variables/1.0/">
	<!ENTITY ns_imrep "http://ns.adobe.com/ImageReplacement/1.0/">
	<!ENTITY ns_sfw "http://ns.adobe.com/SaveForWeb/1.0/">
	<!ENTITY ns_custom "http://ns.adobe.com/GenericCustomNamespace/1.0/">
	<!ENTITY ns_adobe_xpath "http://ns.adobe.com/XPath/1.0/">
]>
<style type="text/css">
	.tem-chargepoint-styling{fill:inherit;}
</style>
<switch>
	<foreignObject requiredExtensions="&ns_ai;" x="0" y="0" width="1" height="1">
		<i:pgfRef  xlink:href="#adobe_illustrator_pgf">
		</i:pgfRef>
	</foreignObject>
	<g i:extraneous="self">
		<g>
			<path class="tem-chargepoint-styling" d="M183.57,117.59c0-0.1,0-2.95,0-5.99c0-3.55,0-7.36,0-7.36h-4.37v-7.77h-2.5v7.77h-7.05v-7.77h-2.5v7.77
				h-4.39c0,0,0,3.81,0,7.36c0,3.04,0,5.89,0,5.99c0,4.43,2.77,8.2,6.67,9.7c0.06,0.02,0.12,0.04,0.18,0.06
				c0.3,0.11,0.6,0.2,0.91,0.28c0.09,0.02,0.18,0.05,0.28,0.07c0.17,0.04,0.34,0.06,0.51,0.09l0.66,0v44.06
				c0,4.25-3.97,4.41-4.42,4.42h-16.67V96.46H99v90.71h51.87v-8.39h16.67c2.39,0,6.92-1.45,6.92-6.92V127.8l0.61,0
				c0.15-0.03,0.31-0.05,0.46-0.09c0.09-0.02,0.18-0.05,0.28-0.07c0.31-0.08,0.61-0.18,0.91-0.28c0.06-0.02,0.12-0.04,0.18-0.06
				C180.8,125.79,183.57,122.02,183.57,117.59L183.57,117.59z M123.7,160.01h-8.84l7.07-27.23h9.55l-4.95,19.1h8.49l-15.21,26.52
				L123.7,160.01L123.7,160.01z M142.47,125.72H107.4v-21.48h35.07V125.72L142.47,125.72z"/>
		</g>
	</g>
</switch>
<i:pgf  id="adobe_illustrator_pgf">
	<![CDATA[
	eJzVvXl68sivKPxtgD1AEhIIkwcmk5GZzAlkIhMx4CQEAsSG7n5/f9zV3DXcDdyNfarybDyUgT7n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==
	]]>
	<![CDATA[
	wqJ4eNAtxqeXp8dnnHSYb+w/JGuTp/R9VXx5oipPtfZt7aB40KN3i7mxgoXd8jc0oJg8OFFMh+L3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==
	]]>
	<![CDATA[
	8OjDO/NGoz/vdrJtyBtvrM3Z+2yYA7t2Z91ozp4jCC/1sADAomE+G+6Hoxhn2kehnLVmxHuGOhSp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==
	]]>
	<![CDATA[
	cKIi/s15D1NNvF+8J9GmcNHCTzJN9BjW4cHUoHMVk01BFTGvYu/JiU4YKnUlZLVJvjT5oueSKDLS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==
	]]>
	<![CDATA[
	fo8+fqm9eUKzr/fnfa//rT1KGwoz9bG8P4TK2lZsszRKfu4Wr3sf55Wzk1BL3zjVjtws47I+w0ng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	]]>
</i:pgf>
  `
]
export const tVIconVerbrauchRGB = [
  '283.46 283.46',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" [
	<!ENTITY ns_extend "http://ns.adobe.com/Extensibility/1.0/">
	<!ENTITY ns_ai "http://ns.adobe.com/AdobeIllustrator/10.0/">
	<!ENTITY ns_graphs "http://ns.adobe.com/Graphs/1.0/">
	<!ENTITY ns_vars "http://ns.adobe.com/Variables/1.0/">
	<!ENTITY ns_imrep "http://ns.adobe.com/ImageReplacement/1.0/">
	<!ENTITY ns_sfw "http://ns.adobe.com/SaveForWeb/1.0/">
	<!ENTITY ns_custom "http://ns.adobe.com/GenericCustomNamespace/1.0/">
	<!ENTITY ns_adobe_xpath "http://ns.adobe.com/XPath/1.0/">
]>
<style type="text/css">
	.tem-consumption-styling{fill:inherit;}
</style>
<switch>
	<foreignObject requiredExtensions="&ns_ai;" x="0" y="0" width="1" height="1">
		<i:pgfRef  xlink:href="#adobe_illustrator_pgf">
		</i:pgfRef>
	</foreignObject>
	<g i:extraneous="self">
		<g>
			<path class="tem-consumption-styling" d="M179.19,170.59c0-9.18-7.44-16.63-16.63-16.63c-9.18,0-16.63,7.44-16.63,16.63
				c0,9.18,7.44,16.63,16.63,16.63C171.75,187.22,179.19,179.77,179.19,170.59L179.19,170.59z M176.71,170.56
				c0,7.81-6.33,14.14-14.14,14.14s-14.14-6.33-14.14-14.14c0-7.81,6.33-14.14,14.14-14.14S176.71,162.75,176.71,170.56
				L176.71,170.56z"/>
			<polyline class="tem-consumption-styling" points="167.8,168.66 159.9,182.44 161.92,172.89 157.33,172.89 161,158.74 165.96,158.74 163.39,168.66 
				167.8,168.66 			"/>
			<path class="tem-consumption-styling" d="M163.59,119.17h-14.87V96.46h-2.5v22.71h-24.85V96.46h-2.5v22.71H104c0,0,0,37.62,0,38.25
				c0,16.45,13.34,29.79,29.79,29.79c5.3,0,10.27-1.4,14.58-3.83c-3.06-3.39-4.94-7.87-4.94-12.8c0-10.57,8.57-19.13,19.13-19.13
				c0.34,0,0.68,0.03,1.02,0.05C163.59,140.77,163.59,119.17,163.59,119.17L163.59,119.17z"/>
		</g>
	</g>
</switch>
<i:pgf  id="adobe_illustrator_pgf">
	<![CDATA[
	eJzVvWl6MruuKPxNgDlAEhIIUFRHm5ae9A3pSEcKqCQkBEgBa613/7ijuWO4E7gT+2RX37uAdc49
ez07L1QZyZZlWZIlKxq5bKVK/XFXTHEUHQ5FoxVJFGZjqRjGT8NHw+F8OpPQo9h1PMzkKBoalY7y
HaXhnShNB+NRMcxyFEMx8LKOfh2rCNJ4OBiFjz6/4+FYHJ7fDGZDEd7c3HWOeuNRB37ZlYR577Nz
3ShT4mQaV9EDvKowg7ZMnqIzFEuHmWyRyaHXwugvYTod/Ae9zHJ5Dp6Vx/NRfzD6KI//gYc0Hy5k
4Yfwmzz6RXNwLU4dmlAsn+fybCab5zIFHgZWoJh8IVOg+QzP0Kzy6+q4N/8RR7NLadwTp9PKeDiW
psVw5Y8wCp8JH/BGCLfF4XD8dwiIkunUB0MRxv8jzMIMh0hVOmLYTnk+GPbP5z9dESiTzXHoMdfB
wG6nAAUAos/oca5z9ANPWuJsBv0FVIjcQB9jB+Ah/i/2dAm0EAGb9C2OXuIKWGk8QU+mcjM2z1F8
ls9kswW2wFi+yr+4EX8mQ6C3TB2eoTL2v0pLGB5ulWK4HJXL5nJMNsNl+Ew4xXJ5itUfMGGeZSiW
YwEhwscXwhmep3LaAwWiTmDxr4H4dzF8Ph6JMi1L0qwlTzTP07T8V35zPR+K0u1oMIMx8uhRQSbm
2bgvDqG99vv6UPiYquRi9L9ygxtB+hBnwB7j4XyGeTivYoDJOhX+iGiuGRnBxUQc3YzvcB9TDJ1n
wznUqTCb4fNhhuX4MJvFCLJhntMwMvpfGTACg4Co0BGTXcKEX0iDj8GoqPQt12lIg77OBCwlEy3H
5xkuD/AZ2vEZHhwFo0D/Y5gCS8Mskz4p4P/lskwmz/AsyROZMkDk2UwcKZQCdq+cGdiXps5aMMba
qF8Z/6CZnqIlK8JggaWH4w/5nfYZv4GfzycyvfD3DjDFpTQYIZihc/wm37kczuFVQxrPJ0ej93Eo
JgusO7EHUgn4ph++6H7BF5A+50Lv80P8jzjofY7EmTgNl2E9wnOtLSUMJnFPsDBISQzLL+GX+Kv6
r/+vq+I7CAX95/LT5jPL5YZDcZR6nE+F2X9+xv35EN7Krf2hXg6FkSCF8XMVqBFU+Gg0EyXhezb4
K/wjAB5ohH4jzh4IgAN7ToA+g7/UYZsReTUwvPJHdDoY2QCgZyk0SSBIRWkgDDWshv2IEiY+oFvf
4qz3aQUuP10B+Eth9hkuA137Uw1AafQxRHw2H33Y5vUU6CE396dKRRgOBx+SMPkc9MJlaT79DN+M
x3pHT5T37wNxMhhNxaEFl/H3+Ofo1wSzjpayNLoYyWOz4z0D8oiSI0qQt/Lv/h/Gp/3GCRfiiP+B
mFp/frqgak1/NPDGJ5eCNBv0hmLrDxCSQKi0enhKnHrdmoj/gcXi2HHlZ0G6/V+FSOGxcK0/gGXt
Isw827T+FkBinA66ngsXTdv7YNSHMbXmg5moAUcDQFvfhzgVZ/+ZwWYC4h1PjfqDlgY304Hd0Ljf
pVLeG2FBfoOUpdmfoTgNpU9G479H+Eu4GIo9tWbCqC9I/Zd4OH0u/IjhZCjdGoDGJ6pt6PBFiDao
LEz4QYAH1yHY8DOFLJ/LMCwPWjLDIRUgQzOZLJfNgu6MNGmayuULdKbAskyO5zNcTtGz6PBDKUTr
X/7Al2P48AWP/ka6yln46YUO9+Hxw3UII+2H0pcCDC68EwqnYROEf/EAgSL68HxpdAk7HUwmHtFl
d8kxWFVsTKGH/4RsqvdlL3RZ1jqn9iHIzJ0OpjPTdNkGj1sswiMMLb+S5QIC8/8pjwGQ5aELcKWz
qroO5pkQinbS6nfgIvRt0EN6tCD9kb8/nJ2eg0ru+HInHPvnZziC1ylYe9KgOwfFLA7MCU1LkiT8
14BYAXxDq94nyHUJ6VmoDRtOgwKmv0V/Zn8movw2tjmadv4SpOkOrMsWQB99mJv+JQznalv0fOrS
bgRrWm6m9GRq+vY/lDrdATbYGQLiABHBYDjHZPCnkLF18r93jCMwdQnGNxz3vsU+ydjUliua/iVH
z3iOnmheB0J3KJIwvu9M/k9a6MW/iJc6avrfzMVoeD3Q0sc//72S7N/jwyKob6AuoT0PRAcpO/7r
6wL68v9QV/7byfIjzoQ+TNGy/Sgs2Y/1vqITkXC5oTH+8dPZYDYbihLYj/P34f/9P9P56AMp7rej
QQ9+q8ID3Y0Ja7oXdpeFFTccWB+XEjI0wvoex2TocPpaFIbol4XwmQgG17WADOvBf7C3Paw7QeVf
cLTpFxfz2WQ+8/kNrRDOqXOnwuhjLnyAoTWeIJMq6SCmeOX3vfFQklvkVNEDxjKlISmD1ReOCWDf
aowjP5pOxjNLqx9h+q2MKKsOaCL09T2ydASUno21oYnmsSBnekkShRJ2Ztm3T8sQ8jRQOk/zBQo5
wTmOztEFGe3lGLRpxD8x7LyW3b1mXNXBdDIU/pyBSaFwwyPyJIkjYIT/Df+GGTsjGOZYHd5l6VqF
a/H96x25Foc342u5E7hTl+PpAA0Ev2UUuW/+NU38e9YyL0dTsGC6YzBqWuJQ7M1UFcWhAVh9wnxo
UM+0xaq2wMSX32VYns1rTFcIC0qTcA8dBoTZ8Ickqqs6m4EZcW/LhCW1V6yh1UwSRtOJALKh9weg
DfrhqcYivhC7mkzQ2BEvDXXJhwewfoSZCA1FrOzaGhfCE2ECC3o6+JkPBX2lMa5oCQmjDdZ3EAYS
uoziewRa5xikw4fsLSHqgE4bxgQViy7pLzF8I/4zw94YoTsYDmbKjOMjPw2uKmPkQ8GWNjMx+SjS
IH+/S0f1+XCo/kA5s4S39pFlw++aIBXAAA6DoBE0ScNYV7PB1Y2ObDqtHpj+5nVtbYIOrnTquzQ6
Fd9hlVlY0troRtuWODaXzbm0uh58fM4apnl0b1fWJsbIGo5Nte7pu4tju4uJ0NNmkM94tq0LPRG7
0P1aI/pYG+dd+4FO3IARQMLOhFFPaZ9nCozxQDKc53nGeIbpO9czQZN5CiXyNCUfrNEsk/Eeau2f
mRjwd2jQxp/xmXyOd5mi+nA8lgyz7sUhuK0+875NCWYetzPNPJtlGbfOooEZ+prJF/KMR1O9q+4d
QO1M+H26+v4+FWequuTWtCIOh5XxXKU/5woTNdQFEuvezSY6fxyPmiJiCbs0og3SCGTsEJ2VzUA0
krWczqTxt2oq0eFUhqb9eBp2dgF9wUS5E0aD6ScsHAOLe0oPfLp4N5gOZKGNFoiPMMR4gv8Mza77
r/I8p63sXIbjwnmOyQZZ2fpg0EQal5xNaOQKwYSGDvpmPDHQdWlppAMuj2dgjRthZ3Ma7HyWCWNc
QUE7MUOukNEAZ7hcPjChtXm00tmVzXTt+WjUF/9pib3xqB/sN/WBNF3VdGoDWPFsanBtkwkgNNA8
F3guEWCnqWRcZMlE1cjGf4nSBJ0JWM0uyw96w8EE9DzkMfkHFM0P2CHVX9AGE9H4EwkbX6m/cDhG
uCsM9U3awZelnUHAm3Ttn8lYmiEfRGkKAnx6Iv5RDQcgRG8s9cW+HVA4fT6emV6bTGSGDYNd2JCE
/gBpuMKor9jMXlay/CMczQC2Cv4RVmKtPzJjYsK1y1ZgVPKvCHAZbYnRWJ/D8GCE5wiZbarWbPY9
PLMcq3ofDG4HPEgPV4NZlUbWNdKhS0iH1iwcI+dgeBfKftUy7ldmwwCN17GZGSFq5oAxp9s4MkbZ
3E/LAUDhspHjyOgg98jL52LBeOGxfGRgFbRwKsrCuTYtHCvB3JvSbrS90bQGtWetu0Z9PJq15t2p
HK5lgQDv8fk1GhMYwT3LwE6BhKpRflR1MhGNc6aj91mIqohI667e9Ne4S3UHsx8BCSOrz0leFMbm
k4+fbwokgtgfv79TXSxAzX13bz2fiiBfyuirQtGsKwocZWlFEbM7aYw/nM6GlOwtn0z6Hp2aSFRf
9oW4N0KwlEYaMAL00PYHBUqOjIvWsQdyR8kBI/YWJR2uOfjA49e98RA5hmBa7QvIbcQyMgVRdS71
PsM3kjjowmKEJoPRQJRm3ljREE1EsM9zD7X5NCvnDq2kPjWWPqhPd3KiJu+waj/H0n8IIP2lOkDd
YIHZgIKPfVaC3P2xwbZxhDeUKG1n6A6F3rd3W8Q9SguKzbguD5gFtPT/HvRnn8RLSdJJzdCuJJoi
L4tKJNZFYsjDQZHfU+/xgAYJo58h9/GUiNkRdD/GQXMEUIfCRO2n4ypDg5+i4A5CWB4shmFNhA9x
MHof+zRDehmOc7R5721NxRHSrvrerD3tTYa9Pz6QetJ44g1mBpacYR/yE+0zFZ7PfOFfwaTNUAaC
u3SRB9IbTT3Wit4B4l5KJunhyKp9cTr4GPnMhsbT4/eB1cdobPc+mlFT2NR9cGJQwlTeV4nX5xDM
B2/U/eFEeh9reg4BgXSYGZdZmSjHC4ou7DQvUwDzlzgkHojGO06cII9Dl3Mk/CVvlvrU+IovZSkz
ecfOguAeoEwQvaN5mvFuaVRD8jzr1th/O0Ot/jbuGn59NHGFG0B9H8jkct7wDEsmU3DeYcwQHZfq
FJRGpGZ6rPgfw2YWm143yuGjWiXLFLLZFEs5nLdZfjyRfNYibiMb0OPZp6quOO1Y0BIpNIOgR8FG
GP9MKG+lTupLU7NA140aW7sA2h9uL4xGYw9t1UCK3s8fDxUDRjGe9Dx2MNygP/cZ5vt81NN6Y2cg
uY1iv02n7hMD2KbzCer69O9PsJa95Aa0VZUJbKN6jgGdLgkmM9V1sFPVM+8sU4DTp59CH3jFQ9NB
jcQZGrE+XmeBItNFb+XSLWWkujsaezacWn5YzTY32oGC7DmAkfgh6AfxLo2gXzMcWWey/C2oTE4m
jnbpuORgbzpuPQxypgheegPq1w/mIk9gWFTiY2c/ZQqdpHYFSY+RUg5QkXenpDYOI2Pb7gORbXMP
J4ift8xTpxgO1fNej0Gg5sjs05z2BDq3ChbI82GLx7H1BTYSQ0O3PkigNUhTEY1NcmdO4+C84U2/
BxOwoUbfTvNyPO6iXAHDrDDWSXHwExm9NafjnkFNZPWXtRFQTpMkhheXktgbmJhOc+88CBNHJPq5
srG1miZq8UnhN/8oaStm2sCr6k3V3h5F3JyIktVJiTr78W7W8eAZjn3Xu2Toa+2nK/ZlLrb5n8By
1mKQLgf/iMNLUXoXe1Zvt+1MdyRMbLBawl/i2Xw4G0yGYsnG2i6APsd/NweqbrFjX0N6coM5qB5x
ghxsj8iqvgul0XPjE7QuS63K0VE+UxXRqkFQE/uZt1zi4K6bptOJs1Ti4HPGoU8sv3tV5LQXV9on
/GKHO7iZlavvhcZ3c/16T6i+0+197S2b2LvOfkbiXHMvkkpvXYeikcT+924kfv5YiCQ/B/Dq7Z2K
JObFViR59lCNpOgzlk7vtWMYfSZSiV/xU3Z6Bp2rfvMHF2/7XDnP5bOP2Z/H3dRbfQ==
	]]>
	<![CDATA[
	nLvn6L7+lm52xEooKkn7e91ScnJ+fHhSmO7nm7v3VH38yN/VpOdHuvpYb9/U90p7PWa7lBspWLiN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==
	]]>
	<![CDATA[
	NTcBeX0JF7vjHu+dLafdROED4nvNpw9v7CuD/rw5rW1D3HhzZcbeR9Ps2HW660Yz9lxB+IkHGwCL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==
	]]>
	<![CDATA[
	+xmmGnhvr5PokLho4SeZJroPa39vYpC5isqmoIqZd7E3aqwThk5fiFltks9NtujpVJLY6WcEtpXj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==
	]]>
	<![CDATA[
	4VPtzSOafb0/bzv9L+0Vb0jM1Mfydh+paEex1+Uh9bFduuy9n1ZPjiIt/eBUu3KzgtP6DDeBR80X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	]]>
</i:pgf>
  `
]
export const tVIconWasserkraftRGB = [
  '283.46 283.46',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" [
	<!ENTITY ns_extend "http://ns.adobe.com/Extensibility/1.0/">
	<!ENTITY ns_ai "http://ns.adobe.com/AdobeIllustrator/10.0/">
	<!ENTITY ns_graphs "http://ns.adobe.com/Graphs/1.0/">
	<!ENTITY ns_vars "http://ns.adobe.com/Variables/1.0/">
	<!ENTITY ns_imrep "http://ns.adobe.com/ImageReplacement/1.0/">
	<!ENTITY ns_sfw "http://ns.adobe.com/SaveForWeb/1.0/">
	<!ENTITY ns_custom "http://ns.adobe.com/GenericCustomNamespace/1.0/">
	<!ENTITY ns_adobe_xpath "http://ns.adobe.com/XPath/1.0/">
]>
<style type="text/css">
	.tem-hydro-styling{fill:inherit;}
</style>
<switch>
	<foreignObject requiredExtensions="&ns_ai;" x="0" y="0" width="1" height="1">
		<i:pgfRef  xlink:href="#adobe_illustrator_pgf">
		</i:pgfRef>
	</foreignObject>
	<g i:extraneous="self">
		<g>
			<path class="tem-hydro-styling" d="M164.45,138.05c0-16.89-23.21-41.59-23.21-41.59s-23.21,24.7-23.21,41.59c0,12.2,10.39,22.1,23.21,22.1
				C154.06,160.15,164.45,150.26,164.45,138.05L164.45,138.05z M142.21,134.55h5.18l-9.28,16.18l2.37-11.22h-5.39l4.31-16.61h5.82
				L142.21,134.55L142.21,134.55z"/>
			<path class="tem-hydro-styling" d="M173.47,187.17c-3.71,0-5.61-1.71-7.29-3.22c-1.54-1.38-2.87-2.58-5.61-2.58c-2.75,0-4.08,1.2-5.61,2.58
				c-1.68,1.51-3.58,3.22-7.29,3.22c-3.7,0-5.6-1.71-7.28-3.22c-1.54-1.38-2.87-2.58-5.61-2.58c-2.74,0-4.07,1.2-5.61,2.58
				c-1.68,1.51-3.58,3.22-7.28,3.22c-3.7,0-5.6-1.71-7.28-3.22c-1.54-1.38-2.87-2.58-5.61-2.58v-2.5c3.7,0,5.6,1.71,7.28,3.22
				c1.54,1.38,2.87,2.58,5.61,2.58c2.74,0,4.07-1.2,5.61-2.58c1.68-1.51,3.58-3.22,7.28-3.22c3.7,0,5.6,1.71,7.28,3.22
				c1.54,1.38,2.87,2.58,5.61,2.58c2.75,0,4.07-1.2,5.61-2.58c1.68-1.51,3.58-3.22,7.29-3.22c3.7,0,5.61,1.71,7.29,3.22
				c1.54,1.38,2.87,2.58,5.61,2.58V187.17L173.47,187.17z"/>
			<path class="tem-hydro-styling" d="M173.47,178.87c-3.71,0-5.61-1.71-7.29-3.22c-1.54-1.38-2.87-2.58-5.61-2.58c-2.75,0-4.08,1.2-5.61,2.58
				c-1.68,1.51-3.58,3.22-7.29,3.22c-3.7,0-5.6-1.71-7.28-3.22c-1.54-1.38-2.87-2.58-5.61-2.58c-2.74,0-4.07,1.2-5.61,2.58
				c-1.68,1.51-3.58,3.22-7.28,3.22c-3.7,0-5.6-1.71-7.28-3.22c-1.54-1.38-2.87-2.58-5.61-2.58v-2.5c3.7,0,5.6,1.71,7.28,3.22
				c1.54,1.38,2.87,2.58,5.61,2.58c2.74,0,4.07-1.2,5.61-2.58c1.68-1.51,3.58-3.22,7.28-3.22c3.7,0,5.6,1.71,7.28,3.22
				c1.54,1.38,2.87,2.58,5.61,2.58c2.75,0,4.07-1.2,5.61-2.58c1.68-1.51,3.58-3.22,7.29-3.22c3.7,0,5.61,1.71,7.29,3.22
				c1.54,1.38,2.87,2.58,5.61,2.58V178.87L173.47,178.87z"/>
		</g>
	</g>
</switch>
<i:pgf  id="adobe_illustrator_pgf">
	<![CDATA[
	eJzVvXl++jjzMDgX4A6QhAQCGG+sWVlD9oVsZCMsTsI3BIiB7qefP97TzBnmAnOxKcm7Ldsy0O9v
3u5PpwHLVVKpNpWqpGjkqpkq9cddKSUwbDgUjVZkqTMby8Uw/jV8PBzOpzMZ/RS7iYe5HMNCo9Jx
vq02vJfk6WA8KoZ5geEYDh7W0duxSkceDwej8PHXdzwci8Pvt4PZUIInt/ft49541H7oTKeS/C13
Pmbtm6Nym88x0mQa1/oAQKudGbzAFRg2w/BsmOOLbAE97oz+gncH/0UPs0JegN/K4/moPxh9lsf/
gR/ZQriQhc6KYS6fg6eNwY00JTRh+AKX43IZvsAXsgV4QWDEnMixmbwgFrKc+nZ13Jv/SKPZlTzu
SdNpZTwcy9NiuPJPZxQ+73zCk064JQ2H479DQJlMuz4YSkCEn84szAmIXqVjjm+X54Nh/2L+05WA
PNmcgH4W2hjY3RSgAED0Gf2cax//wC9NaTaD/gIqRHMgkbkD8CP+N/Z8hen405G/pdFrXAUrjyfo
l6nSjM/DwLJiJpuFgXK2r8obt9LPZAj0VqgjckzG+VdtCcPDrVKckGNy2VyOy2aEjJgJp3ghz/DG
D1xY5DmGF3hAiPCJhXBGFJmc/oMK0SCw9NdA+rsYvhiPJIWWJXnWVCZaFFlW+as8uZkPJfluNJjB
GEX0U0Eh5vm4Lw2hvf5+fdj5nGrk4oy/SoPbjvwpzYA9xsP5DDNyXsMAk3XW+UdCc80pCC4n0uh2
fI/7mOLYPB/OoU6F+YyYB/YUxDCfxQiyYVHQMXLGXwUwAoOAaNARk13BhF/Kg8/BqKj2Ldc+kgd9
gwl4RiFaTsxzQh7gcyzxNzw4BkaB/uG4As/CLNP+UsD/5LJcJs+JPM0vCmWAyLOZNFIpBexeOTex
L8ucN2GMtVG/Mv5BMz1FIivBYIGlh+NP5Zn+GT+B1+cThV74exuY4koejBDM0AV+km9fDefw6Ege
zyfHo49xKKZorbPBSAorz8L4Iagg9FuqDDIIcinJg84QfjvuSx1DWpnOYBL3hNv8lma9Lztk5ddl
Yd9LPVCnwOv98GX3D3wBGBed3ten9F9p0PsaSTNpGkY44He9rT9YmBhZowW8ib9q//d/uyp9QPeN
15VfGy+8kBsOpVHqaT7tzP77M+7P0ZCV1v5Qr4adUUfW6afYHxOo8PEIyNj5ng3+Cv90AA80Qu9I
s0cK4CBSE6DP4C8HC/g2MD2iQNSZfYXL0Lv+VIddGn0O0WzNR58O6pwBVKW5P+xKZzgcfMqdydeg
Fy7L8+lX+HY8Hup4TtXnHwNpMhhNpaENl/l9/Dp6m2pIQPjR5UgZmxPvOTgDkkxECZpWee//x/j0
d0i4kGz9H4ip+c9PFzyt6Y8O3vzLVUeeDXpDqfkPEJJCNJs9PCWkXjcn0n9BtRE7rr4WpNv/uxCp
PBau9QegM11Ugmeb5t8d0O9ng66n4KJp+xiM+jCm5nwwk3TgaADI6H1KU2n23xmoZFCSeGq0F5o6
3Ewb7KDZ0qVS3iawoDxBbtLsn6E0DaVPR+O/R/hLuBiKPTdnnVG/I/df4+H0RedHCidD6eYAfD1J
a8OGL0OsyVnhwo8d+OEmBKY+U8iKuQzHi0KmwAnI+GdYLpMVstk8n+FYEX7J5QtspsDz4G2LGSGn
elhs+LEUYo0v/8CXE/jwB376G3kp5+HnVzbch58fb0IYaT+UvurA4MI7oXAaTAn8Hw8QKGIMz5dG
V2AvYDLxiK66S47B7lxjCj3+N+Rwuq96oauy3jmtD0Fm7mwwnVmmyzF43GIRHuFY5ZGiFxCY/0v9
GQDZfnQBrnZWc9RhYdYJRdtp7TtwEfo26CEPuiP/o3x/PD+7AGec+HAnHPvPz3AEj1Mge/KgOwf3
Jg7MCU1Lstz53wNiBfBNrXpfoNdl5K2gNnw4DW6M8RT9mf0zkZSnsc3RtP1XR57ugFw2Afro09r0
r85wrrVFv09d2o1AppVmak+mlm//h1KnO8BLdY6COEBEWCpcYDL4U8jcOvk/O8YRLHIpxjcc976l
Ps3YtJYrmv4lR895jp5qXged7lCiYXzfmfw/SdCLf1GLOmr6P8zFaHg98NLHP/+zmuzf48MiuG/g
LiGbB6qDlh3/dbmAvvz/qCv/42T5kWadPkzRsv0oLNmP9b7qE9Fwuakxfvn5fDCbDSUZ1o/zj+H/
+/9M56NP5LjfjQY9eFeDB74bF9Z9LxwoC6sBOFh9XMlooRE2bByXYcPpG6kzRG8WwucSLLhuOmhh
PfgvjrOHjfCn8obAWt64nM8m85nPO6xKOFLnzjqjz3nnExZa4wlaUpnbo1B1SZY6JRx2cZoomzbL
szCaPCsWGBRiFgQ2xxaUvl6NwWNFcxTDoWElmGrFVR1MJ8POP+fgtqsUf0LRGmkExP6/4f9hzkls
Ex01mlyVbjS4tsi60ZEbaXg7vlE6gTt1NZ4O0EDwU07Vrda3Wer3eb1HZVgEh2PHU1gldMewcGhK
Q6k309wAQgNYWXXmQ5MLpAuE1gIT36r8ERfM5M5oOumApPT+CX/Kg34YbcEo7bIZmA1T244KKtxD
IXlYNHV1CfFtKps679JKeZ7hRT7vDok3IPni/JQlyeAVhWSYkTUBDX+PwLsagxR8KlEBqg4YozZB
LYQnnQnI6XTwMx92LAJEQjwAMevMJIAlYZ+YErVpRJwFMFYP8l9S+Fb6zwxHPDrdwXAwU2ccb6jp
gDU5Vrbcmvp826VSVN8A7LJtNJ3hQLXWQlYToEmnb2fQ6WSsasGcxnT9yYCxAfvpTL917Vk6BjU5
G+t6SVPByk6kSf9+l47r8+FQG4y6ZQlPnYTPhj90RdqBBXAYut+Zan3l7JrGFDBGmzXtZg+W/lad
Y2+CtqwMrnRpdCZ9gAboW4XQ3uhWN0sCn8vmXFrdDD6/ZkcW/nZvVyaKKbGp3j3DuhDbXU46PZ27
xIxn23qnJ+EQul9rRB9747xrP9BeGzACaP9ZZ9RT2+e5AmfeigznRZEz7176zvWso+tjlRJ5llG2
1Fiey3gPtfafmRTwPTRo82tiJp8TXaaoPhyPZdOse3EIbmvMvG9TipnH7Swzz2d5zq2zaGCmvmby
hTzn0dToqnsHUDsLfp+ufnxMpZnmLrk1rUjDYWU81+gvuMJEDQ1lybt3s4F28cajhoRYwqmNWJM2
AtszRNuaM1DbdC2nM3n8rS2V2HAqw7J+PA1eRwd9wUS574wG0y8QHBOLe2oPvEd3P5gOFIOCBMRH
GWI8wV9Ds+v+Vl4UdMnOZQQhnBe4bBDJNgaDJtIscg6lkSsEUxoG6NvxxETXpbWRAbg8nsFq3Aw7
m9Nh57NcGOMKCprEDLlCRgecEXL5wITW59FOZ1c2Mzz741Ff+k9T6o1H/WDv1AfydFXTqQ9gxbOp
w3VMJoDQQYtC4LlEgElTybnokonmLY7/kuQJ2hOYer/QGw4m4ISiiMl/wAH/BAupvcGalojmV2Ts
v6X+wkkN4W5naBhpQixL34OAJ+nafyZjeYZiEKUpKPDpqfSP5h4CIXpjuS/1nYDC6YvxzPLYskTm
+DC4lkdypz9ADnhn1FfXzF6rZOUlnHgC6yj8Enaw7S9ZMXHh2lUzMCrlLQpcKr3PgMDa4u64SqCs
kyDaVKWNkFv6z7jLdAeznw5iCvvaX+mcufnk8+ebgZmR+uOPD6aLGdnaL/fW86kE81xGX1Xuybqi
wHludhSx6lzufYVvZWnQBRbrSx+D0UCSZ871vQXeRGaMAA1xVD3U5stqrwmt5D4zlj+Zr7grNVGT
DxCWr7H8XwpIf2mLIzdY4EmgTESfSVG6Pza5O0R4Q5nRBb477PS+vdv+AD3VFgyfcZ0pmAXkmPw9
6M++qGdVNkjNsa4kmqKFl0Yk3oV5leGgNNCp93jAqMDoZ2hNqraMeTMOgu7HOGiOAOqwM9H6SUKP
Bz9F+72UsDxYDMOadD6lwehj7NMMqWqc6OsI6DmaSiOkcPverD3tTYa9f3wg9eTxxBvMDJw7LeZB
oWVmGjyf+cJvwaTNUE6yu1JSBtIbTT1kxegAdS9li/Ygsmpfmg4+Rz6zofP0+GNgDzuY232MZsx0
3vUahQ6qM1VUPLV8DsGj8EbdH07kj7HuOVAQyICZcZmViRoNVc0jaV6mAOYvaUg9EJ13SJygjMPQ
czT8pWyLGVPjq75UUebyxM6C4h6gtHCjo3mW825ptoh5kXdr7G/OUKu/zVbDr48WrnADaNiBTC7n
Dc8kMpkC2cJYIRJFdQr+C/J4PCT+x2TMYtObo3L4uFbJcoVsNsUzhO0B28sT2UcWcRvFpx7PviTZ
3WJBS5BHaRB0d8gM4z8Tq1lyIJH78tSq0I2wqaOdwtBUAoDbd0aj8cyT1hopej//eLgYMIrxpOdh
wXCD/txnmB/zUU/vjZOBlDbqqmQ6dZ8YwDadT1DXp39/DWaSl96AtpozgaMxnmNAAWccbzabPPJg
p1qwjqxTgNOnX50+8IqHp4MaSTM0YmO8ZIWi0MVo5dItdaRGhAovdkgtP+0rCDfagYPsOYCR9Nkx
9g1dGkG/ZjjZBnvQJJMCqCzrToF16bhMWPoQTQ+H1sAdL78B9esHc5EnMKwq8d6bnzOFdn66HZnO
Y53Ohqo8TyZ99zlAyPvKjqF7IwRLbaQDo0APbZGuHXprKNSDAIoHA0aOjCQbcK1psF4afDxE26cw
IZZtX88RK8i0sIO2yQY/hkvaC2G02Laxn76OV7av0kpNR7jsGv4gRC08HbnhUNsU9OAc1BwNWg+e
Uix0NLDAk5+OvAhHX8B6mxq69UEGV02eSmhssjvZzYPzhjf9Hkxg4Tr6Js3LybiLcrZNs2Lde0Wz
cqkG0W8NZWafuEtbSEzrS/P+qHpbtb4Ev9V+ulJfmWyrbYFnV7LUG0zN2lDpDjxCW5ynwMy2jsKT
x87EgaQOqu5s3Os4fWN4iNOIjV1DMyyt/M+J/+rzg4jFgMNZ4PxHLWFwjLE2AqbSLRtn3hAfjY34
YngwwvFD5ODr4mvxfF54gdd8H1NKDA7AeaTBWLd50eYx2t8tWewt5+CDCopnVtR45o05nmmFh9pS
AdQYq2nenTHxFh6GnbXMYJQGJChm3YJbeagWOpoqXfbKLbJ3jI5eljHckna0eNZIIroa/EcaXkny
h0SQ12bnL+kc9PAAMJYcCk9p5di6/Rr/3Rj07WNwNBt1Jk5RwVUdiALTSacnEWWjCYttpfpRUz8O
3W0UN1iT6hHRlWR7RBbtWSiNfjf/guxBqVk5Ps5nqhLS1ghqYj/znksc3HfTbDpxnkocfM0E9IkX
d6+Lgv7gWv+EH+wIB7ezcvWjcPTdWL/Z61Q/2Na+/pRP7N1kvyJxobEXSaW3bkLRSGL/ezcSv3gq
RJJfA3j0/sFEEvNiM5I8f6xGUuw5z6b3WjGMPhOpxK/FKT89h85Vv8WDy/d9oZwX8g==
	]]>
	<![CDATA[
	2afsz9Nu6r0+zj0IbN94yjbaUiUUleX9vW4pObk4OTwtTPfzjd0Hpj5+Eu9r8ssTW32qt27re6W9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==
	]]>
	<![CDATA[
	1SagqC+lsBNtvHe1nH4ShQ+I7zWfPrzzbxz6806SbVPeeGNli73PhjWwSzrrRl/suYLwUw8OADYN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==
	]]>
	<![CDATA[
	c4jp/tGX40RF/Jv7HqaWeO+8J5FQuGjjJ4UmRgxrf29i0rmqy6aiilmt2DszNgjDpi+lrD7JF5a1
6NlUlvnpVwTMykkk8XyxwaYfv3NKE1RPFdk43z9m2Ngoku49T0RB/jqpA8WGr4Xru+1Y6ie+Vf4t
s43Pi9L677ycjbx0+gJ8ej/cyO/Ma5vnl783md/v1nMuw4i9/Hn9kTll5Ejm7Eh8L9983x30m+fZ
h69b6SLzex+TPjYeSnGx+mft9uY0FP0uDncfx9JBbPTbzv1G5cNR9iLycHGwtSHEjrLRj+fj4/j8
a/1ZHL9IRTy1uLJz/+62eR9hEm+HEf7z9z6xK2wdsvXyaZmtf/RO2KPs5o0svxdi8jT/APIyXX/L
dqeZ7vOVXgp4m9hLpx4Y4aywppW9/UnL05cxumyusE7e9bVUl+48nbULpd71BKnJ5kSfF3Sf5Pyd
i26XDs9OSMTC5IDhzjZlWdiIeI70K9bZkq7W759u9zdGchrmZZMXP+frw36kj2pJT7Ti0Mg8OREv
UL7a+QjXJEZK9dvbKLsh9eG3q7HVYZ/YxAeGdlUxIqtqPFmxlab7LUGtkSixn41W5tWnuvSIr8+s
vJ6sN2ry824bF9uW388fKuUaf1utHiTyp0a7ULReWG/+Apz7Xw2scoFmjEt851AxY+vtcOcsIuNR
lX7GZ9PS6cNDO1G7f2ygTzDcqyGDinaTyqJ+P9OS8cqJTc9iKBehPdPWyOkMs6V94mI4dgw0yY3g
a24b1/2CwjmewNe9JP4KVuxZhq8VRnutnq7X+PM8gG2wiWoyOq/HGsfHXHLrqx2Kah09jZsfFWYd
/UHC/OAs0dMfpMwP3nKS/iBtfjCpfJqwcKZHR+VfVF9wsW3+7S7W1RpfJM0PPsW+/oDB9xtyjY1D
FpmEDa6RqgvY7l9wYJG/YPxHdzwiB5CoMytUBp00x6aBV1DRY1Il4NVxSuP9+baqjq7OGNwEJ8LD
1xuWf512OfjTR18feeUUzW3h4Bb4FeHm4xtMXJ281jGeA8BS4XZUpK1LBmMRynkhvyO9xT8qX9n6
ZXmYX8+bVhv6hY1qRNFh1I2bYVs36eAQSfBUeQGId6wBMXu3V6yU7jZ33itfudNJ6bY0ekA2oMCX
n7ff6u348ykf7z0OtNm4FQzGBu94UlYH3j1LYt4PRdGjDrAu8wO/3iiMj8IfceVTZ+0+hT8B0Zvb
yqfyk9BARqbFv853j/EnYaPwMwMAnxnUJKVK3fcdOKxrRxw+bzy/hR8B7FJM+dTZqOyp/fnu8Los
dgHB3YH24FPUBOQpo4+lKxzc1VEW3js8yD6lqunOLsxL8XO0dVffrYl/HKW6R4/X6upV+bNp2RTg
z3bNvDh7TqMeIm4rbSufai8nCfwJn0Sh93v2KeBfwdlK1Gz9yT79NIbVj+j09nD34FEsnT6yYAMy
rxnQK9cxzJ/C5iC6Wet9/xasFh5XQBghWyCm2Sx3fvNeZnm2GYnvXoiRVHrrHhnoaiTRYy4jG9V8
KpI4+j1Dv51FmLWHh1A0kvz68xhJ3r/VIqmS0EB2akOn3aYS41E01V5L6bI+f9vqOghUudqk85vS
tKUYM2tLXcVtoaTTX7TXhA6ma8RR/eEPCmDgr/CnNWYURbl1GHnF7Ix84iQu2cbclh48zhgl2jNI
gk1Dvo6wsVM7IUglenRwf3GqyJj+Bz24Ayw50ET7ubjOd6+q6tnfS2gdPgUbsDf+Ri4pg5Un0mO5
+0bl/bvUN7Pp/hnLZrqnBwQ1ilyoz0tFl2rjQ0XzLyV1Oo8qSeU3FDODr8eMosfiKG/+T3m4Nqoj
HcopGtSA3Ti4EeC3620q/0/1GMua5CgerGasTX6GfPCZK75enRdKjWwW3Uy9Wy6/X6xf4K/FzXG1
WF2Xkse1h7J0c/hxy23CU74JZjezXy9s3PSxqd6Zf8KClBHle+zBbh/ZjLF2ckAa1+AzmA+0IzOw
DG1sHBZrvy9FoVJtl24rby+1xtWAO/wtpUvV45/BtF4dcmWV48XqAK9fbmbIKb1QjykwuVi0SNen
tcTg6at0e/8g70gF+bvUnEe+cr+Nm7Nap7MF81J76q99YecOsOTniq8bHb9W0J3gaWN5ERTzA19l
mN2Henv2yiGLfPJ94z1gy3DB39yfb0ZsqyTl4BHwYZBwnfyohznU2wmzb6lYlfXi2Q3QWxqUv2Ox
62CYD3b2N10xq2d32HCbLOTpRvWlenS09126rQq/JKJ7kpwHxcsdW3MV/n0em20xYqO8ZV3iqtpS
utpLIG2pHo5Re6n/6mujHZRYd1gZ1Dflw/utx9/DcUNu1dvJxnrp8nP3DEggboSi1Y/r6Q2WxWnk
davK9qOjKkhl8XrBmSZRG+x+IHpvf06j2GPmq73LA9qBI4oFGLrPwN0YTdl9ox76ggMPRYWSHKka
Jhq089vU1h9aNbq7m5rtVuedozNQo82zw/Ts4LTUyETkUBTUZ7UJS5vGYaGW7yVr8lvxDZaFo/2j
4f3jCzR6Zg/T08kXHp9ltUXFAljUQcMsKOxBmC8UdeCeVCrl763RS5XJbU0DCfvCGmY1us0ctaYn
dYDhAqNNNtT9FzUc0d6uLSjn3mMGf8w0alBmqVEqP6SVNlpZAz22rFqnUOrKqRrBrHhwG67e875q
g2JzWRa0YgGHC1gWI3Wg4cLs2wdMZLTlHDVkxXxHjSXLJldL85jZX1vAWzMJF/jlaOXEOCsfLWu6
bCR+8VRAK7lD9KccSfL1C+VrfLvMR1IvtSZa8eHV3Sk8SMmR5PljM5KMH+ImyUgqn3qDFV98MNyP
pEbXL+htFjU/UJZ95hXDGMWJ+S3lgCz1jLDzEYq+pJR+sfGNPMtOq6Py5dXha72aybyXbnf+xKrH
z1lYi8FsxNZg2Vtn9JDerzEH6a/oSAYP4aVgHzM95nsJrNj96d4xzMFtpPaevfyicif2ntYDIdXy
lDBavtfePtx5+WpXmZt3ufKxN+pSI0UQTS6E1XtCOyNLOo4U3pMjo/tfMWWhqN1/WnCSPamNPdiF
fcYVe0pLGlFkX1bhP3h7D9odQyt2lm2YQ9HgGna5lXhk+2040ZdmsRVMvEZ3sGI0lLejD2jUsNcX
2Krws02zmP2uyzaS47iska7ivIsTv5is3vDIboAteYqBaRmK9Uiy3T9BX9lI8nfygMwEPL1e20EW
5DISf//IKxFDaCdEUieF1r9lX9wUAMg+pcINtFy1qVtYiy2gcINixlmdDty1znvt+3D0m34H9Dct
w7T6GtZx8n+rfbFYNvt94tSkDjJcrGHuN6r/cjDGYV+QWr8iRQZcjbo/+msU7dmcrCMXugtE6LUD
zDS9CxWKBrevwVlcqU1YURjMFXNogThUcG5T85RoxWvB4dLrsSV4DPRYIPFaULjIeox2kmmFKxiP
XS8oXCg/2SFeKGvh/tcZHjBnLVTKDMvXHsqti1Jywh6WetcX9epBInNSSo6LW9Wn+uy11Mi+Xxx+
3E52YF7k1+7lzgF3n8fJC9WD7ZpQvz3ItVYY+jPH+VcTbSc5N8ZZ0KuKU6wwzh9wsW6L85d+llyp
LrZGXoUX/cAjD5beo1x0EQOzv3z41Rf9IjHY4ByvxccIHvUKFzFIJ7tuOSyPWeX4UHQ1S4l/Mwbr
t3pT42Pc4vGx2MYzg2Jhl+jrlbFWIa1UcOxiobUKtyXNKl+5V4nCyAAW9TNOrMt8JWbiwxyloRTV
vfzAa9aDm+2X0u3dnzfPGKwRisSf6u0IfCrWFg/EbsXQKinyHKfV6EZ2ZIo9eFxiL4kwYMrh1l2H
S2HFtmILDjexO8g+LL6XFHi4Skxp+fn1Hq6qLZeeX+/hhqKrmV/v4SIeW8X8LhTrW5ydibNLu2O1
8HDx7C4eTw4y3FDUdX7VGNfsIGHsyxMS5/Q8fJR/bbpiA2Uvq2uauM235CbmF78L29ac+4w9mGbP
N9Scc+zLJfaatT72a9BY9nqbZlR49bN7+mC4fnzltisaHcW/rf9m5+faovA9agcw7179GtMUikY2
n/gT0wiwpY3stX70nag7yw09mN4t8wpsMzOu2wEIx88GgCa2lQBCLSsCmuBcOSWJrt7e4uM/5Rwq
IohxR2+fLFqaxdXfOr/b6m/fawmUxGukdvZtthdlQqJR47uK9Ct5tg8ftjvglyfq8IBBaYdXY+dd
PbjaIRlT5XPn58Zya48muDvDuwskL5fSGnrUsl5dFDPm5TEyTteU5Hi53Ho2zHesu3HzAitD8Qhl
6TMWRmLGGsXmEcW7iCjEFKfPmxpP40uaCutGf8zM1+XHGgkOBRMJoruRd40EYtogQSiK+vNtOn8X
X3ijEKE6bepEeDETYf58qZPAdmVUkkQCxMkWIgiH17GYSoTOwaWFCMWpprgUpBHzlHiRQD+rkzuZ
qtxfjp/qRGi8Mmt/7ij4QDnRTGHi3OW3SgJ+zmESqFYssdO7PHfjgy1Ftyn95j+vyazkBQBXCuvc
uBAI5VogTwAwFm8Q+KoOf4lwB9BZO0poFFtsGGaG9ALgLpVbypnSSwwDaR1Go9hiwxA2Ct9pV6ay
AcBWzAnCky/9+xAzc2UV6eTA0h0zcyWdetA0vw7CzJeLaJiYmSs1AArFaGcjhvmS0IdXtz609Kwb
DYTBl+6zcVD8Hmkgtu10MHOlhaUUzU8zDIMvg3OlEh2NGXzpQQkP2YgZXMk2qs2ufgPcyE6xuMF+
bP22rPe29WqFGKfiMcuo7DwWp9B9npSNu/MYLZvGDR4LJK5mitHqPtdhmHnMQkorj3kNw+Cx4FpH
4bG4G49Rk5LKIke2qi/XKgh++mYFsW3TfYH7sG22yK6U8O4DheZDFtmrF2a+XIQjts0WeTHFtb24
RcZLLumPhBzQRtJeH5w6KTyhYNsTCrE1IsnLeBJXoaCqHr1ksMFoNcpnWcIuz+wwjx0+vVDnzVQE
09n4eVHK3rb2Whml6K/82MYVNSmtgPNlir6mtYIlVIaknt6QacSUWjxp+o3qHRvbSsDvg1tLKgNS
vlYYRu2oCiKtL1hezHV1+2LMqCdi+7FYEcXHlEfFbVOpUe2tuKs9OEwaD/itg7N97UGdMT14nb8d
GtVGxgOMXsdyVMQ6OY5xa78dJgzamTEf1VPGAyDgHarNPEur5VxHlyzi7oSwUYzC2i5zgSrr8RKv
+xbVS1CvEziqwHUnHHK/r1M6U23wW/sxVGp0rQQeuF62wqOvLDrWX+Z6jUv8VVnncb2nZ06rr0y3
6on0efMbLXdulTng49mizjG3jHkbe9iM1pKF+NvhDnu/kTDl4atxnxuVD+znWwKc9NJwEBTWHAdO
r093E3c7cnb/ToR1ZSn32o9hnufjT80ILvaD8T0b9Y7vwsbu7rtauznvf2uDfDCV2PLVxh7iwAdG
IUb16ZhTmL3au8wo5ynB5+Edr36aP78pVQq1eKetfuI/0TQ+KOt0vv10iCA+MXiFyQ==
	]]>
	<![CDATA[
	t4dnSr0u357fqLDf449fWm+e0Owb/Xnf6f/RH4mmwkxjLO8PkYq+FXtTHjKf26Wr3sdZ9fQ40jQ2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	]]>
</i:pgf>
  `
]
export const tVIconWindkraftRGB = [
  '283.46 283.46',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" [
	<!ENTITY ns_extend "http://ns.adobe.com/Extensibility/1.0/">
	<!ENTITY ns_ai "http://ns.adobe.com/AdobeIllustrator/10.0/">
	<!ENTITY ns_graphs "http://ns.adobe.com/Graphs/1.0/">
	<!ENTITY ns_vars "http://ns.adobe.com/Variables/1.0/">
	<!ENTITY ns_imrep "http://ns.adobe.com/ImageReplacement/1.0/">
	<!ENTITY ns_sfw "http://ns.adobe.com/SaveForWeb/1.0/">
	<!ENTITY ns_custom "http://ns.adobe.com/GenericCustomNamespace/1.0/">
	<!ENTITY ns_adobe_xpath "http://ns.adobe.com/XPath/1.0/">
]>
<style type="text/css">
	.tem-wind-styling{fill:inherit;}
</style>
<switch>
	<foreignObject requiredExtensions="&ns_ai;" x="0" y="0" width="1" height="1">
		<i:pgfRef  xlink:href="#adobe_illustrator_pgf">
		</i:pgfRef>
	</foreignObject>
	<g i:extraneous="self">
		<g>
			<path class="tem-wind-styling" d="M143.62,133.09l7.91-27.3l-14.5-9.32v36.12c-3.85,1.14-6.69,4.66-6.69,8.88c0,0.25,0.04,0.49,0.06,0.74
				l-27.59,6.8L102,166.22l31.25-18.04c1.2,1.14,2.69,1.98,4.36,2.36l-2.09,36.64h8.27l-2.09-36.64c1.14-0.26,2.19-0.74,3.12-1.37
				l19.32,20.13l15.32-7.89l-30.8-17.78c0.17-0.69,0.28-1.4,0.28-2.15C148.95,137.76,146.76,134.59,143.62,133.09L143.62,133.09z
				 M139.65,134.68c3.75,0,6.8,3.04,6.8,6.8c0,3.75-3.04,6.8-6.8,6.8c-3.75,0-6.8-3.04-6.8-6.8
				C132.85,137.72,135.9,134.68,139.65,134.68L139.65,134.68z"/>
			<path class="tem-wind-styling" d="M114.73,142.83h-2.5c0-12.12,7.27-22.87,18.52-27.38l0.93,2.32C121.38,121.9,114.73,131.74,114.73,142.83
				L114.73,142.83z"/>
			<path class="tem-wind-styling" d="M124.57,137.58l-2.39-0.74c1.31-4.22,4-8,7.58-10.62l1.48,2.02C128.08,130.54,125.71,133.86,124.57,137.58
				L124.57,137.58z"/>
			<path class="tem-wind-styling" d="M171.44,142.83h-2.5c0-11.09-6.65-20.93-16.95-25.06l0.93-2.32C164.17,119.96,171.44,130.71,171.44,142.83
				L171.44,142.83z"/>
			<path class="tem-wind-styling" d="M159.1,137.58c-1.15-3.71-3.52-7.03-6.67-9.34l1.48-2.02c3.58,2.63,6.28,6.4,7.58,10.62L159.1,137.58
				L159.1,137.58z"/>
		</g>
	</g>
</switch>
<i:pgf  id="adobe_illustrator_pgf">
	<![CDATA[
	eJzVfWd+Oruy4GyAPYBtbDDQdCY4Eo2zDU44YULbxsaAGzjpw1vNrGE2MBubkjo3HdTAeXfePb/r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==
	]]>
	<![CDATA[
	R5l7ju4Zb+laSyqForK8v9cpJMcXJ4enucl+trZ7T1VHj/xdRX5+pMuP1eZNda+w12W2C5mhioXb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==
	]]>
	<![CDATA[
	voSL3VHHe1fL6SdR+ID4XvPpwxv7yqA/b05r25Q3XluZs/dRswZ2nc660Z09VxB+4mEOgE3CfNS8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==
	]]>
	<![CDATA[
	STsoh0dX5aDU8N6SHGK6f/Q5d6Iifua+h6kl3s/fk+hQuGjjJ4UmRgxrf29skrmqyaaiilm12Bs1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==
	]]>
	<![CDATA[
	2MNkW4MzpV6Xbc3qKuy3+MOn1ptHNPtGf952el/6K95UmGmM5e0+UtK3YuvFAfWxXbjqvp+VT48j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=
	]]>
</i:pgf>
  `
]
export const trafo = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs15" />
<style
   type="text/css"
   id="style2">
	.st0{fill:#9DBF26;}
</style>
<switch
   id="switch10"
   transform="matrix(0.42477181,0,0,0.42477181,-35.043619,-40.256005)"
   style="fill:#87be22;fill-opacity:1">
	<g
   i:extraneous="self"
   id="g8"
   style="fill:#87be22;fill-opacity:1">
		<g
   id="g6"
   style="fill:#87be22;fill-opacity:1">
			<path
   class="st0"
   d="m 171.04,139.24 v -5.2 h 15.67 v -2.5 h -4.79 v -5.22 h -2.5 v 0.15 c -2.92,0.18 -5.72,0.22 -8.38,0.13 v -7.53 h -2.5 v 7.4 c -19.69,-1.28 -32.05,-9.43 -38.69,-15.56 v -1.97 h -2.02 c -1.19,-1.24 -2.11,-2.32 -2.78,-3.17 v -2.05 h -2.5 v 5.22 h -8.38 V 96.46 h -2.5 v 12.47 h -4.52 c -1.95,-1.84 -3.2,-3.36 -3.86,-4.22 v -0.99 h -2.5 v 5.22 H 96 v 2.5 h 12.11 c 1.05,0.89 2.23,1.83 3.56,2.79 v 2.41 H 96 v 2.5 h 15.67 v 45.51 h 2.5 v -45.51 h 5.59 c 8.3,4.22 20.38,8.11 37.89,8.43 v 3.97 h -4.79 v 2.5 h 15.67 v 5.2 h -15.67 v 2.5 h 15.67 v 45.51 h 2.5 v -45.51 h 15.67 v -2.5 z m -56.87,-23.32 c 0.22,0.14 0.42,0.28 0.65,0.42 0.16,0.1 0.33,0.2 0.49,0.3 h -1.14 z m -8.78,-6.98 h -2.1 v -2.25 c 0.55,0.63 1.25,1.4 2.1,2.25 z m 6.28,2.5 v 1.27 c -0.58,-0.43 -1.13,-0.85 -1.65,-1.27 z m 14.53,-2.5 h -1.15 v -1.27 c 0.35,0.39 0.73,0.81 1.15,1.27 z m 31.92,17.38 h -0.22 c -15.23,-0.26 -26.71,-3.36 -35.15,-7.18 h 7.1 v -2.5 h -12.06 c -1.3,-0.73 -2.5,-1.46 -3.61,-2.19 v -3.01 h 14.54 c 5.54,5.15 15.05,11.81 29.4,14.88 z m 10.42,5.22 h -8.38 v -4.82 c 2.64,0.48 5.44,0.83 8.38,1.05 z m 2.5,0 v -3.62 c 1.14,0.05 2.29,0.08 3.48,0.08 1.74,0 3.23,-0.1 4.9,-0.24 v 3.78 z"
   id="path4"
   style="fill:#87be22;fill-opacity:1" />
		</g>
	</g>
</switch>
  `
]
export const user = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs15" /></sodipodi:namedview>
<style
   type="text/css"
   id="style2">
	.tem-user-styling{fill:inherit;}
</style>
<polygon
   class="tem-user-styling"
   points="152.49,187.26 181.39,187.26 181.39,142.13 141.04,96.46 102,142.13 102,187.26 130.5,187.26 130.5,158.35 152.49,158.35 "
   id="polygon4"
   transform="matrix(0.42951542,0,0,0.42951542,-35.860187,-40.931057)" />
  `
]
export const wallbox = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs19" /></sodipodi:namedview>
<style
   type="text/css"
   id="style2">
	.tem-wallbox-styling{fill:inherit;}
</style>
<path
   class="tem-wallbox-styling"
   d="m 45.552443,17.088661 c -1.090471,-0.154402 -2.190591,-0.279855 -3.276237,-0.487334 -0.30398,-0.0579 -0.665862,-0.308805 -0.820265,-0.574185 -0.294331,-0.51146 -0.574186,-1.03257 -0.854041,-1.558505 -1.693607,2.007238 -4.221954,3.281062 -7.054283,3.281062 -5.10012,0 -9.230398,-4.130278 -9.230398,-9.2303983 -3.22316,0.024126 -6.43667,0.2702051 -9.64053,0.7720145 -1.775634,0.2750302 -3.150785,1.1724968 -4.028951,2.7696018 -0.6948131,1.268999 -1.4089264,2.528348 -2.0651388,3.816647 -0.2509047,0.492159 -0.5693606,0.718938 -1.1194209,0.772014 -1.0711701,0.110977 -2.1423402,0.279855 -3.2086852,0.448734 -0.960193,0.154403 -1.2352232,0.646562 -1.1145959,1.939686 0.062726,0.651387 0.3667068,0.863691 1.2641737,0.868516 0.588661,0.0048 1.172497,0 1.9589867,0 -1.5971049,1.500603 -2.2967431,3.20386 -2.344994,5.090471 -0.110977,4.395657 -0.1158021,8.791315 -0.1447527,13.186972 -0.00483,0.77684 0.5211098,1.288299 1.3124246,1.297949 1.915561,0.02413 3.8311219,0.02413 5.7466825,0 0.80579,-0.0097 1.3076,-0.554885 1.341375,-1.3655 0.0193,-0.458384 0.0048,-0.916767 0.0048,-1.466828 8.482509,0.51146 16.887816,0.50181 25.351025,0 0,0.405308 0,0.694813 0,0.984319 0,1.462002 0.405308,1.85766 1.896261,1.862485 1.597105,0 3.19421,0 4.786489,0 1.29795,0 1.727383,-0.424608 1.727383,-1.712907 0,-3.662244 0.01447,-7.319663 -0.0097,-10.981906 -0.0048,-0.854041 -0.09168,-1.717733 -0.221955,-2.562123 -0.250904,-1.60193 -0.902291,-3.034982 -2.209891,-4.328107 0.849216,0 1.505428,0.04343 2.147165,-0.0193 0.303981,-0.02895 0.704463,-0.178528 0.868517,-0.410133 0.661037,-0.921592 0.04825,-2.234017 -1.06152,-2.393245 z m -29.02292,14.648975 -1.172497,-0.27503 c 0.09168,-0.400482 0,-0.878166 -0.255729,-1.268999 C 14.864867,29.8269 14.517461,29.575996 14.150754,29.503619 12.370295,29.156213 10.541586,28.832932 8.7707778,28.519301 8.0470142,28.393848 7.3232506,28.263571 6.594662,28.133294 l 0.2123039,-1.186973 c 0.7285887,0.130278 1.4523523,0.260555 2.1712908,0.386008 1.7756333,0.31363 3.6091673,0.636912 5.3992763,0.989143 0.685163,0.135103 1.31725,0.579011 1.732207,1.215923 0.439084,0.670688 0.593487,1.476478 0.419783,2.200241 z m 26.92883,-3.604342 c -0.728588,0.130277 -1.452352,0.260554 -2.17129,0.386007 -1.770809,0.313631 -3.599518,0.636912 -5.379976,0.984318 -0.366707,0.07238 -0.714114,0.323281 -0.950543,0.689988 -0.25573,0.390833 -0.352232,0.868517 -0.25573,1.268999 l -1.172497,0.27503 c -0.168878,-0.723763 -0.01448,-1.529553 0.419783,-2.200241 0.414958,-0.636912 1.047045,-1.08082 1.732207,-1.215923 1.794934,-0.352231 3.628469,-0.675513 5.404102,-0.989143 0.718938,-0.125453 1.442702,-0.25573 2.166465,-0.386008 z"
   id="path4"
   style="stroke-width:0.482509" /><path
   class="tem-wallbox-styling"
   d="m 41.571743,8.5193007 c 0,-4.4294331 -3.589867,-8.0193004 -8.024126,-8.0193004 -4.429433,0 -8.024125,3.5898673 -8.024125,8.0193004 0,4.4294333 3.589867,8.0241253 8.024125,8.0241253 4.434259,0 8.024126,-3.594692 8.024126,-8.0241253 z m -1.201448,0 c 0,3.7635703 -3.049457,6.8178533 -6.817852,6.8178533 -3.768396,0 -6.817853,-3.049458 -6.817853,-6.8178533 0,-3.7635706 3.049457,-6.8178529 6.817853,-6.8178529 3.768395,0 6.817852,3.0542823 6.817852,6.8178529 z"
   id="path6"
   style="stroke-width:0.482509" /><polyline
   class="tem-wallbox-styling"
   points="164.3,116.16 156.41,129.94 158.43,120.38 153.83,120.38 157.51,106.24 162.47,106.24      159.9,116.16 164.3,116.16    "
   id="polyline8"
   transform="matrix(0.48250905,0,0,0.48250905,-43.200272,-48.460193)" />
  `
]
export const wallboxPlugged = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     id="g8086">
    <circle
       style="clip-rule:evenodd;fill:none;fill-rule:evenodd;stroke-width:0.048949;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       class="svg-dashboard-background"
       cx="5.036613"
       cy="24.807751"
       r="0.52538627"
       id="circle4298" />
    <g
       id="g12091"
       transform="matrix(0.06227178,0,0,0.06227178,0.09128791,-10.486419)"
       style="clip-rule:evenodd;fill:inherit;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision">
      <g
         id="g8448"
         transform="matrix(0.82963076,0,0,0.82963076,43.017454,-537.38326)">
        <g
           id="g1328"
           transform="matrix(4.3890375,0,0,4.3890375,-649.37502,0.03065548)">
          <g
             id="g1320">
            <path
               id="GridInput_Icon-3"
               style="clip-rule:evenodd;fill:inherit;stroke:none;fill-rule:nonzero;stroke-width:3;stroke-dasharray:none;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
               class="svg-dashboard-background"
               d="m 285.41207,234.61359 v 87.77953 h 57.55842 v -87.77953 z m 6.77931,6.77953 h 43.99999 v 78 h -43.99999 z m 16.62407,17.88694 c -0.36868,0 -0.60688,0.11947 -0.84543,0.23875 -0.23856,0.11928 -0.35769,0.35779 -0.47697,0.59634 l -5.63841,22.934 c -0.11927,0.48795 -2.4e-4,0.84562 0.3576,1.08417 0.24939,0.23856 0.48759,0.35812 0.84542,0.35812 h 0.35812 l 11.28768,-2.76521 -5.51904,22.45703 c -0.11928,0.2494 9e-5,0.60688 0.11937,0.84543 0.11927,0.23856 0.35789,0.3577 0.71572,0.47697 h 0.3576 c 0.60724,0 0.96498,-0.23861 1.20354,-0.71572 l 15.00787,-32.18304 c 0.11928,-0.36868 0.23847,-0.84572 -0.11937,-1.20355 h 0.0103 c -0.24939,-0.23856 -0.48759,-0.3576 -0.84542,-0.3576 h -0.35812 l -11.04945,2.76469 4.80384,-12.84934 c 0.11928,-0.11927 0.11937,-0.35821 0.11937,-0.47749 0,-0.36867 -0.11957,-0.60688 -0.35812,-0.84543 -0.24941,-0.23856 -0.48811,-0.35812 -0.84594,-0.35812 z"
               inkscape:original-d="m 285.41207,234.61359 v 87.77953 h 57.55842 v -87.77953 z m 6.77931,6.77953 h 43.99999 v 78 h -43.99999 z m 16.62407,17.88694 c -0.36868,0 -0.60688,0.11947 -0.84543,0.23875 -0.23856,0.11928 -0.35769,0.35779 -0.47697,0.59634 l -5.63841,22.934 c -0.11927,0.48795 -2.4e-4,0.84562 0.3576,1.08417 0.24939,0.23856 0.48759,0.35812 0.84542,0.35812 h 0.35812 l 11.28768,-2.76521 -5.51904,22.45703 c -0.11928,0.2494 9e-5,0.60688 0.11937,0.84543 0.11927,0.23856 0.35789,0.3577 0.71572,0.47697 h 0.3576 c 0.60724,0 0.96498,-0.23861 1.20354,-0.71572 l 15.00787,-32.18304 c 0.11928,-0.36868 0.23847,-0.84572 -0.11937,-1.20355 h 0.0103 c -0.24939,-0.23856 -0.48759,-0.3576 -0.84542,-0.3576 h -0.35812 l -11.04945,2.76469 4.80384,-12.84934 c 0.11928,-0.11927 0.11937,-0.35821 0.11937,-0.47749 0,-0.36867 -0.11957,-0.60688 -0.35812,-0.84543 -0.24941,-0.23856 -0.48811,-0.35812 -0.84594,-0.35812 z"
               sodipodi:nodetypes="ccccccccccsscccscccscsccccscccscss" />
            <path
               style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers"
               id="rect355"
               width="72.288063"
               height="7.02315"
               x="-350.33539"
               y="320.91077"
               transform="scale(-1,1)"
               d="m -350.33539,320.91077 h 72.28806 v 7.02315 h -72.28806 z"
               sodipodi:type="rect" />
          </g>
          <g
             id="g1367"
             transform="matrix(-1,0,0,1,369.85621,179.44072)">
            <path
               id="path2861"
               inkscape:transform-center-x="-0.48253742"
               inkscape:transform-center-y="-0.18569867"
               d="m 110.56432,109.98032 -2.25347,6.11067 c 1.95893,-3.0358 -0.97607,1.18496 0.28623,1.52728 0.40737,0.11041 0.52805,-2.10725 2.4009,-4.17713 1.79047,-1.9789 5.8793,-0.67311 6.0333,-1.19043 l 0.70657,-2.37366 c -1.15806,-0.11483 -4.20585,-0.92892 -6.66797,-1.82101 -0.45743,1.02934 -1.50174,4.67407 -2.24086,6.60622 z"
               style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:3.2667;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers"
               sodipodi:nodetypes="ccssscccc"
               inkscape:original-d="m 110.56432,109.98032 -2.25347,6.11067 c 1.95893,-3.0358 -0.97607,1.18496 0.28623,1.52728 0.40737,0.11041 0.52805,-2.10725 2.4009,-4.17713 1.79047,-1.9789 5.8793,-0.67311 6.0333,-1.19043 l 0.70657,-2.37366 c -1.15806,-0.11483 -4.20585,-0.92892 -6.66797,-1.82101 -0.45743,1.02934 -1.50174,4.67407 -2.24086,6.60622 z" />
            <path
               style="fill:none;stroke:inherit;stroke-width:2.5;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
               d="m 78.633311,127.53734 c 8.60448,0.11417 12.12384,7.02847 18.803605,6.39588 7.622214,-0.72184 10.840444,-16.14995 10.840444,-16.14995"
               id="path772"
               sodipodi:nodetypes="csc" />
          </g>
        </g>
      </g>
      <g
         id="g10370"
         transform="matrix(0.57550515,0,0,0.57550515,8.9079305,324.91701)">
        <path
           style="fill:none;stroke:inherit;stroke-width:30.2362;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
           d="M 144.72441,570.92913 H 69.133854 c 0,0 0.0403,-178.88889 0,-226.77165 -0.0454,-53.92715 34.015746,-90.70866 34.015746,-90.70866 0,0 -57.131136,-6.67226 -71.811016,-18.89764 -7.33994,-6.11269 -9.49298,-26.81335 0,-37.79528 9.49298,-10.98194 32.62709,-12.10485 56.69291,-11.33858 45.011886,1.4332 37.795276,34.53209 37.795276,34.53209 0,0 78.69,-167.487578 102.04724,-178.154138 38.06696,-17.38405 273.67577,-16.435 313.70079,0 39.09177,16.0518 102.04724,180.283468 102.04724,180.283468 0,0 -8.41313,-34.89097 37.79528,-36.66142 24.44337,-0.93653 49.84381,2.8128 56.69291,11.33858 9.38087,11.67733 7.76356,32.77177 0,37.79528 -12.51657,8.09901 -71.81102,18.89764 -71.81102,18.89764 0,0 34.42758,40.65681 34.01575,90.70866 -0.39003,47.40194 0,226.77165 0,226.77165 -25.54973,-0.0144 -39.23653,0.0632 -75.59055,0 -0.0132,-21.64458 -0.002,-60.13167 0,-75.59055 h 30.23622 -540.47245 30.23623 z"
           id="path7705"
           sodipodi:nodetypes="ccscszscsscssscsccccccc" />
        <path
           style="fill:none;stroke:inherit;stroke-width:30.2362;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
           d="m 281.23801,415.88947 207.07653,-0.33584"
           id="path7707" />
        <path
           style="fill:none;stroke:inherit;stroke-width:30.2362;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
           d="m 179.68538,226.99212 h 411.96851 c 0,0 -55.21954,-137.822528 -72.73944,-145.349498 -17.85734,-7.67194 -243.49246,-9.62677 -259.28843,0.65229 -14.30427,9.30835 -79.94064,144.697208 -79.94064,144.697208 z"
           id="path7713"
           sodipodi:nodetypes="ccssc" />
        <ellipse
           style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:34.2032;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:markers"
           id="path10013"
           cx="181.99602"
           cy="336.61871"
           rx="39.591309"
           ry="39.080318" />
        <ellipse
           style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:34.2032;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:markers"
           id="path10013-3"
           cx="579.00861"
           cy="336.61871"
           rx="39.591309"
           ry="39.080318" />
      </g>
    </g>
  </g>
  `
]
export const wallboxUnplugged = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     transform="matrix(0.07358277,0,0,0.07358277,9.9138551,0.99999877)"
     style="clip-rule:evenodd;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
     id="g5448">
    <circle
       style="clip-rule:evenodd;fill:none;fill-rule:evenodd;stroke-width:0.786055;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       class="svg-dashboard-background"
       cx="64.822495"
       cy="249.84024"
       r="8.4369879"
       id="circle4298" />
    <g
       id="g12704"
       transform="translate(-194.97722,-145.77635)">
      <g
         id="g10901"
         transform="matrix(5.6531358,0,0,5.6531358,-127.96311,-659.86111)">
        <path
           style="fill:none;stroke:inherit;stroke-width:2.74924;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
           d="m 68.361149,215.2975 c -7.86693,-0.0562 -7.80298,-10.06941 -7.80298,-10.06941 v -4.52493 -6.51003 c 0.0203,-4.32279 -0.0114,-5.91849 0,-7.91042 0,-1.10948 0,-5.26142 0,-3.32845 v -5.10828"
           id="path2847"
           sodipodi:nodetypes="ccccccc" />
        <path
           id="path2861"
           inkscape:transform-center-x="0.59666271"
           inkscape:transform-center-y="0.15996054"
           d="m 60.466619,170.47649 -0.41643,6.49961 c 1.0114,-3.46851 -0.59743,1.41419 0.71007,1.38214 0.42194,-0.0103 -0.0951,-2.17032 1.10937,-4.6885 1.15147,-2.40747 5.44291,-2.32251 5.44291,-2.86226 v -2.47659 c -1.14269,0.22034 -4.29607,0.30962 -6.91037,0.15706 -0.14475,1.11706 -0.10581,4.90825 -0.26296,6.97097 z"
           style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:3.2667;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers"
           sodipodi:nodetypes="ccssscccc"
           inkscape:original-d="m 60.466619,170.47649 -0.41643,6.49961 c 1.0114,-3.46851 -0.59743,1.41419 0.71007,1.38214 0.42194,-0.0103 -0.0951,-2.17032 1.10937,-4.6885 1.15147,-2.40747 5.44291,-2.32251 5.44291,-2.86226 v -2.47659 c -1.14269,0.22034 -4.29607,0.30962 -6.91037,0.15706 -0.14475,1.11706 -0.10581,4.90825 -0.26296,6.97097 z" />
      </g>
      <g
         id="g1320"
         transform="matrix(5.4463561,0,0,5.4463561,-1311.198,-1132.0128)">
        <path
           id="GridInput_Icon-3-5"
           style="clip-rule:evenodd;fill:inherit;stroke:none;fill-rule:nonzero;stroke-width:3;stroke-dasharray:none;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
           class="svg-dashboard-background"
           d="m 285.41207,234.61359 v 87.77953 h 57.55842 v -87.77953 z m 6.77931,6.77953 h 43.99999 v 78 h -43.99999 z m 16.62407,17.88694 c -0.36868,0 -0.60688,0.11947 -0.84543,0.23875 -0.23856,0.11928 -0.35769,0.35779 -0.47697,0.59634 l -5.63841,22.934 c -0.11927,0.48795 -2.4e-4,0.84562 0.3576,1.08417 0.24939,0.23856 0.48759,0.35812 0.84542,0.35812 h 0.35812 l 11.28768,-2.76521 -5.51904,22.45703 c -0.11928,0.2494 9e-5,0.60688 0.11937,0.84543 0.11927,0.23856 0.35789,0.3577 0.71572,0.47697 h 0.3576 c 0.60724,0 0.96498,-0.23861 1.20354,-0.71572 l 15.00787,-32.18304 c 0.11928,-0.36868 0.23847,-0.84572 -0.11937,-1.20355 h 0.0103 c -0.24939,-0.23856 -0.48759,-0.3576 -0.84542,-0.3576 h -0.35812 l -11.04945,2.76469 4.80384,-12.84934 c 0.11928,-0.11927 0.11937,-0.35821 0.11937,-0.47749 0,-0.36867 -0.11957,-0.60688 -0.35812,-0.84543 -0.24941,-0.23856 -0.48811,-0.35812 -0.84594,-0.35812 z"
           inkscape:original-d="m 285.41207,234.61359 v 87.77953 h 57.55842 v -87.77953 z m 6.77931,6.77953 h 43.99999 v 78 h -43.99999 z m 16.62407,17.88694 c -0.36868,0 -0.60688,0.11947 -0.84543,0.23875 -0.23856,0.11928 -0.35769,0.35779 -0.47697,0.59634 l -5.63841,22.934 c -0.11927,0.48795 -2.4e-4,0.84562 0.3576,1.08417 0.24939,0.23856 0.48759,0.35812 0.84542,0.35812 h 0.35812 l 11.28768,-2.76521 -5.51904,22.45703 c -0.11928,0.2494 9e-5,0.60688 0.11937,0.84543 0.11927,0.23856 0.35789,0.3577 0.71572,0.47697 h 0.3576 c 0.60724,0 0.96498,-0.23861 1.20354,-0.71572 l 15.00787,-32.18304 c 0.11928,-0.36868 0.23847,-0.84572 -0.11937,-1.20355 h 0.0103 c -0.24939,-0.23856 -0.48759,-0.3576 -0.84542,-0.3576 h -0.35812 l -11.04945,2.76469 4.80384,-12.84934 c 0.11928,-0.11927 0.11937,-0.35821 0.11937,-0.47749 0,-0.36867 -0.11957,-0.60688 -0.35812,-0.84543 -0.24941,-0.23856 -0.48811,-0.35812 -0.84594,-0.35812 z"
           sodipodi:nodetypes="ccccccccccsscccscccscsccccscccscss" />
        <path
           style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers"
           id="rect355-3"
           width="72.288063"
           height="7.02315"
           x="-350.33539"
           y="320.91077"
           transform="scale(-1,1)"
           d="m -350.33539,320.91077 h 72.28806 v 7.02315 h -72.28806 z"
           sodipodi:type="rect" />
      </g>
    </g>
  </g>
  `
]
export const wallboxWarning = [
  '50 40',
  `
  <defs
     id="defs8142" />
  
  <g
     transform="matrix(0.0613994,0,0,0.0613994,4.2236859,0.99999951)"
     inkscape:label="#GridInput_Icon"
     style="clip-rule:evenodd;fill:inherit;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
     id="g8139">
    <circle
       style="clip-rule:evenodd;fill:none;fill-rule:evenodd;stroke-width:0.786055;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       class="svg-dashboard-background"
       cx="64.822495"
       cy="249.84024"
       r="8.4369879"
       id="circle4298" />
    <g
       id="g12245"
       transform="translate(-76.12888,-43.305828)">
      <g
         id="g12024"
         transform="translate(159.65939,-2.6682392)">
        <g
           id="g10901"
           transform="matrix(5.653143,0,0,5.653143,-282.84318,-657.19362)">
          <path
             style="fill:none;stroke:inherit;stroke-width:2.74924;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
             d="m 68.361149,215.2975 c -7.86693,-0.0562 -7.80298,-10.06941 -7.80298,-10.06941 v -4.52493 -6.51003 c 0.0203,-4.32279 -0.0114,-5.91849 0,-7.91042 0,-1.10948 0,-5.26142 0,-3.32845 v -5.10828"
             id="path2847"
             sodipodi:nodetypes="ccccccc" />
          <path
             id="path2861"
             inkscape:transform-center-x="0.59666271"
             inkscape:transform-center-y="0.15996054"
             d="m 60.290124,173.23122 -0.06984,1.09012 c -0.09394,1.46618 0.0093,2.64896 0.0042,2.76181 -6.98e-4,0.0155 -0.0013,0.0309 -0.0019,0.0463 -0.02684,0.74027 0.73073,0.60248 0.800461,-0.19301 0.02455,-0.28004 0.0597,-0.59311 0.11693,-0.93151 0.225303,-1.33227 1.309146,-3.38175 2.506767,-3.9593 1.64111,-0.79142 3.66578,-0.86742 3.66578,-1.23816 v -1.39882 c 0,-0.59523 -0.476448,-0.99596 -1.069542,-0.94844 -0.759084,0.0608 -1.739125,0.0974 -2.78482,0.10306 -1.688275,0.009 -3.146039,1.29111 -3.181245,2.97905 -0.02116,1.01436 -0.04268,2.10238 -0.08515,3.02565 -0.02265,0.49239 -0.02626,0.49046 0.0062,-0.004 l 0.08763,-1.33349 a 0.00225803,0.00225803 3.7127985 0 1 0.0045,3e-4 z"
             style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:3.2667;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers"
             sodipodi:nodetypes="ccssscccc" />
        </g>
        <g
           id="g12016">
          <path
             id="GridInput_Icon-3-5"
             style="clip-rule:evenodd;fill:inherit;stroke:none;fill-rule:nonzero;stroke-width:16.3391;stroke-dasharray:none;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
             class="svg-dashboard-background"
             d="m 113.73047,148.44531 a 10.893816,10.893816 0 0 0 -10.89453,10.89258 V 626.52344 H 416.32032 V 274.35352 l -36.92188,0.0137 v 324.94727 a 10.871373,10.871373 0 0 1 -10.87109,10.87109 H 153.9375 A 14.178329,14.178329 0 0 1 139.75977,596.00586 V 196.25391 a 10.884481,10.884481 0 0 1 10.88281,-10.88477 h 162.53906 l 21.29883,-36.92383 z m 116.56836,134.3418 c -2.00796,0 -3.30429,0.65114 -4.60352,1.30078 -1.29927,0.64965 -1.94801,1.94882 -2.59765,3.24805 l -30.70899,124.90625 c -0.64959,2.65755 -10e-4,4.60507 1.94727,5.9043 1.35827,1.29929 2.65659,1.95117 4.60547,1.95117 h 1.94922 l 61.47656,-15.06055 -30.05859,122.3086 c -0.64965,1.35833 7.5e-4,3.30624 0.65039,4.60547 0.64959,1.29928 1.94957,1.94807 3.89843,2.59765 h 1.94727 c 3.30725,0 5.25541,-1.29992 6.55469,-3.89844 L 327.09766,355.3711 c 0.64964,-2.00796 1.29854,-4.60777 -0.65039,-6.55664 h 0.0566 c -1.35827,-1.29928 -2.65465,-1.94727 -4.60352,-1.94727 h -1.95117 l -60.17969,15.05859 26.16407,-69.98242 c 0.64963,-0.64959 0.65039,-1.95192 0.65039,-2.60156 0,-2.00792 -0.65195,-3.30429 -1.95118,-4.60352 -1.35836,-1.29929 -2.65855,-1.95117 -4.60742,-1.95117 z" />
          <path
             id="rect355-3"
             d="M 438.24177,618.45064 H 81.659726 A 18.934372,18.934372 0 0 0 62.72539,637.38498 19.584998,19.584998 0 0 0 82.575477,656.70127 H 437.45924 a 18.973133,18.973133 0 0 0 18.97317,-18.97317 v -1.08682 a 18.190641,18.190641 0 0 0 -18.19064,-18.19064 z"
             style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:16.3391;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers" />
        </g>
      </g>
      <g
         id="g11920"
         transform="translate(-85.44232,36.013631)">
        <path
           id="path7883"
           inkscape:transform-center-x="0.00019802826"
           inkscape:transform-center-y="-6.9424446"
           d="m 738.73212,222.50499 -191.37825,-0.003 c -21.69932,2.2e-4 -30.49446,-13.96844 -19.64461,-31.19942 L 623.40055,39.333193 c 10.84984,-17.230978 28.44064,-17.230763 39.29004,4.56e-4 l 95.68697,151.971901 c 10.8494,17.23123 2.05388,31.1997 -19.64544,31.19944 z"
           style="fill:none;stroke:#c2002d;stroke-width:38.2358;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:markers" />
        <g
           id="g11914">
          <path
             style="fill:none;stroke:#c2002d;stroke-width:30.2362;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
             d="M 643.04321,88.247788 V 140.33155"
             id="path8302"
             sodipodi:nodetypes="cc" />
          <circle
             id="path11832"
             style="fill:#c2002d;fill-opacity:1;stroke:#c2002d;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:normal"
             cx="643.04321"
             cy="178.65967"
             r="15.118108" />
        </g>
      </g>
    </g>
  </g>
  `
]
